var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 770,
    viewBox: "0 0 682 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_250987)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682,
    height: 770,
    fill: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_48_250987)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_48_250987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2257 31.0051L65.2232 31.0052C64.1346 31.0528 63.0348 31.1646 61.9439 31.3081L61.8788 30.8131L61.9439 31.3081C57.5793 31.8821 53.2905 33.0999 49.3816 35.1035C44.4774 37.6174 39.9197 41.786 38.9955 47.2974C38.8631 48.0868 38.8355 48.8988 38.8713 49.7158C38.9152 50.7183 39.0972 51.7301 39.4084 52.6848C39.8554 54.0562 40.5211 55.3341 41.3558 56.523L41.3558 56.523C42.4582 58.0934 43.8814 59.4916 45.4278 60.6515C48.8756 63.2373 52.8989 64.9673 57.0919 66.0156C62.4958 67.3666 68.1481 67.6411 73.6736 66.9537C76.1659 66.6435 78.6347 66.0925 81.028 65.3277L81.028 65.3276C82.5009 64.8572 83.9634 64.3208 85.327 63.6391C87.8034 62.4007 90.218 60.9891 92.1456 59.0624C93.4893 57.7192 94.6732 56.2824 95.5092 54.6147C96.0815 53.4728 96.4865 52.2718 96.7043 51.017L97.197 51.1026L96.7043 51.017C97.5005 46.4322 95.2135 41.8634 91.742 38.8184L91.742 38.8184C90.703 37.9067 89.6256 37.0658 88.4678 36.3327L88.7353 35.9103L88.4678 36.3327C85.4431 34.417 82.05 33.0906 78.5635 32.219C76.8465 31.7897 75.1004 31.4494 73.3512 31.262C71.8253 31.0985 70.3154 30.9871 68.7874 30.9496C68.3976 30.9401 68.0064 30.9362 67.614 30.9362C67.5173 30.9362 67.4406 30.9337 67.3747 30.9316C67.2623 30.9279 67.1814 30.9253 67.0863 30.9378L65.2257 31.0051ZM65.2257 31.0051L66.3537 30.9501C66.3541 30.95 66.3545 30.95 66.3549 30.95M65.2257 31.0051L66.3549 30.95M66.3549 30.95C66.4267 30.9469 66.497 30.9489 66.5869 30.9515C66.6113 30.9522 66.6371 30.9529 66.6648 30.9536C66.7836 30.9565 66.9319 30.9581 67.0862 30.9378L66.3549 30.95Z",
    stroke: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0845 33.2945C69.0783 33.3007 69.0928 33.2999 69.0935 33.2992C69.0997 33.293 69.0852 33.2938 69.0845 33.2945Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1534 33.2945C69.1472 33.3007 69.1617 33.2999 69.1624 33.2992C69.1686 33.293 69.1541 33.2938 69.1534 33.2945Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8917 33.3083C68.8855 33.3145 68.9 33.3137 68.9006 33.313C68.9068 33.3068 68.8924 33.3076 68.8917 33.3083Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9238 33.3038V33.3176H68.9652C68.948 33.3082 68.9438 33.3073 68.9238 33.3038Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4412 33.3589C67.9866 33.5031 67.5471 33.6072 67.1179 33.8266C66.8299 33.9737 66.5686 34.2112 66.2767 34.3378C66.2481 34.4295 66.0883 34.5046 66.0178 34.5705C65.8036 34.7706 65.5967 34.9818 65.4145 35.2121C64.9549 35.7941 64.5866 36.5092 64.4127 37.2325C63.9503 39.1547 64.4084 41.0171 64.9804 42.858C65.2641 43.771 65.5422 44.6861 65.8179 45.6016C65.9418 46.0131 66.0978 46.4234 66.194 46.8424C65.9696 46.8956 65.7468 47.0175 65.546 47.1276C64.686 47.6 63.9348 48.4949 64.2304 49.5308C64.2771 49.694 64.3476 49.856 64.4389 49.9996C64.9669 50.8306 65.9441 51.2924 66.8833 51.4803C67.1356 51.5307 67.3974 51.585 67.6554 51.585C67.7057 51.9257 67.8632 52.2751 67.9625 52.6053C68.1968 53.3828 68.4343 54.1597 68.6752 54.9352C69.0739 56.2184 69.4783 57.5028 69.8416 58.7955C69.9645 59.2331 70.0493 59.6867 70.1877 60.119C70.4165 60.8347 70.5585 61.7857 70.2313 62.4904C70.1185 62.7332 69.9317 63.0503 69.6682 63.1521C69.6562 63.2448 69.3908 63.3236 69.3098 63.3546C68.9796 63.4816 68.5774 63.5592 68.2344 63.4289C68.1589 63.4005 68.0505 63.4115 68 63.3451C67.7777 63.3355 67.5118 63.1325 67.3343 63.0117C66.8545 62.6853 66.4378 62.2832 65.9458 61.9728C65.7537 61.8515 65.4659 61.6835 65.2289 61.7045C65.1879 61.6578 65.0943 61.6768 65.0359 61.6769C64.8317 61.6773 64.6302 61.7552 64.4711 61.8824C64.0277 62.237 63.9045 62.8976 64.0712 63.4141C64.2964 64.112 64.9607 64.497 65.6011 64.7471C65.7655 64.8112 65.9412 64.8646 66.1112 64.9101C66.1859 64.9299 66.27 64.9213 66.3318 64.972C66.49 64.9634 66.6477 65.013 66.8046 65.0249C67.1551 65.0516 67.5294 65.0459 67.876 64.9815C68.257 64.9106 68.6708 64.795 69.0166 64.6166C69.2407 64.501 69.4633 64.3523 69.6958 64.2551L69.682 64.2275C69.8719 64.167 70.0391 63.9859 70.1921 63.8635C70.2475 63.8192 70.3303 63.7756 70.3438 63.7036C70.5265 63.6257 70.6306 63.408 70.785 63.29C70.8048 63.1787 70.9768 63.031 71.0452 62.9374C71.2289 62.686 71.3947 62.4118 71.5308 62.1319C71.9465 61.2771 72.155 60.2386 72.1152 59.286C72.0334 57.3231 71.3494 55.46 70.7708 53.5979L70.3021 52.0676C70.224 51.8163 70.0815 51.5164 70.0681 51.2542C70.3221 51.2104 70.5964 51.036 70.8125 50.9016C71.659 50.3746 72.3472 49.3848 71.8836 48.3727C71.4924 47.5183 70.6083 47.0066 69.7372 46.7517C69.4799 46.6766 69.2171 46.6168 68.9513 46.5804C68.8655 46.5687 68.6794 46.5815 68.6163 46.5175C68.5791 46.4795 68.5718 46.4088 68.556 46.3598L68.4312 45.96L68.008 44.5676C67.6922 43.4889 67.3545 42.4149 67.0208 41.3415C66.8547 40.8069 66.6727 40.2718 66.54 39.7284C66.2805 38.6648 65.796 37.5629 65.9281 36.4472C65.9844 35.9717 66.2253 35.3383 66.7179 35.1512L66.7041 35.1236C66.8692 35.0723 67.0203 34.9738 67.1866 34.9217C67.4923 34.8257 67.8072 34.8456 68.1131 34.9195C68.2416 34.9506 68.4302 34.9827 68.5239 35.0823C68.7078 35.0901 68.9343 35.2843 69.0794 35.3888C69.459 35.6621 69.809 35.9732 70.1883 36.2478C70.3469 36.3629 70.5964 36.5525 70.7987 36.5575C70.8551 36.6398 70.9864 36.6083 71.0607 36.6678C71.2849 36.6533 71.4712 36.6702 71.6811 36.5688C71.8793 36.473 72.0032 36.3019 72.1097 36.1186C72.5743 35.32 72.1847 34.4776 71.4822 33.976C70.9466 33.5937 70.1671 33.3615 69.5149 33.3213C69.256 33.3053 69.0023 33.3078 68.7445 33.3337C68.6616 33.342 68.5139 33.3988 68.4412 33.3589Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1582 33.3038V33.3176H69.1996C69.1823 33.3082 69.1782 33.3073 69.1582 33.3038Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2227 33.3083C69.2165 33.3145 69.231 33.3137 69.2317 33.313C69.2379 33.3068 69.2234 33.3076 69.2227 33.3083Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2544 33.3038V33.3176H69.2958C69.2785 33.3082 69.2744 33.3073 69.2544 33.3038Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3189 33.3083C69.3127 33.3145 69.3272 33.3137 69.3279 33.313C69.3341 33.3068 69.3196 33.3076 69.3189 33.3083Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3468 33.3083C69.3406 33.3145 69.355 33.3137 69.3557 33.313C69.3619 33.3068 69.3474 33.3076 69.3468 33.3083Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4571 33.3083C69.4509 33.3145 69.4654 33.3137 69.4661 33.313C69.4723 33.3068 69.4578 33.3076 69.4571 33.3083Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.795 33.3221C68.7888 33.3283 68.8033 33.3275 68.804 33.3268C68.8102 33.3206 68.7957 33.3214 68.795 33.3221Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.567 33.3221C69.5608 33.3283 69.5752 33.3275 69.5759 33.3268C69.5821 33.3206 69.5677 33.3214 69.567 33.3221Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6573 33.3359C68.6511 33.3421 68.6656 33.3413 68.6663 33.3406C68.6725 33.3344 68.658 33.3352 68.6573 33.3359Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6085 33.3359C69.6023 33.3421 69.6167 33.3413 69.6174 33.3406C69.6236 33.3344 69.6092 33.3352 69.6085 33.3359Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.65 33.3359C69.6438 33.3421 69.6583 33.3413 69.6589 33.3406C69.6651 33.3344 69.6507 33.3352 69.65 33.3359Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4366 33.3497C68.4304 33.3559 68.4449 33.3551 68.4456 33.3544C68.4518 33.3482 68.4373 33.349 68.4366 33.3497Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7188 33.3497C69.7126 33.3559 69.7271 33.3551 69.7278 33.3544C69.734 33.3482 69.7195 33.349 69.7188 33.3497Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8887 33.359V33.3728H69.9301C69.9128 33.3634 69.9087 33.3625 69.8887 33.359Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3262 33.3773C68.32 33.3835 68.3345 33.3827 68.3352 33.382C68.3414 33.3758 68.3269 33.3766 68.3262 33.3773Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2852 33.3911C68.279 33.3973 68.2935 33.3965 68.2942 33.3958C68.3004 33.3896 68.2859 33.3904 68.2852 33.3911Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9717 33.3865V33.4003H70.0268C70.006 33.3909 69.9949 33.3888 69.9717 33.3865Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0772 33.4049C70.071 33.4111 70.0855 33.4103 70.0862 33.4096C70.0924 33.4034 70.0779 33.4042 70.0772 33.4049Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1367 33.4141V33.4278H70.1781C70.1608 33.4185 70.1567 33.4175 70.1367 33.4141Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1967 33.4233C70.196 33.424 70.1953 33.4386 70.2016 33.4324C70.2022 33.4317 70.2029 33.4171 70.1967 33.4233Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2291 33.4325C70.2229 33.4387 70.2374 33.4379 70.238 33.4372C70.2442 33.431 70.2298 33.4318 70.2291 33.4325Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0367 33.4601C68.0305 33.4663 68.045 33.4654 68.0457 33.4648C68.0519 33.4585 68.0374 33.4594 68.0367 33.4601Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2471 33.4554V33.4692H70.2884C70.2712 33.4599 70.2671 33.4589 70.2471 33.4554Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3164 33.4692V33.483H70.3578C70.3405 33.4736 70.3364 33.4727 70.3164 33.4692Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8666 33.506C67.866 33.5067 67.8653 33.5214 67.8715 33.5151C67.8722 33.5145 67.8729 33.4998 67.8666 33.506Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.399 33.4968V33.5106H70.4403C70.4231 33.5012 70.4189 33.5003 70.399 33.4968Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4814 33.5106V33.5244H70.5228C70.5056 33.515 70.5014 33.5141 70.4814 33.5106Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7793 33.552C67.801 33.5426 67.8038 33.541 67.8207 33.5244C67.7989 33.5338 67.7962 33.5354 67.7793 33.552Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5186 33.5289C70.5124 33.5351 70.5269 33.5343 70.5276 33.5336C70.5338 33.5274 70.5193 33.5282 70.5186 33.5289Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.546 33.5427C70.5398 33.5489 70.5542 33.5481 70.5549 33.5474C70.5611 33.5412 70.5467 33.542 70.546 33.5427Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5645 33.5382V33.552H70.6058C70.5886 33.5426 70.5844 33.5417 70.5645 33.5382Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6012 33.5565C70.5949 33.5627 70.6094 33.5619 70.6101 33.5612C70.6163 33.555 70.6018 33.5558 70.6012 33.5565Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7158 33.5934V33.6072H70.7572C70.7399 33.5977 70.7358 33.5968 70.7158 33.5934Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7667 33.6255C70.7605 33.6317 70.775 33.6308 70.7756 33.6302C70.7818 33.624 70.7674 33.6248 70.7667 33.6255Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7895 33.6302C70.7888 33.6309 70.7881 33.6455 70.7943 33.6393C70.795 33.6386 70.7957 33.624 70.7895 33.6302Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.822 33.6393C70.8158 33.6455 70.8303 33.6446 70.831 33.644C70.8372 33.6377 70.8227 33.6386 70.822 33.6393Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8398 33.6484V33.6622H70.8812C70.864 33.6528 70.8598 33.6519 70.8398 33.6484Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8857 33.6577C70.885 33.6583 70.8843 33.673 70.8905 33.6668C70.8912 33.6661 70.8919 33.6515 70.8857 33.6577Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4072 33.6622V33.7036H67.421C67.4176 33.6836 67.4165 33.6795 67.4072 33.6622Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4303 33.6669C67.424 33.6731 67.4385 33.6722 67.4392 33.6715C67.4454 33.6653 67.4309 33.6662 67.4303 33.6669Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.955 33.6852C70.9543 33.6859 70.9536 33.7006 70.9599 33.6943C70.9605 33.6937 70.9612 33.679 70.955 33.6852Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0375 33.7266C71.0369 33.7273 71.0362 33.7419 71.0424 33.7357C71.0431 33.735 71.0437 33.7204 71.0375 33.7266Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1157 33.7588C71.1233 33.7814 71.1207 33.7788 71.1433 33.7864V33.7588H71.1157Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2769 33.8461C71.2707 33.8523 71.2852 33.8514 71.2859 33.8507C71.2921 33.8445 71.2776 33.8454 71.2769 33.8461Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3321 33.8736C71.3259 33.8798 71.3404 33.879 71.3411 33.8783C71.3473 33.8721 71.3328 33.8729 71.3321 33.8736Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9565 33.9058C66.9558 33.9065 66.9551 33.9211 66.9613 33.9149C66.962 33.9142 66.9627 33.8996 66.9565 33.9058Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3873 33.915C71.3811 33.9212 71.3956 33.9204 71.3962 33.9197C71.4024 33.9135 71.388 33.9143 71.3873 33.915Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4511 33.9472C71.4504 33.9479 71.4497 33.9625 71.4559 33.9563C71.4566 33.9556 71.4573 33.941 71.4511 33.9472Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8188 33.9748C66.8181 33.9755 66.8174 33.9901 66.8236 33.9839C66.8243 33.9832 66.825 33.9686 66.8188 33.9748Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5063 33.9886C71.5056 33.9893 71.5049 34.0039 71.5111 33.9977C71.5118 33.997 71.5125 33.9824 71.5063 33.9886Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7271 34.0252C66.7209 34.0315 66.7354 34.0306 66.7361 34.0299C66.7423 34.0237 66.7278 34.0246 66.7271 34.0252Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5615 34.03C71.5608 34.0307 71.5601 34.0453 71.5663 34.0391C71.567 34.0384 71.5677 34.0238 71.5615 34.03Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5801 34.1172V34.131H66.6214C66.6042 34.1215 66.6001 34.1206 66.5801 34.1172Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7042 34.1494C71.698 34.1556 71.7125 34.1548 71.7131 34.1541C71.7193 34.1479 71.7049 34.1487 71.7042 34.1494Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7594 34.1907C71.7532 34.1969 71.7676 34.196 71.7683 34.1953C71.7745 34.1891 71.76 34.19 71.7594 34.1907Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8009 34.232C71.7947 34.2382 71.8091 34.2374 71.8098 34.2367C71.816 34.2305 71.8015 34.2313 71.8009 34.232Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3824 34.2596C66.3762 34.2658 66.3907 34.265 66.3914 34.2643C66.3976 34.2581 66.3831 34.2589 66.3824 34.2596Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8373 34.2643C71.8367 34.265 71.836 34.2797 71.8422 34.2734C71.8429 34.2728 71.8436 34.2581 71.8373 34.2643Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8784 34.3057C71.8777 34.3064 71.877 34.321 71.8832 34.3148C71.8839 34.3141 71.8846 34.2995 71.8784 34.3057Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9477 34.3884C71.947 34.3891 71.9463 34.4037 71.9525 34.3975C71.9532 34.3968 71.9539 34.3822 71.9477 34.3884Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2124 34.4022C66.2117 34.4029 66.211 34.4175 66.2172 34.4113C66.2179 34.4106 66.2186 34.396 66.2124 34.4022Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9801 34.4388C71.9739 34.445 71.9883 34.4442 71.989 34.4435C71.9952 34.4373 71.9807 34.4381 71.9801 34.4388Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1435 34.4573C66.1428 34.458 66.1421 34.4726 66.1483 34.4664C66.149 34.4658 66.1497 34.4511 66.1435 34.4573Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1293 34.4711C66.1287 34.4718 66.128 34.4864 66.1342 34.4802C66.1349 34.4795 66.1355 34.4649 66.1293 34.4711Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0929 34.494C66.0866 34.5002 66.1011 34.4994 66.1018 34.4987C66.108 34.4925 66.0935 34.4934 66.0929 34.494Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0283 34.5309V34.5447H66.0697C66.0524 34.5353 66.0483 34.5343 66.0283 34.5309Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0672 34.5447V34.586H72.081C72.0775 34.566 72.0765 34.5619 72.0672 34.5447ZM66.0103 34.563C66.0041 34.5692 66.0186 34.5684 66.0193 34.5677C66.0255 34.5615 66.011 34.5623 66.0103 34.563Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1269 34.6503C72.1262 34.651 72.1255 34.6656 72.1317 34.6594C72.1324 34.6587 72.1331 34.6441 72.1269 34.6503Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8907 34.6687L65.877 34.6963H65.9045C65.9045 34.6708 65.9087 34.6777 65.8907 34.6687Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8448 34.7284C65.8386 34.7346 65.8531 34.7338 65.8538 34.7331C65.86 34.7269 65.8455 34.7277 65.8448 34.7284Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7388 34.8065V34.8479H65.7526C65.7491 34.8279 65.7481 34.8238 65.7388 34.8065Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2094 34.8295C72.2087 34.8302 72.208 34.8448 72.2142 34.8386C72.2149 34.8379 72.2156 34.8233 72.2094 34.8295Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5728 34.8479V34.8755C67.5953 34.868 67.5929 34.8704 67.6003 34.8479H67.5728Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6279 34.8479C67.6355 34.8705 67.6329 34.8679 67.6555 34.8755C67.6479 34.8529 67.6505 34.8555 67.6279 34.8479Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4303 34.8663C67.424 34.8725 67.4385 34.8717 67.4392 34.871C67.4454 34.8648 67.4309 34.8656 67.4303 34.8663Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6783 34.8663C67.6721 34.8725 67.6866 34.8717 67.6873 34.871C67.6935 34.8648 67.679 34.8656 67.6783 34.8663Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7335 34.8663C67.7273 34.8725 67.7417 34.8717 67.7424 34.871C67.7486 34.8648 67.7342 34.8656 67.7335 34.8663Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7613 34.8663C67.7551 34.8725 67.7696 34.8717 67.7703 34.871C67.7765 34.8648 67.762 34.8656 67.7613 34.8663Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7887 34.8663C67.7824 34.8725 67.7969 34.8717 67.7976 34.871C67.8038 34.8648 67.7893 34.8656 67.7887 34.8663Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8208 34.8617V34.8755H67.8622C67.8449 34.8661 67.8408 34.8651 67.8208 34.8617Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3614 34.8801C67.3552 34.8863 67.3697 34.8855 67.3704 34.8848C67.3766 34.8786 67.3621 34.8794 67.3614 34.8801Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8575 34.8801C67.8513 34.8863 67.8658 34.8855 67.8665 34.8848C67.8727 34.8786 67.8582 34.8794 67.8575 34.8801Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8896 34.8755V34.8893H67.9862C67.9541 34.8758 67.9246 34.8758 67.8896 34.8755Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0043 34.8847C68.0037 34.8854 68.003 34.9 68.0092 34.8938C68.0099 34.8931 68.0105 34.8785 68.0043 34.8847Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6793 34.8938C65.6731 34.9 65.6875 34.8992 65.6882 34.8985C65.6944 34.8923 65.68 34.8931 65.6793 34.8938Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2232 34.9076C67.217 34.9138 67.2315 34.913 67.2322 34.9123C67.2384 34.9061 67.2239 34.9069 67.2232 34.9076Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2647 34.9076C67.2585 34.9138 67.273 34.913 67.2737 34.9123C67.2799 34.9061 67.2654 34.9069 67.2647 34.9076Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0509 34.9076C68.0447 34.9138 68.0591 34.913 68.0598 34.9123C68.066 34.9061 68.0515 34.9069 68.0509 34.9076Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.106 34.9214C68.0998 34.9276 68.1143 34.9267 68.115 34.9261C68.1212 34.9199 68.1067 34.9207 68.106 34.9214Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6378 34.9352C65.6316 34.9414 65.646 34.9406 65.6467 34.9399C65.6529 34.9337 65.6385 34.9345 65.6378 34.9352Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1377 34.9307V34.9445H68.1791C68.1618 34.9351 68.1577 34.9341 68.1377 34.9307Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0947 34.9537C67.094 34.9544 67.0933 34.969 67.0995 34.9628C67.1002 34.9621 67.1009 34.9475 67.0947 34.9537Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2159 34.949C68.2097 34.9552 68.2242 34.9543 68.2249 34.9536C68.2311 34.9474 68.2166 34.9483 68.2159 34.949Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2529 34.9537C68.2522 34.9544 68.2515 34.969 68.2577 34.9628C68.2584 34.9621 68.2591 34.9475 68.2529 34.9537Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6012 34.972L65.5874 34.9996C65.6048 34.9862 65.6065 34.9901 65.6012 34.972Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3076 34.9813C68.3069 34.982 68.3062 34.9966 68.3124 34.9904C68.3131 34.9897 68.3138 34.9751 68.3076 34.9813Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5009 35.0502C68.5002 35.0509 68.4995 35.0655 68.5058 35.0593C68.5064 35.0586 68.5071 35.044 68.5009 35.0502Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8188 35.0777C66.8181 35.0784 66.8174 35.093 66.8236 35.0868C66.8243 35.0861 66.825 35.0715 66.8188 35.0777Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5606 35.0869C68.5544 35.0931 68.5689 35.0923 68.5696 35.0916C68.5758 35.0854 68.5613 35.0862 68.5606 35.0869Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5791 35.0961V35.1099H68.6205C68.6032 35.1005 68.5991 35.0995 68.5791 35.0961Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6523 35.1191C68.6516 35.1198 68.6509 35.1344 68.6571 35.1282C68.6578 35.1275 68.6585 35.1129 68.6523 35.1191Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7127 35.1557C68.7065 35.1619 68.7209 35.1611 68.7216 35.1604C68.7278 35.1542 68.7134 35.1551 68.7127 35.1557ZM65.4404 35.1742C65.4397 35.1749 65.439 35.1895 65.4452 35.1833C65.4459 35.1826 65.4466 35.168 65.4404 35.1742Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6123 35.2018C66.6116 35.2025 66.6109 35.2172 66.6171 35.2109C66.6178 35.2103 66.6185 35.1956 66.6123 35.2018Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7677 35.1971C68.7615 35.2033 68.7759 35.2025 68.7766 35.2018C68.7828 35.1956 68.7684 35.1964 68.7677 35.1971ZM65.3989 35.2156C65.3982 35.2163 65.3975 35.2309 65.4037 35.2247C65.4044 35.224 65.4051 35.2094 65.3989 35.2156Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8228 35.2247C68.8166 35.2309 68.8311 35.2301 68.8318 35.2294C68.838 35.2232 68.8235 35.224 68.8228 35.2247Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.371 35.257C65.3704 35.2577 65.3697 35.2723 65.3759 35.2661C65.3766 35.2654 65.3772 35.2508 65.371 35.257Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3153 35.2615V35.3028H72.3291C72.3257 35.2828 72.3246 35.2787 72.3153 35.2615Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9697 35.3121C68.969 35.3128 68.9683 35.3274 68.9745 35.3212C68.9752 35.3205 68.9759 35.3059 68.9697 35.3121Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.33 35.3259C65.3293 35.3266 65.3286 35.3412 65.3349 35.335C65.3355 35.3343 65.3362 35.3197 65.33 35.3259Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3159 35.3397C65.3152 35.3404 65.3145 35.355 65.3207 35.3488C65.3214 35.3481 65.3221 35.3335 65.3159 35.3397Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2794 35.3764C65.2732 35.3826 65.2876 35.3818 65.2883 35.3811C65.2945 35.3749 65.2801 35.3757 65.2794 35.3764Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3334 35.381C72.3328 35.3817 72.3321 35.3964 72.3383 35.3901C72.339 35.3895 72.3396 35.3748 72.3334 35.381Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2749 35.3948C65.2742 35.3955 65.2735 35.4101 65.2797 35.4039C65.2804 35.4033 65.2811 35.3886 65.2749 35.3948Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.373 35.3856V35.427H66.3868C66.3834 35.407 66.3825 35.4029 66.373 35.3856Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0709 35.3901C69.0647 35.3963 69.0792 35.3955 69.0798 35.3948C69.086 35.3886 69.0716 35.3894 69.0709 35.3901Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.121 35.4224C69.1204 35.4231 69.1197 35.4377 69.1259 35.4315C69.1266 35.4308 69.1272 35.4162 69.121 35.4224Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3334 35.45C72.3328 35.4507 72.3321 35.4653 72.3383 35.4591C72.339 35.4584 72.3396 35.4438 72.3334 35.45Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1812 35.4591C69.175 35.4653 69.1895 35.4645 69.1902 35.4638C69.1964 35.4576 69.1819 35.4584 69.1812 35.4591Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2086 35.4729C69.2024 35.4791 69.2169 35.4783 69.2176 35.4776C69.2238 35.4714 69.2093 35.4722 69.2086 35.4729Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.206 35.4914C65.2053 35.4921 65.2046 35.5067 65.2108 35.5005C65.2115 35.4998 65.2122 35.4852 65.206 35.4914Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3334 35.4914C72.3328 35.4921 72.3321 35.5067 72.3383 35.5005C72.339 35.4998 72.3396 35.4852 72.3334 35.4914Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2315 35.5051C69.2308 35.5058 69.2301 35.5204 69.2363 35.5142C69.237 35.5135 69.2377 35.4989 69.2315 35.5051Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3198 35.5052C72.3191 35.5059 72.3184 35.5205 72.3246 35.5143C72.3253 35.5136 72.326 35.499 72.3198 35.5052Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2857 35.5143C66.2795 35.5205 66.294 35.5196 66.2947 35.519C66.3009 35.5127 66.2864 35.5136 66.2857 35.5143Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3198 35.5327C72.3191 35.5333 72.3184 35.548 72.3246 35.5418C72.3253 35.5411 72.326 35.5265 72.3198 35.5327Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2866 35.5465C69.2859 35.5471 69.2852 35.5618 69.2914 35.5556C69.2921 35.5549 69.2928 35.5402 69.2866 35.5465Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3013 35.5786V35.62H72.3151C72.3116 35.6 72.3107 35.5958 72.3013 35.5786Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.123 35.6154C65.1223 35.6161 65.1216 35.6307 65.1278 35.6245C65.1285 35.6238 65.1292 35.6092 65.123 35.6154Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3832 35.6292C69.3826 35.6299 69.3819 35.6445 69.3881 35.6383C69.3888 35.6376 69.3895 35.623 69.3832 35.6292Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0957 35.643C65.095 35.6437 65.0943 35.6583 65.1005 35.6521C65.1012 35.6514 65.1019 35.6368 65.0957 35.643Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3061 35.643C72.3054 35.6437 72.3047 35.6583 72.3109 35.6521C72.3116 35.6514 72.3123 35.6368 72.3061 35.643Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4336 35.6476V35.6889H69.4474C69.4439 35.669 69.4431 35.6648 69.4336 35.6476Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2919 35.6706C72.2913 35.6713 72.2906 35.6859 72.2968 35.6797C72.2975 35.679 72.2981 35.6644 72.2919 35.6706Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0865 35.6797C65.0803 35.6859 65.0948 35.685 65.0955 35.6844C65.1017 35.6782 65.0872 35.679 65.0865 35.6797Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1572 35.6982C66.1565 35.6989 66.1558 35.7135 66.162 35.7073C66.1627 35.7066 66.1634 35.692 66.1572 35.6982Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.045 35.7348C65.0388 35.741 65.0533 35.7402 65.054 35.7395C65.0602 35.7333 65.0457 35.7342 65.045 35.7348Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5123 35.7348C69.5061 35.741 69.5206 35.7402 69.5212 35.7395C69.5274 35.7333 69.513 35.7342 69.5123 35.7348Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1293 35.7534C66.1287 35.7541 66.128 35.7687 66.1342 35.7625C66.1349 35.7618 66.1355 35.7472 66.1293 35.7534Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2645 35.7533C72.2638 35.7539 72.2632 35.7686 72.2694 35.7624C72.27 35.7617 72.2707 35.7471 72.2645 35.7533Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5581 35.7716V35.7854H69.5995C69.5822 35.776 69.5781 35.7751 69.5581 35.7716ZM65.004 35.7899C64.9978 35.7961 65.0123 35.7953 65.0129 35.7946C65.0191 35.7884 65.0047 35.7893 65.004 35.7899Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2554 35.79C72.2492 35.7962 72.2637 35.7954 72.2644 35.7947C72.2706 35.7885 72.2561 35.7893 72.2554 35.79Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6221 35.8175C69.6159 35.8237 69.6304 35.8229 69.6311 35.8222C69.6373 35.816 69.6228 35.8168 69.6221 35.8175Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9805 35.8268V35.8681H64.9943C64.9908 35.8482 64.9898 35.844 64.9805 35.8268Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6363 35.8313C69.6301 35.8375 69.6446 35.8367 69.6453 35.836C69.6515 35.8298 69.637 35.8306 69.6363 35.8313Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0883 35.8498C66.0876 35.8505 66.0869 35.8651 66.0932 35.8589C66.0938 35.8582 66.0945 35.8436 66.0883 35.8498Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6637 35.8589C69.6574 35.8651 69.6719 35.8642 69.6726 35.8636C69.6788 35.8574 69.6643 35.8582 69.6637 35.8589Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6819 35.8682C69.6895 35.8908 69.6869 35.8883 69.7094 35.8957C69.702 35.8733 69.7043 35.8756 69.6819 35.8682Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2232 35.8774C72.2225 35.8781 72.2219 35.8927 72.2281 35.8865C72.2287 35.8858 72.2294 35.8712 72.2232 35.8774Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9438 35.905C64.9431 35.9057 64.9424 35.9203 64.9486 35.9141C64.9493 35.9134 64.95 35.8988 64.9438 35.905Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0605 35.905C66.0598 35.9057 66.0591 35.9203 66.0653 35.9141C66.066 35.9134 66.0667 35.8988 66.0605 35.905Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7188 35.9003C69.7126 35.9065 69.7271 35.9056 69.7278 35.9049C69.734 35.8987 69.7195 35.8996 69.7188 35.9003Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.769 35.9464C69.7683 35.947 69.7676 35.9617 69.7738 35.9555C69.7745 35.9548 69.7752 35.9402 69.769 35.9464Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1957 35.9464C72.1951 35.947 72.1944 35.9617 72.2006 35.9555C72.2013 35.9548 72.202 35.9402 72.1957 35.9464Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0332 35.9877C66.0325 35.9884 66.0318 36.003 66.038 35.9968C66.0387 35.9961 66.0394 35.9815 66.0332 35.9877Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1821 35.9877C72.1814 35.9884 72.1807 36.003 72.1869 35.9968C72.1876 35.9961 72.1883 35.9815 72.1821 35.9877Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8936 35.9968C64.8874 36.003 64.9019 36.0022 64.9026 36.0015C64.9088 35.9953 64.8943 35.9961 64.8936 35.9968Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.024 36.0106C66.0178 36.0168 66.0323 36.016 66.033 36.0153C66.0392 36.0091 66.0247 36.0099 66.024 36.0106Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8886 36.029C64.8879 36.0297 64.8872 36.0443 64.8934 36.0381C64.8941 36.0374 64.8948 36.0228 64.8886 36.029Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1593 36.0382C72.1531 36.0444 72.1675 36.0436 72.1682 36.0429C72.1744 36.0367 72.1599 36.0375 72.1593 36.0382Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8564 36.0474V36.0749C64.8788 36.0675 64.8764 36.07 64.884 36.0474H64.8564Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.976 36.098C69.9753 36.0987 69.9746 36.1133 69.9808 36.1071C69.9815 36.1064 69.9822 36.0918 69.976 36.098Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8334 36.1118C64.8328 36.1124 64.8321 36.1271 64.8383 36.1209C64.839 36.1202 64.8396 36.1056 64.8334 36.1118Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0312 36.1393C70.0305 36.14 70.0298 36.1547 70.036 36.1484C70.0367 36.1478 70.0374 36.1331 70.0312 36.1393Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0854 36.1531C72.0847 36.1538 72.084 36.1684 72.0902 36.1622C72.0909 36.1616 72.0916 36.1469 72.0854 36.1531Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9638 36.2082C65.9631 36.2089 65.9624 36.2235 65.9686 36.2173C65.9693 36.2166 65.97 36.202 65.9638 36.2082Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 36.2221C70.1409 36.2228 70.1402 36.2374 70.1464 36.2312C70.1471 36.2305 70.1478 36.2159 70.1415 36.2221Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0439 36.2358C72.0432 36.2365 72.0425 36.2511 72.0487 36.2449C72.0494 36.2442 72.0501 36.2296 72.0439 36.2358Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1966 36.2496C70.1959 36.2503 70.1952 36.2649 70.2014 36.2587C70.2021 36.258 70.2028 36.2434 70.1966 36.2496ZM64.7646 36.2634C64.7639 36.2641 64.7632 36.2787 64.7694 36.2725C64.7701 36.2718 64.7708 36.2572 64.7646 36.2634Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9458 36.2542V36.2955H65.9596C65.9561 36.2755 65.9553 36.2714 65.9458 36.2542Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2377 36.291C70.2371 36.2916 70.2364 36.3063 70.2426 36.3001C70.2433 36.2994 70.2439 36.2848 70.2377 36.291Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9501 36.3048C65.9495 36.3054 65.9488 36.3201 65.955 36.3139C65.9557 36.3132 65.9563 36.2985 65.9501 36.3048Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9614 36.3323C71.9607 36.333 71.96 36.3476 71.9662 36.3414C71.9669 36.3408 71.9676 36.3261 71.9614 36.3323Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 36.3461C65.9358 36.3468 65.9351 36.3614 65.9413 36.3552C65.942 36.3545 65.9427 36.3399 65.9365 36.3461Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3253 36.3414C70.3191 36.3476 70.3335 36.3468 70.3342 36.3461C70.3404 36.3399 70.326 36.3407 70.3253 36.3414Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7144 36.3552C64.7082 36.3614 64.7227 36.3606 64.7234 36.3599C64.7296 36.3537 64.7151 36.3545 64.7144 36.3552Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9321 36.3783V36.4197H65.9459C65.9425 36.3997 65.9414 36.3955 65.9321 36.3783Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6914 36.3921V36.4335H64.7052C64.7017 36.4135 64.7007 36.4093 64.6914 36.3921Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9249 36.3966C71.9187 36.4028 71.9332 36.402 71.9338 36.4013C71.94 36.3951 71.9256 36.3959 71.9249 36.3966Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4448 36.4151C70.4441 36.4158 70.4434 36.4304 70.4496 36.4242C70.4503 36.4235 70.451 36.4089 70.4448 36.4151Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 36.4427C65.9358 36.4434 65.9351 36.4579 65.9413 36.4517C65.942 36.451 65.9427 36.4365 65.9365 36.4427Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4999 36.4427C70.4993 36.4434 70.4986 36.4579 70.5048 36.4517C70.5055 36.451 70.5062 36.4365 70.4999 36.4427Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5093 36.4471V36.4609H70.5506C70.5334 36.4515 70.5293 36.4506 70.5093 36.4471Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8419 36.4654C71.8357 36.4716 71.8501 36.4709 71.8508 36.4702C71.857 36.464 71.8426 36.4647 71.8419 36.4654Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9228 36.484C65.9221 36.4847 65.9214 36.4992 65.9276 36.493C65.9283 36.4923 65.929 36.4778 65.9228 36.484Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 36.4979C65.9358 36.4986 65.9351 36.513 65.9413 36.5068C65.942 36.5062 65.9427 36.4917 65.9365 36.4979Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6451 36.5068C64.6389 36.513 64.6534 36.5123 64.6541 36.5116C64.6603 36.5054 64.6458 36.5061 64.6451 36.5068Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.918 36.5023V36.5437H65.9318C65.9283 36.5237 65.9273 36.5196 65.918 36.5023Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6148 36.5068C70.6086 36.513 70.6231 36.5123 70.6238 36.5116C70.63 36.5054 70.6155 36.5061 70.6148 36.5068Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6513 36.5255C70.6506 36.5262 70.6499 36.5406 70.6561 36.5344C70.6568 36.5337 70.6575 36.5193 70.6513 36.5255Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7115 36.5482C70.7053 36.5544 70.7198 36.5537 70.7205 36.553C70.7267 36.5468 70.7122 36.5475 70.7115 36.5482Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.748 36.5531C70.7473 36.5537 70.7466 36.5682 70.7528 36.562C70.7535 36.5613 70.7542 36.5469 70.748 36.5531Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6763 36.5758C71.6701 36.582 71.6846 36.5813 71.6853 36.5806C71.6915 36.5744 71.677 36.5751 71.6763 36.5758Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8082 36.5895C70.802 36.5958 70.8165 36.5951 70.8171 36.5944C70.8233 36.5882 70.8089 36.5889 70.8082 36.5895ZM71.6216 36.5895C71.6154 36.5958 71.6299 36.5951 71.6306 36.5944C71.6368 36.5882 71.6223 36.5889 71.6216 36.5895Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.6081C65.9084 36.6088 65.9077 36.6233 65.914 36.6171C65.9146 36.6164 65.9153 36.6019 65.9091 36.6081Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8262 36.5989V36.6127H70.8675C70.8503 36.6034 70.8462 36.6023 70.8262 36.5989Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6127 36.6219C64.6121 36.6226 64.6114 36.6371 64.6176 36.6309C64.6183 36.6302 64.6189 36.6157 64.6127 36.6219Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9092 36.6127V36.6265L70.9505 36.6402C70.9371 36.6158 70.938 36.6184 70.9092 36.6127Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.6357C65.9084 36.6364 65.9077 36.6509 65.914 36.6447C65.9146 36.644 65.9153 36.6295 65.9091 36.6357Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9917 36.6403V36.654H71.0331C71.0158 36.6447 71.0117 36.6437 70.9917 36.6403Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0332 36.6403C71.0408 36.6628 71.0382 36.6602 71.0608 36.6678C71.0534 36.6454 71.0558 36.6478 71.0332 36.6403Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4561 36.6447C71.4499 36.6509 71.4644 36.6502 71.4651 36.6495C71.4713 36.6433 71.4568 36.644 71.4561 36.6447Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5854 36.6633C64.5847 36.664 64.584 36.6784 64.5902 36.6722C64.5909 36.6716 64.5916 36.6571 64.5854 36.6633Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4698 36.6585C71.4636 36.6647 71.4781 36.664 71.4788 36.6633C71.485 36.6571 71.4705 36.6578 71.4698 36.6585Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0884 36.6677V36.6815H71.1297C71.1125 36.6722 71.1084 36.6712 71.0884 36.6677Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1529 36.6723C71.1467 36.6785 71.1612 36.6778 71.1619 36.6771C71.1681 36.6709 71.1536 36.6716 71.1529 36.6723Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1846 36.6677V36.6815H71.2259C71.2087 36.6722 71.2046 36.6712 71.1846 36.6677Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2769 36.6723C71.2707 36.6785 71.2852 36.6778 71.2859 36.6771C71.2921 36.6709 71.2776 36.6716 71.2769 36.6723Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3321 36.6723C71.3259 36.6785 71.3404 36.6778 71.3411 36.6771C71.3473 36.6709 71.3328 36.6716 71.3321 36.6723Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5762 36.6998C64.57 36.706 64.5845 36.7053 64.5852 36.7046C64.5914 36.6984 64.5769 36.6991 64.5762 36.6998Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.7185C65.9084 36.7192 65.9077 36.7336 65.914 36.7274C65.9146 36.7267 65.9153 36.7123 65.9091 36.7185Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5489 36.7963C64.5427 36.8025 64.5572 36.8018 64.5579 36.8012C64.5641 36.795 64.5496 36.7956 64.5489 36.7963Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.909 36.8288C65.9083 36.8295 65.9077 36.8439 65.9139 36.8377C65.9146 36.837 65.9152 36.8226 65.909 36.8288Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5118 36.8608L64.498 36.9022C64.5225 36.8888 64.5251 36.8853 64.5118 36.8608Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9043 36.8608V36.9436H65.9181C65.9174 36.9125 65.9164 36.8891 65.9043 36.8608Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 36.9804C65.9084 36.9811 65.9077 36.9956 65.914 36.9894C65.9146 36.9887 65.9153 36.9742 65.9091 36.9804Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4477 37.0631C64.447 37.0638 64.4463 37.0783 64.4525 37.0721C64.4532 37.0714 64.4539 37.0569 64.4477 37.0631Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9228 37.0631C65.9221 37.0638 65.9214 37.0782 65.9276 37.072C65.9283 37.0713 65.929 37.0569 65.9228 37.0631Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4107 37.1961C64.4045 37.2023 64.419 37.2016 64.4197 37.201C64.4259 37.1948 64.4114 37.1954 64.4107 37.1961Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9365 37.2836C65.9358 37.2843 65.9351 37.2988 65.9413 37.2926C65.942 37.2919 65.9427 37.2774 65.9365 37.2836Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3784 37.3388C64.3777 37.3395 64.377 37.354 64.3832 37.3478C64.3839 37.3471 64.3846 37.3326 64.3784 37.3388Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3647 37.4492C64.364 37.4499 64.3633 37.4643 64.3695 37.4581C64.3702 37.4574 64.3709 37.443 64.3647 37.4492Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3647 37.4768C64.364 37.4775 64.3633 37.4919 64.3695 37.4857C64.3702 37.485 64.3709 37.4706 64.3647 37.4768Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.351 37.4906C64.3503 37.4912 64.3496 37.5057 64.3558 37.4995C64.3565 37.4988 64.3572 37.4844 64.351 37.4906Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9916 37.5318C65.991 37.5325 65.9903 37.547 65.9965 37.5408C65.9972 37.5401 65.9979 37.5256 65.9916 37.5318Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3373 37.5456C64.3367 37.5463 64.336 37.5608 64.3422 37.5546C64.3429 37.5539 64.3436 37.5394 64.3373 37.5456Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.978 37.5456C65.9773 37.5463 65.9766 37.5608 65.9828 37.5546C65.9835 37.5539 65.9842 37.5394 65.978 37.5456Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3188 37.619V37.6604H64.3326C64.3292 37.6404 64.3282 37.6363 64.3188 37.619Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.019 37.6698C66.0183 37.6704 66.0176 37.6849 66.0238 37.6787C66.0245 37.678 66.0252 37.6636 66.019 37.6698Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3095 37.6973C64.3088 37.698 64.3081 37.7125 64.3143 37.7063C64.315 37.7056 64.3157 37.6911 64.3095 37.6973ZM66.0053 37.6973C66.0046 37.698 66.0039 37.7125 66.0101 37.7063C66.0108 37.7056 66.0115 37.6911 66.0053 37.6973Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2958 37.7662C64.2952 37.7669 64.2945 37.7814 64.3007 37.7752C64.3014 37.7745 64.3021 37.76 64.2958 37.7662Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2958 37.7938C64.2952 37.7945 64.2945 37.8089 64.3007 37.8027C64.3014 37.8021 64.3021 37.7876 64.2958 37.7938Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0468 37.8352C66.0461 37.8358 66.0454 37.8503 66.0516 37.8441C66.0523 37.8434 66.053 37.829 66.0468 37.8352Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2685 37.9179C64.2678 37.9186 64.2671 37.933 64.2733 37.9268C64.274 37.9261 64.2747 37.9117 64.2685 37.9179Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2637 37.9637V38.0051H64.2775C64.274 37.9851 64.2732 37.981 64.2637 37.9637Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2594 38.0234C64.2532 38.0296 64.2676 38.0289 64.2683 38.0282C64.2745 38.022 64.26 38.0227 64.2594 38.0234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2543 38.1109C64.2537 38.1116 64.253 38.126 64.2592 38.1198C64.2599 38.1191 64.2605 38.1047 64.2543 38.1109Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1157 38.1523C66.115 38.153 66.1143 38.1675 66.1205 38.1613C66.1212 38.1606 66.1219 38.1461 66.1157 38.1523Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2407 38.1799C64.24 38.1806 64.2393 38.1951 64.2455 38.1888C64.2462 38.1882 64.2469 38.1737 64.2407 38.1799Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2407 38.2212C64.24 38.2219 64.2393 38.2364 64.2455 38.2302C64.2462 38.2295 64.2469 38.215 64.2407 38.2212Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2407 38.2487C64.24 38.2494 64.2393 38.2639 64.2455 38.2577C64.2462 38.257 64.2469 38.2425 64.2407 38.2487Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 38.2625C64.2263 38.2632 64.2256 38.2777 64.2318 38.2715C64.2325 38.2708 64.2332 38.2563 64.227 38.2625Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2227 38.2947V38.336H64.2364C64.233 38.316 64.232 38.3119 64.2227 38.2947Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2227 38.3497V38.3911H64.2364C64.233 38.3711 64.232 38.367 64.2227 38.3497Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 38.4143C64.2263 38.415 64.2256 38.4294 64.2318 38.4232C64.2325 38.4225 64.2332 38.4081 64.227 38.4143Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1938 38.4601V38.5014H66.2076C66.2042 38.4815 66.2033 38.4773 66.1938 38.4601Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2085 38.4877V38.529H64.2223C64.2188 38.509 64.2178 38.5049 64.2085 38.4877Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2085 38.5427V38.6254H64.2223C64.2216 38.5944 64.2206 38.571 64.2085 38.5427Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.226 38.6073C66.2253 38.6079 66.2246 38.6224 66.2308 38.6162C66.2315 38.6155 66.2322 38.6011 66.226 38.6073Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1948 38.6393C64.2024 38.6619 64.2 38.6594 64.2224 38.6669V38.6393H64.1948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 38.6762C64.2126 38.6769 64.2119 38.6914 64.2182 38.6852C64.2188 38.6845 64.2195 38.67 64.2133 38.6762Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 38.6899C64.1985 38.6906 64.1978 38.7051 64.204 38.6989C64.2047 38.6982 64.2054 38.6837 64.1992 38.6899Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 38.7313C64.1985 38.732 64.1978 38.7464 64.204 38.7402C64.2047 38.7396 64.2054 38.7251 64.1992 38.7313Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 38.7727C64.2126 38.7733 64.2119 38.7878 64.2182 38.7816C64.2188 38.7809 64.2195 38.7665 64.2133 38.7727Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3086 38.9243C66.3079 38.925 66.3072 38.9395 66.3134 38.9333C66.3141 38.9326 66.3148 38.9181 66.3086 38.9243Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 38.9657C64.1985 38.9663 64.1978 38.9808 64.204 38.9746C64.2047 38.9739 64.2054 38.9594 64.1992 38.9657Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1992 39.007C64.1985 39.0077 64.1978 39.0222 64.204 39.016C64.2047 39.0153 64.2054 39.0008 64.1992 39.007Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3915 39.2C66.3909 39.2007 66.3902 39.2152 66.3964 39.209C66.3971 39.2083 66.3978 39.1938 66.3915 39.2Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1948 39.2046C64.2024 39.2272 64.2 39.2248 64.2224 39.2322V39.2046H64.1948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.269C64.2126 39.2697 64.2119 39.2842 64.2182 39.278C64.2188 39.2773 64.2195 39.2628 64.2133 39.269Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.3242C64.2126 39.3249 64.2119 39.3393 64.2182 39.3331C64.2188 39.3324 64.2195 39.318 64.2133 39.3242Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2085 39.3838V39.4114C64.2309 39.404 64.2285 39.4064 64.2361 39.3838H64.2085Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.4344C64.2126 39.4351 64.2119 39.4496 64.2182 39.4434C64.2188 39.4427 64.2195 39.4282 64.2133 39.4344Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 39.4759C64.2263 39.4765 64.2256 39.491 64.2318 39.4848C64.2325 39.4841 64.2332 39.4696 64.227 39.4759Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2133 39.4896C64.2126 39.4903 64.2119 39.5047 64.2182 39.4985C64.2188 39.4979 64.2195 39.4834 64.2133 39.4896Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 39.531C64.2263 39.5317 64.2256 39.5461 64.2318 39.5399C64.2325 39.5392 64.2332 39.5248 64.227 39.531Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.227 39.5999C64.2263 39.6006 64.2256 39.6151 64.2318 39.6089C64.2325 39.6082 64.2332 39.5937 64.227 39.5999Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5429 39.7377C66.5422 39.7384 66.5415 39.7529 66.5477 39.7467C66.5484 39.746 66.5491 39.7315 66.5429 39.7377Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5571 39.7791C66.5564 39.7798 66.5557 39.7943 66.5619 39.7881C66.5626 39.7874 66.5633 39.7729 66.5571 39.7791Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2363 39.8112C64.2439 39.8337 64.2413 39.8311 64.2639 39.8387V39.8112H64.2363Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5707 39.8756C66.5701 39.8763 66.5694 39.8907 66.5756 39.8845C66.5763 39.8838 66.577 39.8694 66.5707 39.8756Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.25 39.949C64.2576 39.9716 64.255 39.969 64.2776 39.9765V39.949H64.25Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3095 40.2479C64.3088 40.2486 64.3081 40.263 64.3143 40.2568C64.315 40.2562 64.3157 40.2417 64.3095 40.2479Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3326 40.3765L64.3188 40.4316H64.3326C64.3392 40.4051 64.3406 40.4014 64.3326 40.3765Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3419 40.505C64.3357 40.5112 64.3501 40.5105 64.3508 40.5098C64.357 40.5036 64.3426 40.5043 64.3419 40.505Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7775 40.5512C66.7768 40.5519 66.7761 40.5664 66.7823 40.5602C66.783 40.5595 66.7837 40.545 66.7775 40.5512Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3925 40.7442C64.3918 40.7449 64.3911 40.7594 64.3974 40.7532C64.398 40.7525 64.3987 40.738 64.3925 40.7442Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4062 40.7993C64.4055 40.8 64.4048 40.8145 64.411 40.8083C64.4117 40.8076 64.4124 40.7931 64.4062 40.7993Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4199 40.882C64.4192 40.8827 64.4185 40.8972 64.4247 40.891C64.4254 40.8903 64.4261 40.8758 64.4199 40.882Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4614 41.0474C64.4607 41.0481 64.46 41.0626 64.4662 41.0564C64.4669 41.0557 64.4676 41.0412 64.4614 41.0474Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9843 41.2268C66.9836 41.2275 66.9829 41.2419 66.9891 41.2357C66.9898 41.235 66.9905 41.2206 66.9843 41.2268Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5117 41.245V41.2864H64.5255C64.5221 41.2664 64.5212 41.2622 64.5117 41.245Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6269 41.7093C64.6262 41.71 64.6255 41.7245 64.6317 41.7183C64.6324 41.7176 64.6331 41.7031 64.6269 41.7093Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1357 41.7231C67.135 41.7238 67.1343 41.7383 67.1405 41.7321C67.1412 41.7314 67.1419 41.7169 67.1357 41.7231Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8334 42.3848C64.8328 42.3855 64.8321 42.4 64.8383 42.3938C64.839 42.3931 64.8396 42.3786 64.8334 42.3848Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3427 42.3986C67.342 42.3993 67.3413 42.4138 67.3475 42.4076C67.3482 42.4069 67.3489 42.3924 67.3427 42.3986Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.555 42.6434C75.312 42.6758 75.0235 42.7045 74.8393 42.8869C74.5051 43.2181 74.5119 43.8628 74.5982 44.2919C74.6328 44.4637 74.6988 44.6335 74.8267 44.7583C75.1497 45.0735 75.8606 45.0328 76.2719 44.9775C76.4889 44.9482 76.7326 44.8947 76.8911 44.7326C77.0174 44.6033 77.0809 44.4386 77.1157 44.2643C77.1987 43.8485 77.2134 43.2517 76.9158 42.9134C76.6312 42.5901 75.9483 42.591 75.555 42.6434Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.569 42.6571C75.326 42.6895 75.0375 42.7183 74.8533 42.9006C74.5201 43.2306 74.5281 43.8648 74.6149 44.2919C74.6489 44.4583 74.7171 44.6238 74.8407 44.7444C75.1592 45.0553 75.8526 45.0181 76.2583 44.9636C76.4753 44.9343 76.719 44.8809 76.8775 44.7187C77.0038 44.5895 77.0672 44.4247 77.1021 44.2505C77.1841 43.8403 77.1955 43.2606 76.9021 42.9271C76.6221 42.609 75.9564 42.6056 75.569 42.6571Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9853 42.8812C64.9846 42.8819 64.9839 42.8963 64.9901 42.8901C64.9908 42.8895 64.9915 42.875 64.9853 42.8812Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4946 42.895C67.4939 42.8957 67.4932 42.9101 67.4994 42.9039C67.5001 42.9032 67.5008 42.8888 67.4946 42.895Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1132 50.0685C47.5598 50.0685 48.0688 50.0142 48.4919 50.185C48.9823 50.3832 49.2872 50.8252 49.5155 51.2818C49.7945 51.8398 50.014 52.4264 50.2455 53.0051L50.7639 54.2873C50.8494 54.4992 50.9002 54.7143 51.1389 54.7944C51.6457 54.9649 52.2817 54.8613 52.8071 54.8525C52.9739 54.8498 53.2848 54.8284 53.3565 54.6457C53.4139 54.4994 53.3507 54.3035 53.3034 54.1632C53.1875 53.8199 53.0371 53.4892 52.8937 53.1568L52.2201 51.5851C51.9696 50.9979 51.6969 50.3965 51.2453 49.9331C51.0357 49.718 50.7852 49.5753 50.5323 49.4205C51.1705 49.2046 51.7839 48.8684 52.1939 48.3176C53.0354 47.1873 53.0091 45.2206 51.9523 44.2241C50.6486 42.995 48.6528 43.2027 47.0029 43.2027H45.8448C45.6252 43.2027 45.3771 43.1789 45.1692 43.2622C44.8474 43.3911 44.8036 43.6422 44.7636 43.9472C44.7347 44.1671 44.7556 44.4011 44.7556 44.6227V45.8636V52.0538V53.8185C44.7556 54.0503 44.694 54.3886 44.7883 54.6044C44.8673 54.7853 45.1219 54.8131 45.2933 54.837C45.7185 54.8963 46.1927 54.8966 46.6169 54.8308C46.7696 54.8072 46.9753 54.7798 47.0722 54.6433C47.1725 54.5022 47.1132 54.1925 47.1132 54.0253V52.4398V50.0685ZM57.1913 45.1329V51.7643V53.7082C57.1913 53.9712 57.1248 54.3421 57.2185 54.5906C57.2909 54.7829 57.568 54.8125 57.7428 54.837C58.1391 54.8922 58.5869 54.8991 58.9836 54.8425C59.1339 54.8212 59.3086 54.8065 59.4385 54.72C59.6285 54.5937 59.5626 54.293 59.5626 54.0943V52.3571V45.1329H61.7547H62.3338C62.4182 45.1329 62.5207 45.1496 62.5957 45.1032C62.7367 45.0164 62.7677 44.8278 62.7922 44.6779C62.8482 44.3322 62.8475 43.9182 62.7775 43.575C62.7374 43.3768 62.6478 43.2189 62.4303 43.2039C61.7844 43.1595 61.1202 43.2027 60.4726 43.2027H56.5709H54.9165C54.7022 43.2027 54.3849 43.1446 54.1863 43.2355C54.0413 43.3016 54.0012 43.5029 53.9779 43.6439C53.9211 43.9872 53.923 44.3908 53.9848 44.733C54.0093 44.8683 54.051 45.045 54.1858 45.1127C54.2638 45.152 54.3766 45.1329 54.4615 45.1329H55.0544H57.1913Z",
    fill: "#F37E21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1918 43.5567C65.1912 43.5574 65.1905 43.5719 65.1967 43.5657C65.1974 43.565 65.198 43.5505 65.1918 43.5567Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7011 43.5705C67.7004 43.5712 67.6997 43.5857 67.7059 43.5795C67.7066 43.5788 67.7073 43.5643 67.7011 43.5705Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8388 44.0255C67.8381 44.0262 67.8374 44.0406 67.8436 44.0344C67.8443 44.0337 67.845 44.0193 67.8388 44.0255Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3989 44.2322C65.3982 44.2329 65.3975 44.2474 65.4037 44.2412C65.4044 44.2405 65.4051 44.226 65.3989 44.2322ZM67.9036 44.2229V44.2643H67.9174C67.9139 44.2443 67.9131 44.2401 67.9036 44.2229Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5502 44.7286C65.5496 44.7293 65.5489 44.7438 65.5551 44.7376C65.5558 44.7369 65.5564 44.7224 65.5502 44.7286Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0595 44.7424C68.0588 44.7431 68.0581 44.7576 68.0643 44.7513C68.065 44.7507 68.0657 44.7362 68.0595 44.7424Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1133 45.0088V48.3038C47.932 48.3038 48.9077 48.4491 49.6363 47.9947C50.5017 47.4549 50.623 45.8841 49.7052 45.3186C49.2656 45.0477 48.756 45.0346 48.2576 45.0224C47.8767 45.0131 47.4952 45.0088 47.1133 45.0088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7573 45.4041C65.7566 45.4048 65.7559 45.4193 65.7621 45.4131C65.7628 45.4124 65.7635 45.3979 65.7573 45.4041Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2665 45.4179C68.2659 45.4186 68.2652 45.4331 68.2714 45.4269C68.2721 45.4262 68.2728 45.4117 68.2665 45.4179Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9091 45.9005C65.9084 45.9012 65.9077 45.9156 65.914 45.9094C65.9146 45.9087 65.9153 45.8943 65.9091 45.9005Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4457 46.0108C68.4451 46.0114 68.4444 46.0259 68.4506 46.0197C68.4513 46.019 68.452 46.0046 68.4457 46.0108ZM81.1527 47.4215V46.677C81.1527 46.5607 81.1752 46.4299 81.097 46.3335C81.0077 46.2241 80.8573 46.1988 80.7253 46.1772C80.3968 46.124 79.991 46.1178 79.6637 46.1807C79.5169 46.2088 79.3314 46.2382 79.2565 46.3875C79.181 46.5374 79.2225 46.7759 79.2225 46.939V48.1935V52.7018V54.0667C79.2225 54.2366 79.1753 54.4946 79.2678 54.6456C79.3637 54.8019 79.5967 54.8212 79.7602 54.8446C80.1154 54.8955 80.5064 54.8825 80.8631 54.8538C81.0267 54.8405 81.2171 54.8248 81.3595 54.7357C81.5208 54.6349 81.4835 54.4522 81.4835 54.2873V53.143V50.3856V49.5722C81.4835 49.4662 81.4558 49.3135 81.4937 49.2138C81.5509 49.0635 81.7329 48.9194 81.838 48.8002C82.2704 48.3097 82.8564 47.8292 83.5516 48.0126C84.2955 48.2091 84.4753 49.09 84.4753 49.7515V53.3222V54.2459C84.4753 54.3769 84.4499 54.5455 84.5294 54.659C84.6311 54.8048 84.8525 54.8215 85.013 54.8446C85.2453 54.8777 85.4821 54.8663 85.7161 54.8663C85.9761 54.8663 86.2694 54.8743 86.5157 54.7772C86.7544 54.6831 86.7225 54.4896 86.7225 54.2735V53.0051V50.3994V49.5998C86.7225 49.4864 86.6968 49.3366 86.7296 49.2276C86.7761 49.0725 86.9836 48.9005 87.0946 48.7864C87.4377 48.4341 87.8382 48.0102 88.3631 47.9742C88.4871 47.9657 88.6142 47.9711 88.7354 47.999C89.4475 48.1629 89.636 48.8886 89.7103 49.5171C89.7578 49.9195 89.7142 50.3526 89.7142 50.7579V53.2395V54.0943C89.7142 54.2513 89.6949 54.4228 89.7298 54.5768C89.7768 54.7848 90.0489 54.8176 90.2244 54.8426C90.589 54.8944 90.9885 54.8832 91.3549 54.8538C91.5198 54.8405 91.7276 54.8226 91.8645 54.7197C91.9667 54.6427 91.9615 54.5406 91.9615 54.4252V53.8875V51.4748V49.6963C91.9615 48.9454 91.941 48.1746 91.6263 47.4766C91.0252 46.1431 89.372 45.6692 88.0598 46.2007C87.385 46.474 86.8702 46.9567 86.3641 47.4628C86.3124 47.2834 86.1859 47.1165 86.0785 46.9665C85.3795 45.9901 83.8731 45.7688 82.8071 46.2007C82.1594 46.463 81.6399 46.9343 81.1527 47.4215Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1387 47.4352V46.6907C81.1387 46.5744 81.1613 46.4436 81.0831 46.3473C80.9938 46.2379 80.8434 46.2125 80.7113 46.191C80.3848 46.1381 79.9888 46.1348 79.6636 46.1972C79.5205 46.2244 79.3427 46.2565 79.2701 46.4012C79.1946 46.5512 79.2362 46.7897 79.2362 46.9527V48.2073V52.688V54.0529C79.2362 54.2228 79.1889 54.4808 79.2815 54.6318C79.3749 54.7843 79.6 54.806 79.7601 54.8287C80.112 54.8789 80.4956 54.8684 80.8492 54.8399C81.0128 54.8267 81.2032 54.811 81.3455 54.7219C81.5068 54.6211 81.4696 54.4384 81.4696 54.2735V53.1154V50.3718V49.5584C81.4696 49.4524 81.4419 49.2997 81.4798 49.1999C81.537 49.0497 81.719 48.9056 81.8241 48.7863C82.2658 48.2854 82.8576 47.8121 83.5652 47.9988C84.3025 48.1933 84.4889 49.066 84.4889 49.7238V53.2946V54.2321C84.4889 54.3631 84.4636 54.5316 84.543 54.6452C84.6423 54.7874 84.856 54.8063 85.0128 54.8287C85.2456 54.8618 85.4812 54.8525 85.7159 54.8525C85.9713 54.8525 86.2598 54.8589 86.5018 54.7634C86.7358 54.671 86.7086 54.4863 86.7086 54.2735V53.0189V50.3856V49.586C86.7086 49.4726 86.6829 49.3228 86.7157 49.2137C86.7622 49.0586 86.9697 48.8866 87.0807 48.7725C87.4233 48.4206 87.8343 47.9829 88.363 47.9596C88.5367 47.9521 88.7073 47.9634 88.8731 48.0193C89.493 48.2278 89.6869 48.9507 89.7267 49.5308C89.7534 49.9222 89.7279 50.3241 89.7279 50.7165V53.1016V54.0529C89.7279 54.2185 89.7067 54.4007 89.7434 54.563C89.7892 54.7658 90.0517 54.8027 90.2242 54.8267C90.5861 54.8772 90.9773 54.8692 91.3409 54.8399C91.5036 54.8268 91.6977 54.8082 91.8371 54.715C92.0025 54.6045 91.9476 54.3493 91.9476 54.177V52.7018V50.2615C91.9476 49.6952 91.9701 49.1277 91.8962 48.5657C91.8006 47.8381 91.5412 47.0814 90.9549 46.6006C89.9538 45.7798 88.4826 45.8692 87.4393 46.5487C87.1746 46.7211 86.9233 46.9289 86.695 47.1469C86.5843 47.2527 86.4918 47.4106 86.3501 47.4766C86.2417 47.1006 85.9016 46.7326 85.5919 46.5115C84.6987 45.8735 83.4267 45.8625 82.4761 46.378C82.1259 46.5677 81.8241 46.8231 81.5248 47.0826C81.4 47.1909 81.289 47.3653 81.1387 47.4352Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4588 46.159C75.2415 46.1874 74.9254 46.1845 74.7748 46.374C74.6569 46.5224 74.7143 46.8295 74.7143 47.0079V48.6485V53.1154V54.2322C74.7143 54.3757 74.6835 54.5689 74.7884 54.6845C74.8958 54.8026 75.0898 54.8214 75.2382 54.8426C75.6465 54.9006 76.1126 54.895 76.5204 54.835C76.67 54.8129 76.8752 54.7802 76.9536 54.632C77.0333 54.4817 76.9754 54.1801 76.9754 54.0116V52.4674V48.0005V46.8424C76.9754 46.7091 77.0174 46.4905 76.9343 46.3777C76.8509 46.2643 76.6791 46.2226 76.548 46.1981C76.2085 46.1347 75.8024 46.1138 75.4588 46.159Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4723 46.1728C75.255 46.2012 74.9389 46.1983 74.7883 46.3878C74.6704 46.5362 74.7278 46.8433 74.7278 47.0217V48.6347V53.1016V54.2184C74.7278 54.3619 74.697 54.5551 74.8019 54.6708C74.9093 54.7888 75.1034 54.8076 75.2517 54.8288C75.6519 54.8858 76.1069 54.8801 76.5063 54.8212C76.6559 54.7991 76.8612 54.7664 76.9396 54.6182C77.0192 54.4679 76.9613 54.1663 76.9613 53.9978V52.4812V48.0143V46.8562C76.9613 46.7229 77.0033 46.5043 76.9203 46.3915C76.8369 46.2781 76.665 46.2364 76.5339 46.2119C76.2025 46.15 75.8079 46.1286 75.4723 46.1728Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5146 46.2176C68.514 46.2182 68.5133 46.2327 68.5195 46.2265C68.5202 46.2258 68.5209 46.2114 68.5146 46.2176Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6068 46.5115C68.672 46.592 68.9324 46.5801 69.0342 46.5942C69.3753 46.6414 69.7177 46.7386 70.0407 46.8568C71.1571 47.2661 72.444 48.3586 71.9095 49.6824C71.8119 49.9237 71.6654 50.1345 71.4962 50.3304C71.2444 50.622 70.9151 50.8471 70.5784 51.0292C70.4448 51.1014 70.1561 51.1623 70.0682 51.2817C71.1236 50.9246 72.2255 49.9818 72.0199 48.7587C71.987 48.5624 71.9122 48.3835 71.8224 48.2072C71.7142 47.9944 71.5522 47.7919 71.378 47.6294C70.8276 47.1165 70.1311 46.8194 69.4065 46.6476C69.1442 46.5856 68.8645 46.5839 68.6068 46.5115Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1157 46.576C66.115 46.5767 66.1143 46.5912 66.1205 46.585C66.1212 46.5843 66.1219 46.5698 66.1157 46.576Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6552 51.5989V51.5851C67.4117 51.5849 67.1625 51.5334 66.9245 51.4858C66.1685 51.3345 65.4064 51.0207 64.8427 50.4816C64.1361 49.8059 63.9441 48.8356 64.5218 48.0143C64.6878 47.7784 64.8992 47.5712 65.1322 47.4018C65.4564 47.1664 65.8133 46.9712 66.1938 46.8424C66.1245 46.8221 66.0377 46.8772 65.9732 46.9031C65.7876 46.9774 65.6075 47.0661 65.4355 47.1678C64.7038 47.6009 64.0489 48.3481 64.1573 49.2551C64.3119 50.548 65.7247 51.265 66.8693 51.4941C67.1266 51.5454 67.392 51.5989 67.6552 51.5989ZM68.7168 46.87V46.8838C69.7168 46.9627 70.9754 47.4201 71.4836 48.3452C71.9708 49.232 71.4014 50.1309 70.6193 50.6035C70.4339 50.7155 70.1658 50.9018 69.9438 50.9095C69.9958 50.9452 70.0544 50.9114 70.1092 50.8895C70.2411 50.8368 70.3712 50.7734 70.4953 50.7046C71.0066 50.4211 71.5103 49.9865 71.6501 49.393C71.9622 48.0681 70.5108 47.2536 69.4337 46.9924C69.2017 46.936 68.9565 46.875 68.7168 46.87Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7305 46.8838V46.9665C68.7929 47.0379 68.8299 47.1895 68.827 47.2836C68.8714 47.3339 68.8842 47.3967 68.8821 47.4628C68.9662 47.559 69.0377 47.8318 69.0338 47.9592C69.0769 48.0084 69.0894 48.0739 69.0889 48.1384C69.173 48.2345 69.2445 48.5074 69.2406 48.6347C69.2837 48.684 69.2962 48.7495 69.2957 48.8139C69.3498 48.8758 69.379 48.9942 69.3784 49.0759C69.4288 49.1334 69.4543 49.2346 69.4474 49.3103C69.5315 49.4064 69.603 49.6792 69.599 49.8066C69.6421 49.8559 69.6547 49.9214 69.6542 49.9858C69.7164 50.0572 69.7536 50.2088 69.7507 50.3029C69.7952 50.3532 69.8079 50.416 69.8058 50.4821C69.8915 50.58 69.9282 50.7965 69.9575 50.9233C70.941 50.6548 71.9812 49.6367 71.5836 48.552C71.5233 48.3876 71.4344 48.2352 71.3269 48.097C70.7426 47.3439 69.6561 46.9569 68.7305 46.8838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7763 47.0861C68.7756 47.0868 68.7749 47.1013 68.7811 47.0951C68.7818 47.0944 68.7825 47.0799 68.7763 47.0861Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5314 51.1991C67.277 51.2589 66.8803 51.1231 66.6353 51.0477C65.807 50.793 64.8114 50.3164 64.5796 49.393C64.3711 48.5634 64.969 47.8596 65.6426 47.463C65.8268 47.3546 66.0853 47.1809 66.3044 47.1733C66.252 47.1375 66.1941 47.1719 66.1389 47.193C66.0114 47.2416 65.8873 47.2996 65.7667 47.3632C65.2526 47.6347 64.7587 48.0481 64.5814 48.6209C64.5393 48.7567 64.5259 48.8932 64.5259 49.0345C64.5259 50.0275 65.4189 50.6162 66.2492 50.9454C66.5513 51.0651 66.8796 51.1436 67.2005 51.1932C67.2806 51.2056 67.4723 51.2668 67.5314 51.1991Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5176 51.2129C67.5042 51.0574 67.4318 50.8927 67.3844 50.7441L67.1733 50.0548L66.5839 48.1246C66.4876 47.8044 66.3659 47.4853 66.2906 47.1595C65.9842 47.2433 65.6807 47.4137 65.422 47.595C65.2094 47.7439 65.0179 47.9166 64.8619 48.1246C64.3792 48.7683 64.4656 49.5941 65.0224 50.1651C65.503 50.6576 66.1658 50.9485 66.8283 51.1008C67.0516 51.1524 67.2874 51.2122 67.5176 51.2129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4741 47.7479C66.4734 47.7486 66.4727 47.763 66.4789 47.7568C66.4796 47.7562 66.4803 47.7417 66.4741 47.7479Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9835 47.7616C68.9835 47.7616 68.9822 47.7768 68.9884 47.7706C68.9884 47.7706 68.9897 47.7554 68.9835 47.7616Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6811 48.4234C66.6804 48.4241 66.6797 48.4386 66.6859 48.4324C66.6866 48.4317 66.6873 48.4172 66.6811 48.4234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1904 48.4372C69.1897 48.4379 69.189 48.4524 69.1952 48.4462C69.1959 48.4455 69.1966 48.431 69.1904 48.4372Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8325 48.9198C66.8318 48.9204 66.8311 48.9349 66.8373 48.9287C66.838 48.928 66.8387 48.9136 66.8325 48.9198Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3417 48.9335C69.3411 48.9342 69.3404 48.9487 69.3466 48.9425C69.3473 48.9418 69.3479 48.9273 69.3417 48.9335Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4243 49.1955C69.4236 49.1962 69.4229 49.2106 69.4291 49.2044C69.4298 49.2037 69.4305 49.1893 69.4243 49.1955Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.998 49.4575C66.9973 49.4582 66.9966 49.4726 67.0028 49.4664C67.0035 49.4657 67.0042 49.4513 66.998 49.4575Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0395 49.5953C67.0388 49.596 67.0381 49.6105 67.0443 49.6043C67.045 49.6036 67.0457 49.5891 67.0395 49.5953Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5488 49.6091C69.5481 49.6098 69.5474 49.6243 69.5536 49.618C69.5543 49.6174 69.555 49.6029 69.5488 49.6091Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1909 50.0916C67.1902 50.0923 67.1895 50.1068 67.1957 50.1006C67.1964 50.0999 67.1971 50.0854 67.1909 50.0916Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7001 50.1054C69.6995 50.1061 69.6988 50.1206 69.705 50.1144C69.7057 50.1137 69.7063 50.0992 69.7001 50.1054Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3979 50.7672C67.3972 50.7679 67.3965 50.7823 67.4027 50.7761C67.4034 50.7754 67.4041 50.761 67.3979 50.7672Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9072 50.781C69.9065 50.7817 69.9058 50.7961 69.912 50.7899C69.9127 50.7892 69.9134 50.7748 69.9072 50.781Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0772 51.3276C70.071 51.3338 70.0855 51.3331 70.0862 51.3324C70.0924 51.3262 70.0779 51.3269 70.0772 51.3276Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 51.5393C70.1409 51.54 70.1402 51.5544 70.1464 51.5482C70.1471 51.5475 70.1478 51.5331 70.1415 51.5393Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2104 51.746C70.2097 51.7467 70.209 51.7612 70.2152 51.755C70.2159 51.7543 70.2166 51.7398 70.2104 51.746Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7148 51.8012C67.7141 51.8019 67.7134 51.8164 67.7196 51.8102C67.7203 51.8095 67.721 51.795 67.7148 51.8012Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2656 51.9528C70.2649 51.9535 70.2642 51.968 70.2704 51.9618C70.2711 51.9611 70.2718 51.9466 70.2656 51.9528Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8666 52.2974C67.866 52.2981 67.8653 52.3126 67.8715 52.3064C67.8722 52.3057 67.8729 52.2912 67.8666 52.2974Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9492 52.5732C67.9485 52.5739 67.9478 52.5884 67.954 52.5822C67.9547 52.5815 67.9554 52.567 67.9492 52.5732Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9633 52.6146C67.9626 52.6153 67.9619 52.6297 67.9682 52.6235C67.9688 52.6229 67.9695 52.6084 67.9633 52.6146Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4721 52.6284C70.4714 52.6291 70.4707 52.6435 70.4769 52.6373C70.4776 52.6366 70.4783 52.6222 70.4721 52.6284Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1147 53.1109C68.114 53.1116 68.1133 53.1261 68.1195 53.1199C68.1202 53.1192 68.1209 53.1047 68.1147 53.1109Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.624 53.1247C70.6233 53.1254 70.6226 53.1399 70.6288 53.1337C70.6295 53.133 70.6302 53.1185 70.624 53.1247Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3217 53.7865C68.321 53.7871 68.3203 53.8016 68.3266 53.7954C68.3272 53.7947 68.3279 53.7802 68.3217 53.7865Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.831 53.8002C70.8303 53.8009 70.8296 53.8154 70.8358 53.8092C70.8365 53.8085 70.8372 53.794 70.831 53.8002Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9824 54.2966C70.9817 54.2973 70.981 54.3118 70.9872 54.3055C70.9879 54.3049 70.9886 54.2904 70.9824 54.2966Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5283 54.462C68.5276 54.4627 68.5269 54.4772 68.5331 54.471C68.5338 54.4703 68.5345 54.4558 68.5283 54.462Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6801 54.9583C68.6794 54.959 68.6787 54.9735 68.6849 54.9673C68.6856 54.9666 68.6863 54.9521 68.6801 54.9583Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1894 54.9721C71.1887 54.9728 71.188 54.9873 71.1942 54.9811C71.1949 54.9804 71.1956 54.9659 71.1894 54.9721Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8867 55.6339C68.886 55.6346 68.8853 55.649 68.8915 55.6428C68.8922 55.6421 68.8929 55.6277 68.8867 55.6339Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3959 55.6477C71.3953 55.6483 71.3946 55.6628 71.4008 55.6566C71.4015 55.6559 71.4021 55.6415 71.3959 55.6477Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0385 56.1302C69.0378 56.1309 69.0371 56.1454 69.0433 56.1392C69.044 56.1385 69.0447 56.124 69.0385 56.1302Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5478 56.144C71.5471 56.1447 71.5464 56.1592 71.5526 56.153C71.5533 56.1523 71.554 56.1378 71.5478 56.144Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.644 56.4887C71.6433 56.4894 71.6426 56.5039 71.6488 56.4977C71.6495 56.497 71.6502 56.4825 71.644 56.4887Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2451 56.8057C69.2444 56.8064 69.2437 56.8209 69.2499 56.8147C69.2506 56.814 69.2513 56.7995 69.2451 56.8057Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7822 56.9575C71.7815 56.9582 71.7808 56.9726 71.787 56.9664C71.7877 56.9657 71.7884 56.9513 71.7822 56.9575Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3969 57.3021C69.3962 57.3028 69.3955 57.3172 69.4017 57.311C69.4024 57.3104 69.4031 57.2959 69.3969 57.3021Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9294 57.6375V57.665H71.957C71.9494 57.6425 71.952 57.6449 71.9294 57.6375Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9338 57.6881C71.9331 57.6888 71.9324 57.7032 71.9386 57.697C71.9393 57.6963 71.94 57.6819 71.9338 57.6881Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9611 57.7846C71.9604 57.7853 71.9597 57.7998 71.9659 57.7936C71.9666 57.7929 71.9673 57.7784 71.9611 57.7846Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9615 57.826C71.9608 57.8267 71.9601 57.8412 71.9663 57.835C71.967 57.8343 71.9677 57.8198 71.9615 57.826Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9889 57.9087C71.9883 57.9094 71.9876 57.9239 71.9938 57.9177C71.9945 57.917 71.9951 57.9025 71.9889 57.9087Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0026 57.9914C72.0019 57.9921 72.0012 58.0066 72.0074 58.0004C72.0081 57.9997 72.0088 57.9852 72.0026 57.9914Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0165 58.088C72.0159 58.0887 72.0152 58.1031 72.0214 58.0969C72.0221 58.0962 72.0228 58.0818 72.0165 58.088Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0302 58.1844C72.0295 58.1851 72.0288 58.1996 72.035 58.1934C72.0357 58.1927 72.0364 58.1782 72.0302 58.1844Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.03 58.2396C72.0293 58.2403 72.0286 58.2547 72.0348 58.2485C72.0355 58.2479 72.0362 58.2334 72.03 58.2396Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0439 58.2672C72.0432 58.2679 72.0425 58.2823 72.0487 58.2761C72.0494 58.2754 72.0501 58.261 72.0439 58.2672Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6865 58.2948C69.6858 58.2954 69.6851 58.3099 69.6913 58.3037C69.692 58.303 69.6927 58.2886 69.6865 58.2948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0533 58.3406L72.0396 58.3682H72.0671C72.0671 58.3426 72.0713 58.3495 72.0533 58.3406Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0576 58.4188C72.0569 58.4195 72.0562 58.4339 72.0624 58.4277C72.0631 58.4271 72.0638 58.4126 72.0576 58.4188Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0626 58.4968C72.0564 58.503 72.0708 58.5023 72.0715 58.5016C72.0777 58.4954 72.0633 58.4961 72.0626 58.4968Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0717 58.5705C72.071 58.5712 72.0703 58.5857 72.0765 58.5795C72.0772 58.5788 72.0779 58.5643 72.0717 58.5705Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0714 58.6118C72.0707 58.6125 72.07 58.627 72.0762 58.6208C72.0769 58.6201 72.0776 58.6056 72.0714 58.6118Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0811 58.699V58.7403H72.0948C72.0914 58.7203 72.0904 58.7162 72.0811 58.699Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0853 58.7497C72.0846 58.7504 72.084 58.7648 72.0902 58.7586C72.0908 58.7579 72.0915 58.7435 72.0853 58.7497Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0854 58.7773C72.0847 58.778 72.084 58.7925 72.0902 58.7863C72.0909 58.7856 72.0916 58.7711 72.0854 58.7773Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8383 58.7911C69.8376 58.7918 69.8369 58.8063 69.8432 58.8001C69.8438 58.7994 69.8445 58.7849 69.8383 58.7911Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 58.8463C72.0984 58.847 72.0977 58.8614 72.1039 58.8552C72.1046 58.8545 72.1053 58.8401 72.0991 58.8463Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.852 58.8599C69.8513 58.8606 69.8506 58.8751 69.8568 58.8689C69.8575 58.8682 69.8582 58.8537 69.852 58.8599Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 58.9013C72.0984 58.902 72.0977 58.9165 72.1039 58.9103C72.1046 58.9096 72.1053 58.8951 72.0991 58.9013Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 58.9565C72.1121 58.9572 72.1114 58.9717 72.1176 58.9655C72.1183 58.9648 72.1189 58.9503 72.1127 58.9565Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0992 58.984C72.0985 58.9847 72.0978 58.9992 72.104 58.993C72.1047 58.9923 72.1054 58.9778 72.0992 58.984Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 58.9979C72.1121 58.9986 72.1114 59.013 72.1176 59.0068C72.1183 59.0062 72.1189 58.9917 72.1127 58.9979Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 59.0117C72.0984 59.0124 72.0977 59.0268 72.1039 59.0206C72.1046 59.0199 72.1053 59.0055 72.0991 59.0117Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.0531C72.1121 59.0537 72.1114 59.0682 72.1176 59.062C72.1183 59.0613 72.1189 59.0469 72.1127 59.0531Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9208 59.1081C69.9202 59.1088 69.9195 59.1233 69.9257 59.1171C69.9264 59.1164 69.9271 59.1019 69.9208 59.1081Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.1771C72.1121 59.1778 72.1114 59.1922 72.1176 59.186C72.1183 59.1854 72.1189 59.1709 72.1127 59.1771Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1084 59.2091V59.2505H72.1222C72.1187 59.2305 72.1177 59.2263 72.1084 59.2091Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.3287C72.1121 59.3294 72.1114 59.3439 72.1176 59.3377C72.1183 59.337 72.1189 59.3225 72.1127 59.3287Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9717 59.3608C69.9793 59.3834 69.9767 59.381 69.9993 59.3884V59.3608H69.9717Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.3977C72.1121 59.3983 72.1114 59.4128 72.1176 59.4066C72.1183 59.4059 72.1189 59.3915 72.1127 59.3977Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1083 59.4435V59.4848H72.1221C72.1186 59.4649 72.1178 59.4607 72.1083 59.4435Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.508C72.1121 59.5087 72.1114 59.5232 72.1176 59.517C72.1183 59.5163 72.1189 59.5018 72.1127 59.508Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1087 59.54V59.5814H72.1224C72.119 59.5614 72.1181 59.5573 72.1087 59.54Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1084 59.609V59.6504H72.1222C72.1187 59.6304 72.1177 59.6262 72.1084 59.609Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1127 59.6734C72.1121 59.6741 72.1114 59.6886 72.1176 59.6824C72.1183 59.6817 72.1189 59.6672 72.1127 59.6734Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0727 59.701C70.072 59.7017 70.0713 59.7162 70.0775 59.71C70.0782 59.7093 70.0789 59.6948 70.0727 59.701Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 59.8112C72.0984 59.8119 72.0977 59.8264 72.1039 59.8202C72.1046 59.8195 72.1053 59.805 72.0991 59.8112Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0947 59.8434V59.8847H72.1085C72.1051 59.8648 72.104 59.8606 72.0947 59.8434Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 59.9216C72.0984 59.9223 72.0977 59.9368 72.1039 59.9305C72.1046 59.9299 72.1053 59.9154 72.0991 59.9216Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 59.963C70.1409 59.9637 70.1402 59.9781 70.1464 59.9719C70.1471 59.9712 70.1478 59.9568 70.1415 59.963Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0904 59.9857C72.0842 59.9919 72.0987 59.9912 72.0994 59.9905C72.1056 59.9843 72.0911 59.985 72.0904 59.9857Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0854 60.0456C72.0847 60.0463 72.084 60.0608 72.0902 60.0546C72.0909 60.0539 72.0916 60.0394 72.0854 60.0456Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0811 60.0778V60.1191H72.0948C72.0914 60.0991 72.0904 60.095 72.0811 60.0778Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0762 60.1374C72.07 60.1436 72.0845 60.1429 72.0852 60.1422C72.0914 60.136 72.0769 60.1367 72.0762 60.1374Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0669 60.1604V60.2018H72.0807C72.0772 60.1818 72.0762 60.1776 72.0669 60.1604Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1919 60.2156V60.2432C70.2143 60.2357 70.2121 60.2382 70.2195 60.2156H70.1919Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0717 60.2387C72.071 60.2394 72.0703 60.2539 72.0765 60.2477C72.0772 60.247 72.0779 60.2325 72.0717 60.2387Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0489 60.3304C72.0427 60.3366 72.0572 60.3359 72.0579 60.3352C72.0641 60.329 72.0496 60.3297 72.0489 60.3304Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0396 60.3534V60.3948H72.0533C72.0499 60.3748 72.0489 60.3706 72.0396 60.3534Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0396 60.4086V60.4499H72.0533C72.0499 60.4299 72.0489 60.4258 72.0396 60.4086Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2792 60.5557C70.2786 60.5564 70.2779 60.5709 70.2841 60.5647C70.2848 60.564 70.2854 60.5495 70.2792 60.5557Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0165 60.5833C72.0159 60.584 72.0152 60.5985 72.0214 60.5923C72.0221 60.5916 72.0228 60.5771 72.0165 60.5833Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0074 60.6198C72.0012 60.626 72.0157 60.6253 72.0164 60.6246C72.0226 60.6184 72.0081 60.6191 72.0074 60.6198Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.998 60.6429V60.6843H72.0118C72.0084 60.6643 72.0074 60.6602 71.998 60.6429Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3071 60.7213C70.3064 60.722 70.3057 60.7364 70.3119 60.7302C70.3126 60.7295 70.3133 60.7151 70.3071 60.7213Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9887 60.7349C71.988 60.7356 71.9873 60.7501 71.9935 60.7439C71.9942 60.7432 71.9949 60.7287 71.9887 60.7349Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9801 60.7716C71.9739 60.7778 71.9883 60.7771 71.989 60.7764C71.9952 60.7702 71.9807 60.7709 71.9801 60.7716Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3344 60.7901C70.3337 60.7908 70.333 60.8053 70.3392 60.7991C70.3399 60.7984 70.3406 60.7839 70.3344 60.7901Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.975 60.8039C71.9744 60.8046 71.9737 60.8191 71.9799 60.8129C71.9806 60.8122 71.9812 60.7977 71.975 60.8039Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3344 60.8453C70.3337 60.846 70.333 60.8605 70.3392 60.8543C70.3399 60.8536 70.3406 60.8391 70.3344 60.8453Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9522 60.868C71.946 60.8742 71.9605 60.8735 71.9612 60.8728C71.9674 60.8666 71.9529 60.8673 71.9522 60.868Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9429 60.8911V60.9187H71.9704C71.9629 60.8961 71.9654 60.8985 71.9429 60.8911Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3574 60.9187V60.9601H70.3712C70.3678 60.9401 70.3669 60.9359 70.3574 60.9187Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9477 60.9418C71.947 60.9425 71.9463 60.957 71.9525 60.9508C71.9532 60.9501 71.9539 60.9356 71.9477 60.9418Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3481 60.9556C70.3474 60.9563 70.3467 60.9708 70.3529 60.9646C70.3536 60.9639 70.3543 60.9494 70.3481 60.9556Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9292 60.9601V61.0014H71.943C71.9395 60.9815 71.9387 60.9773 71.9292 60.9601Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9249 61.0059C71.9187 61.0121 71.9332 61.0114 71.9338 61.0108C71.94 61.0045 71.9256 61.0052 71.9249 61.0059Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9155 61.0291V61.0704H71.9293C71.9259 61.0504 71.925 61.0463 71.9155 61.0291Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3574 61.0427V61.0703C70.3798 61.0629 70.3776 61.0651 70.385 61.0427H70.3574Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9015 61.0979L71.8877 61.1255H71.9153C71.9153 61.1 71.9194 61.1069 71.9015 61.0979Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3759 61.1348C70.3752 61.1355 70.3745 61.15 70.3807 61.1438C70.3814 61.1431 70.3821 61.1286 70.3759 61.1348Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8784 61.19C71.8777 61.1907 71.877 61.2052 71.8832 61.199C71.8839 61.1983 71.8846 61.1838 71.8784 61.19Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8784 61.2175C71.8777 61.2182 71.877 61.2327 71.8832 61.2264C71.8839 61.2258 71.8846 61.2113 71.8784 61.2175Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8647 61.2313C71.864 61.232 71.8633 61.2464 71.8695 61.2402C71.8702 61.2396 71.8709 61.2251 71.8647 61.2313Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3896 61.2727C70.3889 61.2733 70.3882 61.2878 70.3944 61.2816C70.3951 61.2809 70.3958 61.2665 70.3896 61.2727Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.851 61.2865C71.8503 61.2871 71.8496 61.3016 71.8558 61.2954C71.8565 61.2947 71.8572 61.2802 71.851 61.2865Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.314C70.4026 61.3147 70.4019 61.3292 70.4081 61.323C70.4088 61.3223 70.4095 61.3078 70.4033 61.314ZM71.8326 61.3047V61.3461H71.8464C71.843 61.3261 71.8421 61.3219 71.8326 61.3047Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3896 61.3278C70.3889 61.3285 70.3882 61.343 70.3944 61.3368C70.3951 61.3361 70.3958 61.3216 70.3896 61.3278Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8282 61.3505C71.822 61.3567 71.8365 61.356 71.8372 61.3554C71.8434 61.3492 71.8289 61.3498 71.8282 61.3505Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.3692C70.4026 61.3699 70.4019 61.3843 70.4081 61.3781C70.4088 61.3774 70.4095 61.363 70.4033 61.3692Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3853 61.4702C70.3927 61.4928 70.3904 61.4904 70.4128 61.4978V61.4702H70.3853Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7773 61.484V61.5254H71.7911C71.7877 61.5054 71.7868 61.5012 71.7773 61.484Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3853 61.5115L70.399 61.5528H70.4128V61.5115H70.3853Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.6036C70.4026 61.6043 70.4019 61.6188 70.4081 61.6126C70.4088 61.6119 70.4095 61.5974 70.4033 61.6036Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.6449C70.4026 61.6456 70.4019 61.6601 70.4081 61.6539C70.4088 61.6532 70.4095 61.6387 70.4033 61.6449Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9669 61.6494L64.9531 61.677H64.9807C64.9807 61.6515 64.9848 61.6584 64.9669 61.6494Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7315 61.6539C71.7253 61.6601 71.7398 61.6594 71.7405 61.6587C71.7467 61.6525 71.7322 61.6532 71.7315 61.6539Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0313 61.6677C65.0251 61.6739 65.0396 61.6732 65.0403 61.6725C65.0465 61.6663 65.032 61.667 65.0313 61.6677Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0728 61.6677C65.0666 61.6739 65.0811 61.6732 65.0818 61.6725C65.088 61.6663 65.0735 61.667 65.0728 61.6677Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1002 61.6677C65.094 61.6739 65.1084 61.6732 65.1091 61.6725C65.1153 61.6663 65.1009 61.667 65.1002 61.6677Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.128 61.6677C65.1218 61.6739 65.1363 61.6732 65.137 61.6725C65.1432 61.6663 65.1287 61.667 65.128 61.6677Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.727 61.6862C71.7263 61.6869 71.7256 61.7014 71.7318 61.6952C71.7325 61.6945 71.7332 61.68 71.727 61.6862Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3159 61.7C65.3152 61.7007 65.3145 61.7152 65.3207 61.709C65.3214 61.7083 65.3221 61.6938 65.3159 61.7Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4033 61.7C70.4026 61.7007 70.4019 61.7152 70.4081 61.709C70.4088 61.7083 70.4095 61.6938 70.4033 61.7Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3624 61.7091C65.3562 61.7153 65.3707 61.7146 65.3713 61.7139C65.3775 61.7077 65.3631 61.7084 65.3624 61.7091Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4082 61.7184V61.7322H65.4496C65.4323 61.7227 65.4282 61.7218 65.4082 61.7184Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.454 61.7277C65.4534 61.7284 65.4527 61.7429 65.4589 61.7367C65.4596 61.736 65.4603 61.7215 65.454 61.7277Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7042 61.7504C71.698 61.7566 71.7125 61.756 71.7131 61.7553C71.7193 61.7491 71.7049 61.7497 71.7042 61.7504Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6314 61.7641C64.6252 61.7703 64.6397 61.7696 64.6404 61.7689C64.6466 61.7627 64.6321 61.7634 64.6314 61.7641Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5416 61.7642C65.5354 61.7704 65.5499 61.7697 65.5505 61.7691C65.5567 61.7628 65.5423 61.7635 65.5416 61.7642Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3896 61.8242C70.3889 61.8249 70.3882 61.8393 70.3944 61.8331C70.3951 61.8324 70.3958 61.818 70.3896 61.8242Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6582 61.838C71.6575 61.8387 71.6568 61.8531 71.663 61.8469C71.6637 61.8462 71.6644 61.8318 71.6582 61.838Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4614 61.8793C64.4607 61.88 64.46 61.8945 64.4662 61.8883C64.4669 61.8876 64.4676 61.8731 64.4614 61.8793Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6303 61.8931C71.6296 61.8938 71.6289 61.9083 71.6351 61.9021C71.6358 61.9014 71.6365 61.8869 71.6303 61.8931Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4249 61.902C64.4187 61.9083 64.4332 61.9076 64.4338 61.9069C64.44 61.9007 64.4256 61.9014 64.4249 61.902Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8448 61.902C65.8386 61.9083 65.8531 61.9076 65.8538 61.9069C65.86 61.9007 65.8455 61.9014 65.8448 61.902ZM70.3758 61.9069C70.3751 61.9076 70.3744 61.922 70.3806 61.9158C70.3813 61.9151 70.382 61.9007 70.3758 61.9069Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6303 61.9344C71.6296 61.9351 71.6289 61.9496 71.6351 61.9434C71.6358 61.9427 71.6365 61.9282 71.6303 61.9344Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3834 61.9572C64.3772 61.9634 64.3917 61.9627 64.3923 61.962C64.3985 61.9558 64.3841 61.9565 64.3834 61.9572Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9638 61.9758C65.9631 61.9765 65.9624 61.991 65.9686 61.9847C65.9693 61.9841 65.97 61.9696 65.9638 61.9758Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3623 61.9896C70.3616 61.9903 70.3609 62.0047 70.3671 61.9985C70.3678 61.9979 70.3685 61.9834 70.3623 61.9896Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5938 61.9986C71.5876 62.0048 71.6021 62.0041 71.6028 62.0034C71.609 61.9972 71.5945 61.9979 71.5938 61.9986Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0515 62.0261C66.0453 62.0323 66.0598 62.0316 66.0605 62.0309C66.0667 62.0247 66.0522 62.0254 66.0515 62.0261ZM70.3575 62.0216V62.063H70.3712C70.3678 62.043 70.3669 62.0388 70.3575 62.0216Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3009 62.0537C64.2947 62.0599 64.3091 62.0592 64.3098 62.0585C64.316 62.0523 64.3015 62.053 64.3009 62.0537Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1065 62.0675C66.1003 62.0737 66.1148 62.073 66.1155 62.0723C66.1217 62.0661 66.1072 62.0668 66.1065 62.0675Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.543 62.0768V62.1319H71.5568C71.5543 62.1087 71.5523 62.0976 71.543 62.0768Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1617 62.095C66.1555 62.1012 66.17 62.1006 66.1707 62.0999C66.1769 62.0937 66.1624 62.0944 66.1617 62.095Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3481 62.0999C70.3474 62.1006 70.3467 62.1151 70.3529 62.1089C70.3536 62.1082 70.3543 62.0937 70.3481 62.0999Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1802 62.1044C66.1878 62.1269 66.1852 62.1245 66.2078 62.1319C66.2002 62.1094 66.2028 62.1118 66.1802 62.1044Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2169 62.1364C66.2107 62.1426 66.2251 62.1419 66.2258 62.1412C66.232 62.135 66.2176 62.1357 66.2169 62.1364Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3394 62.1364C70.3332 62.1426 70.3477 62.1419 70.3484 62.1412C70.3546 62.135 70.3401 62.1357 70.3394 62.1364Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2354 62.1458C66.243 62.1683 66.2406 62.1659 66.263 62.1733C66.2554 62.1508 66.258 62.1532 66.2354 62.1458Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.525 62.1502C71.5188 62.1564 71.5333 62.1557 71.5339 62.155C71.5401 62.1488 71.5257 62.1495 71.525 62.1502Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2315 62.164C64.2253 62.1702 64.2398 62.1695 64.2405 62.1689C64.2467 62.1626 64.2322 62.1633 64.2315 62.164Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3344 62.1826C70.3337 62.1833 70.333 62.1977 70.3392 62.1915C70.3399 62.1908 70.3406 62.1764 70.3344 62.1826Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2999 62.2054C66.2937 62.2116 66.3082 62.2109 66.3088 62.2102C66.315 62.204 66.3006 62.2047 66.2999 62.2054Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4835 62.2054C71.4773 62.2116 71.4917 62.2109 71.4924 62.2102C71.4986 62.204 71.4842 62.2047 71.4835 62.2054Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1905 62.2191C64.1843 62.2253 64.1988 62.2246 64.1995 62.2239C64.2057 62.2177 64.1912 62.2184 64.1905 62.2191Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1855 62.2377C64.1848 62.2384 64.1841 62.2529 64.1903 62.2467C64.191 62.246 64.1917 62.2315 64.1855 62.2377Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3116 62.233C70.3054 62.2392 70.3199 62.2385 70.3206 62.2378C70.3268 62.2316 70.3123 62.2323 70.3116 62.233Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3687 62.2468C66.3625 62.253 66.377 62.2523 66.3777 62.2516C66.3839 62.2454 66.3694 62.2461 66.3687 62.2468Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1582 62.2791C64.1575 62.2798 64.1568 62.2943 64.163 62.2881C64.1637 62.2874 64.1644 62.2729 64.1582 62.2791Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4239 62.288C66.4177 62.2942 66.4322 62.2935 66.4329 62.2929C66.4391 62.2867 66.4246 62.2873 66.4239 62.288ZM70.2932 62.2929C70.2925 62.2935 70.2918 62.308 70.298 62.3018C70.2987 62.3011 70.2994 62.2867 70.2932 62.2929Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4791 62.3294C66.4729 62.3356 66.4874 62.3349 66.488 62.3342C66.4942 62.328 66.4798 62.3287 66.4791 62.3294Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4146 62.357C71.4084 62.3632 71.4229 62.3625 71.4236 62.3618C71.4298 62.3556 71.4153 62.3563 71.4146 62.357Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1166 62.3894C64.116 62.39 64.1153 62.4045 64.1215 62.3983C64.1222 62.3976 64.1229 62.3832 64.1166 62.3894Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5571 62.4032C66.5564 62.4038 66.5557 62.4183 66.5619 62.4121C66.5626 62.4114 66.5633 62.3969 66.5571 62.4032ZM70.2657 62.4032C70.265 62.4038 70.2643 62.4183 70.2705 62.4121C70.2712 62.4114 70.2719 62.3969 70.2657 62.4032Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0888 62.4307C64.0881 62.4314 64.0874 62.4459 64.0936 62.4397C64.0943 62.439 64.095 62.4245 64.0888 62.4307Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6168 62.4536C66.6106 62.4598 66.625 62.4591 66.6257 62.4584C66.6319 62.4522 66.6175 62.4529 66.6168 62.4536Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2154 62.4948C70.2092 62.501 70.2237 62.5004 70.2244 62.4997C70.2306 62.4935 70.2161 62.4941 70.2154 62.4948Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0615 62.5135C64.0608 62.5142 64.0601 62.5287 64.0663 62.5225C64.067 62.5218 64.0677 62.5073 64.0615 62.5135Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2061 62.5042V62.5455H70.2198C70.2164 62.5255 70.2154 62.5214 70.2061 62.5042Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7084 62.5273C66.7078 62.528 66.7071 62.5425 66.7133 62.5363C66.714 62.5356 66.7146 62.5211 66.7084 62.5273Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0478 62.5549C64.0471 62.5556 64.0464 62.5701 64.0526 62.5638C64.0533 62.5632 64.054 62.5487 64.0478 62.5549Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2998 62.5549C71.2991 62.5556 71.2984 62.5701 71.3046 62.5638C71.3053 62.5632 71.306 62.5487 71.2998 62.5549Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0341 62.5687C64.0334 62.5694 64.0327 62.5838 64.039 62.5776C64.0396 62.577 64.0403 62.5625 64.0341 62.5687Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7636 62.5687C66.7629 62.5694 66.7622 62.5838 66.7684 62.5776C66.7691 62.577 66.7698 62.5625 66.7636 62.5687Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2719 62.5824C71.2712 62.5831 71.2705 62.5976 71.2767 62.5914C71.2774 62.5907 71.2781 62.5762 71.2719 62.5824Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1739 62.5914C70.1677 62.5976 70.1822 62.5969 70.1829 62.5962C70.1891 62.59 70.1746 62.5907 70.1739 62.5914Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8096 62.6052C66.8034 62.6114 66.8179 62.6107 66.8186 62.61C66.8248 62.6038 66.8103 62.6045 66.8096 62.6052Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2582 62.6099C71.2576 62.6106 71.2569 62.6251 71.2631 62.6189C71.2638 62.6182 71.2645 62.6037 71.2582 62.6099Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0156 62.6145V62.6559H64.0294C64.026 62.6359 64.0251 62.6317 64.0156 62.6145Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2399 62.6283L71.2261 62.6559C71.2435 62.6424 71.2452 62.6464 71.2399 62.6283Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8512 62.6466C66.8449 62.6528 66.8594 62.6521 66.8601 62.6514C66.8663 62.6452 66.8518 62.6459 66.8512 62.6466Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1461 62.6466C70.1399 62.6528 70.1543 62.6521 70.155 62.6514C70.1612 62.6452 70.1468 62.6459 70.1461 62.6466Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1415 62.6651C70.1409 62.6658 70.1402 62.6803 70.1464 62.6741C70.1471 62.6734 70.1478 62.6589 70.1415 62.6651Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9063 62.6879C66.9001 62.6941 66.9146 62.6935 66.9153 62.6928C66.9215 62.6866 66.907 62.6872 66.9063 62.6879Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.002 62.6971V62.7523H64.0157C64.0133 62.729 64.0113 62.718 64.002 62.6971Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9248 62.6971C66.9322 62.7197 66.9298 62.7173 66.9524 62.7247C66.9448 62.7021 66.9474 62.7046 66.9248 62.6971Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1709 62.7247V62.7385H71.2123C71.195 62.729 71.1909 62.7282 71.1709 62.7247Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0727 62.7617C70.072 62.7624 70.0713 62.7768 70.0775 62.7706C70.0782 62.7699 70.0789 62.7555 70.0727 62.7617Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1529 62.7844C71.1467 62.7906 71.1612 62.7899 71.1619 62.7892C71.1681 62.783 71.1536 62.7837 71.1529 62.7844Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0445 62.7982C67.0383 62.8044 67.0527 62.8037 67.0534 62.803C67.0596 62.7968 67.0452 62.7975 67.0445 62.7982Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0582 62.812C67.052 62.8182 67.0665 62.8175 67.0671 62.8168C67.0733 62.8106 67.0589 62.8113 67.0582 62.812Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.979 62.8443C63.9783 62.845 63.9776 62.8595 63.9838 62.8533C63.9845 62.8526 63.9852 62.8381 63.979 62.8443Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1685 62.8947C67.1623 62.9009 67.1768 62.9002 67.1775 62.8995C67.1837 62.8933 67.1692 62.894 67.1685 62.8947Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0654 62.9133C71.0647 62.914 71.064 62.9285 71.0702 62.9222C71.0709 62.9216 71.0716 62.9071 71.0654 62.9133Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2232 62.9223C67.217 62.9285 67.2315 62.9278 67.2322 62.9271C67.2384 62.9209 67.2239 62.9216 67.2232 62.9223Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9117 62.9636C69.9055 62.9698 69.92 62.9691 69.9207 62.9684C69.9269 62.9622 69.9124 62.9629 69.9117 62.9636Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.996 62.996C70.9954 62.9967 70.9947 63.0112 71.0009 63.005C71.0016 63.0043 71.0022 62.9898 70.996 62.996Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3336 63.005C67.3274 63.0112 67.3418 63.0105 67.3425 63.0098C67.3487 63.0036 67.3343 63.0043 67.3336 63.005Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8477 63.0005V63.0143H69.889C69.8718 63.0048 69.8676 63.0039 69.8477 63.0005Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9824 63.0098C70.9817 63.0105 70.981 63.025 70.9872 63.0188C70.9879 63.0181 70.9886 63.0036 70.9824 63.0098Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3614 63.0325C67.3552 63.0387 67.3697 63.0381 67.3704 63.0374C67.3766 63.0312 67.3621 63.0319 67.3614 63.0325Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9835 63.0463C63.9773 63.0525 63.9917 63.0518 63.9924 63.0512C63.9986 63.045 63.9842 63.0456 63.9835 63.0463Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3887 63.0463C67.3825 63.0525 67.397 63.0518 67.3977 63.0512C67.4039 63.045 67.3894 63.0456 67.3887 63.0463Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9595 63.0463C70.9533 63.0525 70.9678 63.0518 70.9685 63.0512C70.9747 63.045 70.9602 63.0456 70.9595 63.0463Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4166 63.0739C67.4104 63.0801 67.4249 63.0794 67.4255 63.0788C67.4317 63.0726 67.4173 63.0732 67.4166 63.0739Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.751 63.1108H69.7648C69.7722 63.0884 69.7698 63.0907 69.7923 63.0832C69.7649 63.0736 69.7627 63.0834 69.751 63.1108Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.979 63.0925C63.9783 63.0932 63.9776 63.1077 63.9838 63.1014C63.9845 63.1008 63.9852 63.0863 63.979 63.0925Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5634 63.1477C67.5627 63.1483 67.562 63.1628 67.5683 63.1566C67.5689 63.1559 67.5696 63.1415 67.5634 63.1477Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.877 63.1567C70.8708 63.1629 70.8853 63.1622 70.886 63.1615C70.8922 63.1553 70.8777 63.156 70.877 63.1567Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6138 63.1935V63.2073H67.6551C67.6379 63.198 67.6338 63.1969 67.6138 63.1935Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5624 63.2304C69.5618 63.2311 69.5611 63.2456 69.5673 63.2394C69.568 63.2387 69.5687 63.2242 69.5624 63.2304Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.794 63.2531C70.7878 63.2593 70.8023 63.2586 70.803 63.2579C70.8092 63.2517 70.7947 63.2524 70.794 63.2531Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7887 63.2669C67.7824 63.2731 67.7969 63.2724 67.7976 63.2717C67.8038 63.2655 67.7893 63.2662 67.7887 63.2669Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4936 63.2718C69.4929 63.2725 69.4922 63.287 69.4984 63.2808C69.4991 63.2801 69.4998 63.2656 69.4936 63.2718Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8438 63.2945C67.8376 63.3007 67.8521 63.3 67.8528 63.2993C67.859 63.2931 67.8445 63.2938 67.8438 63.2945Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4384 63.2994C69.4377 63.3001 69.437 63.3146 69.4433 63.3084C69.4439 63.3077 69.4446 63.2932 69.4384 63.2994Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.753 63.3083C70.7468 63.3145 70.7613 63.3138 70.762 63.3131C70.7682 63.3069 70.7537 63.3076 70.753 63.3083Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9033 63.3176V63.3314H67.9447C67.9274 63.3221 67.9233 63.3211 67.9033 63.3176Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0478 63.3407C64.0471 63.3414 64.0464 63.3559 64.0526 63.3497C64.0533 63.349 64.054 63.3345 64.0478 63.3407Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2637 63.3635C69.2575 63.3697 69.272 63.369 69.2727 63.3683C69.2789 63.3621 69.2644 63.3628 69.2637 63.3635Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1377 63.4003V63.4141H68.1791C68.1618 63.4046 68.1577 63.4037 68.1377 63.4003Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1792 63.4003V63.4141H68.2206C68.2033 63.4046 68.1992 63.4037 68.1792 63.4003Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.207 63.4141V63.4278H68.2484C68.2312 63.4184 68.227 63.4175 68.207 63.4141Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2529 63.4234C68.2522 63.4241 68.2515 63.4386 68.2577 63.4324C68.2584 63.4317 68.2591 63.4172 68.2529 63.4234Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0157 63.4323C69.0095 63.4385 69.024 63.4378 69.0247 63.4371C69.0309 63.4309 69.0164 63.4316 69.0157 63.4323Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2896 63.4417V63.4554H68.3309C68.3137 63.446 68.3095 63.4451 68.2896 63.4417Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4366 63.4599C68.4304 63.4661 68.4449 63.4654 68.4456 63.4647C68.4518 63.4585 68.4373 63.4592 68.4366 63.4599Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4961 63.4692V63.483H68.5375C68.5202 63.4735 68.5161 63.4727 68.4961 63.4692Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5748 63.4737C68.5686 63.4799 68.5831 63.4792 68.5837 63.4785C68.5899 63.4723 68.5755 63.473 68.5748 63.4737Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7398 63.4737C68.7336 63.4799 68.7481 63.4792 68.7488 63.4785C68.755 63.4723 68.7405 63.473 68.7398 63.4737Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.795 63.4737C68.7888 63.4799 68.8033 63.4792 68.804 63.4785C68.8102 63.4723 68.7957 63.473 68.795 63.4737Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8638 63.4737C68.8576 63.4799 68.8721 63.4792 68.8728 63.4785C68.879 63.4723 68.8645 63.473 68.8638 63.4737Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6295 63.4875C68.6233 63.4937 68.6377 63.493 68.6384 63.4923C68.6446 63.4861 68.6302 63.4868 68.6295 63.4875Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5825 63.5062C70.5818 63.5069 70.5811 63.5213 70.5873 63.5151C70.588 63.5145 70.5887 63.5 70.5825 63.5062Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5366 63.5244V63.5382H70.578C70.5607 63.5287 70.5566 63.5279 70.5366 63.5244Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5048 63.5703C70.4986 63.5765 70.513 63.5758 70.5137 63.5751C70.5199 63.5689 70.5055 63.5696 70.5048 63.5703Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2179 63.7357C64.2116 63.7419 64.2261 63.7412 64.2268 63.7405C64.233 63.7343 64.2185 63.735 64.2179 63.7357Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2888 63.7726C70.2812 63.7952 70.2838 63.7926 70.2612 63.8002V63.8139C70.2886 63.8022 70.2985 63.8 70.2888 63.7726Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2822 63.8232C64.2815 63.8239 64.2808 63.8384 64.287 63.8322C64.2877 63.8315 64.2884 63.817 64.2822 63.8232Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2061 63.8416V63.8691C70.2286 63.8617 70.2262 63.864 70.2336 63.8416H70.2061Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3095 63.8784C64.3088 63.8791 64.3081 63.8935 64.3143 63.8873C64.315 63.8866 64.3157 63.8722 64.3095 63.8784Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.123 63.9104V63.938C70.1455 63.9306 70.1432 63.9328 70.1506 63.9104H70.123Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1 63.9335C70.0994 63.9342 70.0987 63.9487 70.1049 63.9425C70.1056 63.9418 70.1062 63.9273 70.1 63.9335Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3784 63.9611C64.3777 63.9618 64.377 63.9763 64.3832 63.9701C64.3839 63.9694 64.3846 63.9549 64.3784 63.9611Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0727 63.9749C70.072 63.9756 70.0713 63.9901 70.0775 63.9839C70.0782 63.9832 70.0789 63.9687 70.0727 63.9749Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0034 64.0162C70.0027 64.0169 70.002 64.0314 70.0082 64.0252C70.0089 64.0245 70.0096 64.01 70.0034 64.0162Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4887 64.0852C64.488 64.0858 64.4873 64.1003 64.4935 64.0941C64.4942 64.0934 64.4949 64.079 64.4887 64.0852Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5302 64.1265C64.5295 64.1272 64.5288 64.1417 64.535 64.1355C64.5357 64.1348 64.5364 64.1203 64.5302 64.1265Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6593 64.2458C64.6531 64.252 64.6675 64.2513 64.6682 64.2506C64.6744 64.2444 64.6599 64.2451 64.6593 64.2458Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7094 64.2782C64.7087 64.2788 64.708 64.2933 64.7142 64.2871C64.7149 64.2864 64.7156 64.2719 64.7094 64.2782Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7281 64.2872C64.7219 64.2934 64.7364 64.2927 64.7371 64.292C64.7433 64.2858 64.7288 64.2865 64.7281 64.2872Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6133 64.2827V64.2965H69.6546C69.6374 64.287 69.6333 64.2862 69.6133 64.2827Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5898 64.3057C69.5891 64.3064 69.5884 64.3209 69.5946 64.3147C69.5953 64.314 69.596 64.2995 69.5898 64.3057Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7646 64.3195C64.7639 64.3202 64.7632 64.3347 64.7694 64.3285C64.7701 64.3278 64.7708 64.3133 64.7646 64.3195Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5396 64.3424C69.5334 64.3486 69.5479 64.3479 69.5486 64.3472C69.5548 64.341 69.5403 64.3417 69.5396 64.3424Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3554 64.4437C69.3547 64.4444 69.354 64.4588 69.3602 64.4526C69.3609 64.452 69.3616 64.4375 69.3554 64.4437Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.004 64.4802C64.9978 64.4864 65.0123 64.4857 65.0129 64.485C65.0191 64.4788 65.0047 64.4795 65.004 64.4802Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0678 64.5126C65.0671 64.5133 65.0664 64.5278 65.0726 64.5216C65.0733 64.5209 65.074 64.5064 65.0678 64.5126Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1832 64.5767C65.177 64.5829 65.1915 64.5822 65.1921 64.5816C65.1983 64.5754 65.1839 64.576 65.1832 64.5767Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2197 64.5815C65.219 64.5822 65.2183 64.5967 65.2245 64.5905C65.2252 64.5898 65.2259 64.5753 65.2197 64.5815Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0479 64.5721V64.6135H69.0616C69.0582 64.5935 69.0573 64.5894 69.0479 64.5721Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2794 64.618C65.2732 64.6242 65.2876 64.6235 65.2883 64.6228C65.2945 64.6166 65.2801 64.6173 65.2794 64.618Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3072 64.6318C65.301 64.638 65.3155 64.6373 65.3162 64.6366C65.3224 64.6304 65.3079 64.6311 65.3072 64.6318Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3345 64.6456C65.3283 64.6518 65.3428 64.6511 65.3435 64.6504C65.3497 64.6442 65.3352 64.6449 65.3345 64.6456Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9282 64.6505C68.9275 64.6512 68.9268 64.6656 68.933 64.6594C68.9337 64.6587 68.9344 64.6443 68.9282 64.6505Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4312 64.687C65.425 64.6932 65.4395 64.6925 65.4402 64.6918C65.4464 64.6856 65.4319 64.6863 65.4312 64.687Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4677 64.6918C65.467 64.6925 65.4663 64.707 65.4725 64.7008C65.4732 64.7001 65.4739 64.6856 65.4677 64.6918Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5322 64.7101C65.5398 64.7327 65.5374 64.7302 65.5598 64.7377C65.5522 64.7151 65.5548 64.7175 65.5322 64.7101Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6426 64.7653V64.779H65.6839C65.6667 64.7696 65.6626 64.7687 65.6426 64.7653Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7388 64.7927V64.8065H65.7801C65.7629 64.797 65.7588 64.7962 65.7388 64.7927Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7896 64.8249C65.7834 64.8311 65.7979 64.8304 65.7986 64.8297C65.8048 64.8235 65.7903 64.8242 65.7896 64.8249Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8261 64.8297C65.8254 64.8304 65.8247 64.8448 65.8309 64.8386C65.8316 64.8379 65.8323 64.8235 65.8261 64.8297Z",
    fill: "#E2F0E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9273 64.8524C65.9211 64.8586 65.9356 64.8579 65.9363 64.8572C65.9425 64.851 65.928 64.8517 65.9273 64.8524Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9458 64.8617V64.8755H65.9872C65.9699 64.866 65.9658 64.8651 65.9458 64.8617Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.024 64.88C66.0178 64.8862 66.0323 64.8855 66.033 64.8848C66.0392 64.8786 66.0247 64.8793 66.024 64.88Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0283 64.8893V64.9031H66.0697C66.0524 64.8936 66.0483 64.8927 66.0283 64.8893Z",
    fill: "#098509"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0562 64.9031V64.9169H66.0975C66.0803 64.9074 66.0761 64.9065 66.0562 64.9031Z",
    fill: "#DAEBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2075 64.9307V64.9444H66.2489C66.2316 64.935 66.2275 64.9341 66.2075 64.9307Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2675 64.94C66.2668 64.9407 66.2661 64.9552 66.2724 64.949C66.273 64.9483 66.2737 64.9338 66.2675 64.94Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4419 64.9858V64.9996H66.4833C66.466 64.9901 66.4619 64.9893 66.4419 64.9858Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4971 64.9858V64.9996H66.5384C66.5212 64.9901 66.5171 64.9893 66.4971 64.9858Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5522 64.9858V65.0134C66.5748 65.006 66.5722 65.0084 66.5798 64.9858H66.5522Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5981 64.9951C66.5974 64.9958 66.5967 65.0102 66.6029 65.004C66.6036 65.0033 66.6043 64.9889 66.5981 64.9951Z",
    fill: "#C7E2C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7335 64.9903C67.7273 64.9965 67.7417 64.9958 67.7424 64.9951C67.7486 64.9889 67.7342 64.9896 67.7335 64.9903Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8575 64.9903C67.8513 64.9965 67.8658 64.9958 67.8665 64.9951C67.8727 64.9889 67.8582 64.9896 67.8575 64.9903Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6304 65.0041C66.6242 65.0103 66.6387 65.0096 66.6394 65.0089C66.6456 65.0027 66.6311 65.0034 66.6304 65.0041Z",
    fill: "#79BA79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6583 65.0041C66.6521 65.0103 66.6666 65.0096 66.6672 65.0089C66.6734 65.0027 66.659 65.0034 66.6583 65.0041Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7135 65.0179C66.7073 65.0241 66.7217 65.0234 66.7224 65.0227C66.7286 65.0165 66.7141 65.0172 66.7135 65.0179Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4854 65.0179C67.4792 65.0241 67.4937 65.0234 67.4944 65.0227C67.5006 65.0165 67.4861 65.0172 67.4854 65.0179Z",
    fill: "#52AA52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5406 65.0179C67.5344 65.0241 67.5489 65.0234 67.5496 65.0227C67.5558 65.0165 67.5413 65.0172 67.5406 65.0179Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7823 65.0317C66.7761 65.0379 66.7906 65.0372 66.7913 65.0365C66.7975 65.0303 66.783 65.031 66.7823 65.0317Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8375 65.0317C66.8313 65.0379 66.8458 65.0372 66.8464 65.0365C66.8526 65.0303 66.8382 65.031 66.8375 65.0317Z",
    fill: "#8DC58D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9063 65.0317C66.9001 65.0379 66.9146 65.0372 66.9153 65.0365C66.9215 65.0303 66.907 65.031 66.9063 65.0317Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9478 65.0317C66.9416 65.0379 66.9561 65.0372 66.9568 65.0365C66.963 65.0303 66.9485 65.031 66.9478 65.0317Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.003 65.0317C66.9968 65.0379 67.0113 65.0372 67.012 65.0365C67.0182 65.0303 67.0037 65.031 67.003 65.0317Z",
    fill: "#229222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0719 65.0317C67.0657 65.0379 67.0801 65.0372 67.0808 65.0365C67.087 65.0303 67.0725 65.031 67.0719 65.0317Z",
    fill: "#68B468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3477 65.0317C67.3415 65.0379 67.356 65.0372 67.3567 65.0365C67.3629 65.0303 67.3484 65.031 67.3477 65.0317Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4166 65.0317C67.4104 65.0379 67.4249 65.0372 67.4255 65.0365C67.4317 65.0303 67.4173 65.031 67.4166 65.0317Z",
    fill: "#A6D2A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1407 65.0455C67.1345 65.0517 67.149 65.051 67.1497 65.0503C67.1559 65.0441 67.1414 65.0448 67.1407 65.0455Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1959 65.0455C67.1897 65.0517 67.2042 65.051 67.2048 65.0503C67.211 65.0441 67.1966 65.0448 67.1959 65.0455Z",
    fill: "#3B9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3062 65.0455C67.3 65.0517 67.3145 65.051 67.3152 65.0503C67.3214 65.0441 67.3069 65.0448 67.3062 65.0455Z",
    fill: "#B8DDB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3614 65.0455C67.3552 65.0517 67.3697 65.051 67.3704 65.0503C67.3766 65.0441 67.3621 65.0448 67.3614 65.0455Z",
    fill: "#DAEBDA"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M34.543 74.6891C35.2799 74.6891 35.8177 74.8479 36.1562 75.1656C36.4948 75.4808 36.6641 75.9156 36.6641 76.4703C36.6641 76.7203 36.6263 76.9599 36.5508 77.1891C36.4753 77.4156 36.3516 77.6175 36.1797 77.7946C36.0104 77.9716 35.7839 78.1123 35.5 78.2164C35.2161 78.318 34.8659 78.3688 34.4492 78.3688H33.9297V80.4H32.7188V74.6891H34.543ZM34.4805 75.6813H33.9297V77.3766H34.3281C34.5547 77.3766 34.7513 77.3466 34.918 77.2867C35.0846 77.2268 35.2135 77.1331 35.3047 77.0055C35.3958 76.8779 35.4414 76.7138 35.4414 76.5133C35.4414 76.2321 35.3633 76.0237 35.207 75.8883C35.0508 75.7503 34.8086 75.6813 34.4805 75.6813ZM40.2653 80.4H39.0544V75.6969H37.5036V74.6891H41.8161V75.6969H40.2653V80.4ZM45.4408 75.6149C45.209 75.6149 45.0033 75.6604 44.8236 75.7516C44.6465 75.8401 44.4968 75.969 44.3744 76.1383C44.2546 76.3076 44.1634 76.512 44.1009 76.7516C44.0384 76.9912 44.0072 77.2607 44.0072 77.5602C44.0072 77.9638 44.0567 78.3089 44.1556 78.5953C44.2572 78.8792 44.4134 79.0966 44.6244 79.2477C44.8353 79.3961 45.1074 79.4703 45.4408 79.4703C45.6726 79.4703 45.9043 79.4443 46.1361 79.3922C46.3705 79.3401 46.6244 79.2659 46.8978 79.1696V80.1852C46.6452 80.2893 46.3965 80.3636 46.1517 80.4078C45.9069 80.4547 45.6322 80.4781 45.3275 80.4781C44.739 80.4781 44.2546 80.3571 43.8744 80.1149C43.4968 79.8701 43.2168 79.5289 43.0345 79.0914C42.8522 78.6513 42.7611 78.1383 42.7611 77.5524C42.7611 77.1201 42.8197 76.7242 42.9369 76.3649C43.0541 76.0055 43.2259 75.6943 43.4525 75.4313C43.6791 75.1683 43.959 74.9651 44.2923 74.8219C44.6257 74.6787 45.0085 74.6071 45.4408 74.6071C45.7246 74.6071 46.0085 74.6435 46.2923 74.7164C46.5788 74.7867 46.8522 74.8844 47.1127 75.0094L46.722 75.9938C46.5085 75.8922 46.2936 75.8037 46.0775 75.7281C45.8614 75.6526 45.6491 75.6149 45.4408 75.6149ZM48.4366 74.6891H49.5264V77.4469C49.5264 77.5823 49.5238 77.7321 49.5186 77.8961C49.516 78.0602 49.5108 78.2216 49.503 78.3805C49.4978 78.5367 49.4926 78.6735 49.4873 78.7906C49.4821 78.9078 49.4769 78.986 49.4717 79.025H49.4952L52.1319 74.6891H53.5811V80.4H52.503V77.6578C52.503 77.512 52.5056 77.3531 52.5108 77.1813C52.516 77.0094 52.5225 76.8427 52.5303 76.6813C52.5407 76.5198 52.5498 76.3805 52.5577 76.2633C52.5655 76.1435 52.5707 76.0641 52.5733 76.025H52.542L49.8936 80.4H48.4366V74.6891ZM57.7605 80.4L56.3855 75.9196H56.3503C56.3555 76.0263 56.3633 76.1878 56.3738 76.4039C56.3868 76.6175 56.3985 76.8453 56.4089 77.0875C56.4193 77.3297 56.4245 77.5485 56.4245 77.7438V80.4H55.3425V74.6891H56.9909L58.3425 79.0563H58.3659L59.7995 74.6891H61.448V80.4H60.3191V77.6969C60.3191 77.5172 60.3217 77.3102 60.3269 77.0758C60.3347 76.8414 60.3438 76.6188 60.3542 76.4078C60.3646 76.1943 60.3724 76.0341 60.3777 75.9274H60.3425L58.8698 80.4H57.7605ZM62.9477 79.8414C62.9477 79.5966 63.0141 79.4248 63.1469 79.3258C63.2823 79.2268 63.4451 79.1774 63.6352 79.1774C63.8201 79.1774 63.9789 79.2268 64.1117 79.3258C64.2471 79.4248 64.3148 79.5966 64.3148 79.8414C64.3148 80.0758 64.2471 80.2451 64.1117 80.3492C63.9789 80.4534 63.8201 80.5055 63.6352 80.5055C63.4451 80.5055 63.2823 80.4534 63.1469 80.3492C63.0141 80.2451 62.9477 80.0758 62.9477 79.8414ZM70.4669 80.4H69.0919L67.0216 77.5055V80.4H65.8106V74.6891H67.0216V77.4547L69.0684 74.6891H70.3575L68.2755 77.4313L70.4669 80.4ZM75.0017 80.4L74.5877 79.0406H72.5056L72.0916 80.4H70.7869L72.8025 74.6656H74.283L76.3064 80.4H75.0017ZM74.2986 78.025L73.8845 76.6969C73.8585 76.6084 73.8233 76.4951 73.7791 76.3571C73.7374 76.2164 73.6944 76.0745 73.6502 75.9313C73.6085 75.7854 73.5746 75.6591 73.5486 75.5524C73.5226 75.6591 73.4861 75.792 73.4392 75.9508C73.3949 76.1071 73.352 76.2555 73.3103 76.3961C73.2686 76.5367 73.2387 76.637 73.2205 76.6969L72.8103 78.025H74.2986ZM79.1733 74.6891C79.9103 74.6891 80.448 74.8479 80.7866 75.1656C81.1251 75.4808 81.2944 75.9156 81.2944 76.4703C81.2944 76.7203 81.2566 76.9599 81.1811 77.1891C81.1056 77.4156 80.9819 77.6175 80.81 77.7946C80.6407 77.9716 80.4142 78.1123 80.1303 78.2164C79.8465 78.318 79.4962 78.3688 79.0795 78.3688H78.56V80.4H77.3491V74.6891H79.1733ZM79.1108 75.6813H78.56V77.3766H78.9584C79.185 77.3766 79.3816 77.3466 79.5483 77.2867C79.7149 77.2268 79.8439 77.1331 79.935 77.0055C80.0261 76.8779 80.0717 76.7138 80.0717 76.5133C80.0717 76.2321 79.9936 76.0237 79.8373 75.8883C79.6811 75.7503 79.4389 75.6813 79.1108 75.6813ZM82.6925 80.4V74.6891H83.9034V76.8805H84.38C84.9165 76.8805 85.3566 76.9547 85.7003 77.1031C86.0467 77.2516 86.3019 77.4573 86.4659 77.7203C86.6326 77.9808 86.7159 78.2789 86.7159 78.6149C86.7159 79.18 86.5271 79.6188 86.1495 79.9313C85.7745 80.2438 85.1769 80.4 84.3566 80.4H82.6925ZM83.9034 79.4078H84.3097C84.6769 79.4078 84.9659 79.3492 85.1769 79.2321C85.3878 79.1123 85.4933 78.9065 85.4933 78.6149C85.4933 78.4117 85.4412 78.2568 85.337 78.15C85.2355 78.0433 85.0883 77.9703 84.8956 77.9313C84.7055 77.8922 84.4777 77.8727 84.212 77.8727H83.9034V79.4078ZM91.4109 80.4H88.1219V74.6891H91.4109V75.6813H89.3328V76.9352H91.2664V77.9274H89.3328V79.4H91.4109V80.4ZM94.7505 74.6891C95.4874 74.6891 96.0252 74.8479 96.3638 75.1656C96.7023 75.4808 96.8716 75.9156 96.8716 76.4703C96.8716 76.7203 96.8338 76.9599 96.7583 77.1891C96.6828 77.4156 96.5591 77.6175 96.3872 77.7946C96.2179 77.9716 95.9914 78.1123 95.7075 78.2164C95.4236 78.318 95.0734 78.3688 94.6567 78.3688H94.1372V80.4H92.9263V74.6891H94.7505ZM94.688 75.6813H94.1372V77.3766H94.5356C94.7622 77.3766 94.9588 77.3466 95.1255 77.2867C95.2921 77.2268 95.421 77.1331 95.5122 77.0055C95.6033 76.8779 95.6489 76.7138 95.6489 76.5133C95.6489 76.2321 95.5708 76.0237 95.4145 75.8883C95.2583 75.7503 95.0161 75.6813 94.688 75.6813ZM101.766 80.4L101.352 79.0406H99.2697L98.8556 80.4H97.5509L99.5666 74.6656H101.047L103.07 80.4H101.766ZM101.063 78.025L100.649 76.6969C100.623 76.6084 100.587 76.4951 100.543 76.3571C100.501 76.2164 100.458 76.0745 100.414 75.9313C100.373 75.7854 100.339 75.6591 100.313 75.5524C100.287 75.6591 100.25 75.792 100.203 75.9508C100.159 76.1071 100.116 76.2555 100.074 76.3961C100.033 76.5367 100.003 76.637 99.9845 76.6969L99.5744 78.025H101.063Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9922 144.275C45.9922 145.423 45.582 146.349 44.7617 147.052C43.9414 147.755 42.9023 148.197 41.6445 148.377V148.447C43.207 148.603 44.4102 149.037 45.2539 149.748C46.0977 150.459 46.5195 151.384 46.5195 152.525C46.5195 153.525 46.2461 154.412 45.6992 155.185C45.1523 155.951 44.3438 156.552 43.2734 156.99C42.2031 157.42 40.8789 157.634 39.3008 157.634C38.0039 157.634 36.8516 157.556 35.8438 157.4C34.8438 157.236 33.9766 157.005 33.2422 156.709V153.662C33.7422 153.896 34.3008 154.099 34.918 154.271C35.543 154.435 36.1758 154.564 36.8164 154.658C37.457 154.744 38.0508 154.787 38.5977 154.787C40.1133 154.787 41.2109 154.568 41.8906 154.13C42.5781 153.693 42.9219 153.072 42.9219 152.267C42.9219 151.447 42.4258 150.849 41.4336 150.474C40.4414 150.099 39.1055 149.912 37.4258 149.912H35.8203V147.076H37.2617C38.6211 147.076 39.6758 146.99 40.4258 146.818C41.1836 146.638 41.7109 146.384 42.0078 146.056C42.3125 145.72 42.4648 145.318 42.4648 144.849C42.4648 144.263 42.2031 143.798 41.6797 143.455C41.1562 143.103 40.3789 142.927 39.3477 142.927C38.457 142.927 37.625 143.056 36.8516 143.314C36.0781 143.564 35.3555 143.9 34.6836 144.322L33.1016 141.896C33.6875 141.513 34.3125 141.181 34.9766 140.9C35.6484 140.619 36.3828 140.404 37.1797 140.255C37.9766 140.099 38.8672 140.021 39.8516 140.021C41.1406 140.021 42.2422 140.205 43.1562 140.572C44.0703 140.939 44.7695 141.443 45.2539 142.084C45.7461 142.716 45.9922 143.447 45.9922 144.275ZM61.2148 144.298V154.787H63.1367V162.099H59.9258V157.4H51.1133V162.099H47.9023V154.787H49.0039C49.582 153.904 50.0664 152.896 50.457 151.763C50.8555 150.63 51.1758 149.431 51.418 148.166C51.668 146.892 51.8477 145.603 51.957 144.298H61.2148ZM57.6406 146.982H54.957C54.832 147.951 54.6719 148.888 54.4766 149.795C54.2891 150.693 54.0547 151.56 53.7734 152.396C53.4922 153.224 53.1484 154.021 52.7422 154.787H57.6406V146.982ZM70.7773 144.052C71.9883 144.052 73.0312 144.287 73.9062 144.755C74.7812 145.216 75.457 145.888 75.9336 146.771C76.4102 147.654 76.6484 148.732 76.6484 150.005V151.74H68.1992C68.2383 152.748 68.5391 153.541 69.1016 154.119C69.6719 154.689 70.4609 154.974 71.4688 154.974C72.3047 154.974 73.0703 154.888 73.7656 154.716C74.4609 154.545 75.1758 154.287 75.9102 153.943V156.709C75.2617 157.029 74.582 157.263 73.8711 157.412C73.168 157.56 72.3125 157.634 71.3047 157.634C69.9922 157.634 68.8281 157.392 67.8125 156.908C66.8047 156.423 66.0117 155.685 65.4336 154.693C64.8633 153.701 64.5781 152.451 64.5781 150.943C64.5781 149.412 64.8359 148.138 65.3516 147.123C65.875 146.099 66.6016 145.334 67.5312 144.826C68.4609 144.31 69.543 144.052 70.7773 144.052ZM70.8008 146.595C70.1055 146.595 69.5273 146.818 69.0664 147.263C68.6133 147.709 68.3516 148.408 68.2812 149.361H73.2969C73.2891 148.83 73.1914 148.357 73.0039 147.943C72.8242 147.529 72.5508 147.201 72.1836 146.959C71.8242 146.716 71.3633 146.595 70.8008 146.595ZM84.875 157.634C83.5781 157.634 82.4727 157.4 81.5586 156.931C80.6445 156.455 79.9492 155.72 79.4727 154.728C78.9961 153.736 78.7578 152.466 78.7578 150.92C78.7578 149.318 79.0273 148.013 79.5664 147.005C80.1133 145.99 80.8672 145.244 81.8281 144.767C82.7969 144.291 83.918 144.052 85.1914 144.052C86.0977 144.052 86.8789 144.142 87.5352 144.322C88.1992 144.494 88.7773 144.701 89.2695 144.943L88.2148 147.709C87.6523 147.482 87.1289 147.298 86.6445 147.158C86.1602 147.009 85.6758 146.935 85.1914 146.935C84.5664 146.935 84.0469 147.084 83.6328 147.38C83.2188 147.67 82.9102 148.107 82.707 148.693C82.5039 149.279 82.4023 150.013 82.4023 150.896C82.4023 151.763 82.5117 152.482 82.7305 153.052C82.9492 153.623 83.2656 154.048 83.6797 154.33C84.0938 154.603 84.5977 154.74 85.1914 154.74C85.9336 154.74 86.5938 154.642 87.1719 154.447C87.75 154.244 88.3125 153.963 88.8594 153.603V156.662C88.3125 157.005 87.7383 157.252 87.1367 157.4C86.543 157.556 85.7891 157.634 84.875 157.634ZM95.4805 149.361H98C99.3438 149.361 100.453 149.502 101.328 149.783C102.203 150.064 102.855 150.494 103.285 151.072C103.715 151.642 103.93 152.361 103.93 153.228C103.93 154.072 103.734 154.806 103.344 155.431C102.953 156.056 102.332 156.541 101.48 156.884C100.629 157.228 99.5156 157.4 98.1406 157.4H91.9062V144.298H95.4805V149.361ZM100.355 153.275C100.355 152.767 100.152 152.4 99.7461 152.173C99.3398 151.947 98.7344 151.834 97.9297 151.834H95.4805V154.927H97.9766C98.6719 154.927 99.2422 154.802 99.6875 154.552C100.133 154.295 100.355 153.869 100.355 153.275ZM116.457 144.298V149.338H121.449V144.298H125.023V157.4H121.449V151.998H116.457V157.4H112.883V144.298H116.457ZM134.141 144.029C135.898 144.029 137.246 144.412 138.184 145.177C139.121 145.943 139.59 147.107 139.59 148.67V157.4H137.094L136.402 155.619H136.309C135.934 156.088 135.551 156.47 135.16 156.767C134.77 157.064 134.32 157.283 133.812 157.423C133.305 157.564 132.688 157.634 131.961 157.634C131.188 157.634 130.492 157.486 129.875 157.189C129.266 156.892 128.785 156.439 128.434 155.83C128.082 155.213 127.906 154.431 127.906 153.486C127.906 152.095 128.395 151.072 129.371 150.416C130.348 149.752 131.812 149.384 133.766 149.314L136.039 149.244V148.67C136.039 147.982 135.859 147.478 135.5 147.158C135.141 146.838 134.641 146.677 134 146.677C133.367 146.677 132.746 146.767 132.137 146.947C131.527 147.127 130.918 147.353 130.309 147.627L129.125 145.213C129.82 144.845 130.598 144.556 131.457 144.345C132.324 144.134 133.219 144.029 134.141 144.029ZM136.039 151.33L134.656 151.377C133.5 151.408 132.695 151.615 132.242 151.998C131.797 152.38 131.574 152.884 131.574 153.509C131.574 154.056 131.734 154.447 132.055 154.681C132.375 154.908 132.793 155.021 133.309 155.021C134.074 155.021 134.719 154.795 135.242 154.341C135.773 153.888 136.039 153.244 136.039 152.408V151.33ZM145.965 150.709L141.746 144.298H145.801L148.344 148.47L150.91 144.298H154.965L150.699 150.709L155.164 157.4H151.098L148.344 152.912L145.578 157.4H141.523L145.965 150.709ZM169.062 150.826C169.062 151.92 168.914 152.888 168.617 153.732C168.328 154.576 167.902 155.291 167.34 155.877C166.785 156.455 166.113 156.892 165.324 157.189C164.543 157.486 163.66 157.634 162.676 157.634C161.754 157.634 160.906 157.486 160.133 157.189C159.367 156.892 158.699 156.455 158.129 155.877C157.566 155.291 157.129 154.576 156.816 153.732C156.512 152.888 156.359 151.92 156.359 150.826C156.359 149.373 156.617 148.142 157.133 147.134C157.648 146.127 158.383 145.361 159.336 144.838C160.289 144.314 161.426 144.052 162.746 144.052C163.973 144.052 165.059 144.314 166.004 144.838C166.957 145.361 167.703 146.127 168.242 147.134C168.789 148.142 169.062 149.373 169.062 150.826ZM160.004 150.826C160.004 151.685 160.098 152.408 160.285 152.994C160.473 153.58 160.766 154.021 161.164 154.318C161.562 154.615 162.082 154.763 162.723 154.763C163.355 154.763 163.867 154.615 164.258 154.318C164.656 154.021 164.945 153.58 165.125 152.994C165.312 152.408 165.406 151.685 165.406 150.826C165.406 149.959 165.312 149.24 165.125 148.67C164.945 148.091 164.656 147.658 164.258 147.369C163.859 147.08 163.34 146.935 162.699 146.935C161.754 146.935 161.066 147.259 160.637 147.908C160.215 148.556 160.004 149.529 160.004 150.826ZM183.793 144.298V154.787H185.715V162.099H182.504V157.4H173.691V162.099H170.48V154.787H171.582C172.16 153.904 172.645 152.896 173.035 151.763C173.434 150.63 173.754 149.431 173.996 148.166C174.246 146.892 174.426 145.603 174.535 144.298H183.793ZM180.219 146.982H177.535C177.41 147.951 177.25 148.888 177.055 149.795C176.867 150.693 176.633 151.56 176.352 152.396C176.07 153.224 175.727 154.021 175.32 154.787H180.219V146.982ZM189.945 157.4H186.078L189.605 152.22C189.16 152.033 188.742 151.775 188.352 151.447C187.961 151.111 187.645 150.689 187.402 150.181C187.16 149.673 187.039 149.064 187.039 148.353C187.039 147.048 187.531 146.048 188.516 145.353C189.508 144.65 190.785 144.298 192.348 144.298H198.441V157.4H194.867V152.525H192.898L189.945 157.4ZM190.543 148.377C190.543 148.923 190.758 149.353 191.188 149.666C191.625 149.97 192.188 150.123 192.875 150.123H194.867V146.818H192.418C191.777 146.818 191.305 146.974 191 147.287C190.695 147.591 190.543 147.955 190.543 148.377ZM213.02 146.982H208.73V157.4H205.156V146.982H200.855V144.298H213.02V146.982ZM225.16 144.298V149.478C225.16 149.744 225.148 150.08 225.125 150.486C225.109 150.884 225.086 151.291 225.055 151.705C225.023 152.119 224.992 152.49 224.961 152.818C224.93 153.146 224.906 153.369 224.891 153.486L230.938 144.298H235.238V157.4H231.781V152.173C231.781 151.744 231.797 151.271 231.828 150.755C231.859 150.232 231.895 149.74 231.934 149.279C231.973 148.818 232 148.47 232.016 148.236L225.992 157.4H221.703V144.298H225.16ZM252.523 144.052C254 144.052 255.191 144.627 256.098 145.775C257.012 146.923 257.469 148.607 257.469 150.826C257.469 152.31 257.254 153.56 256.824 154.576C256.395 155.584 255.801 156.345 255.043 156.861C254.285 157.377 253.414 157.634 252.43 157.634C251.797 157.634 251.254 157.556 250.801 157.4C250.348 157.236 249.961 157.029 249.641 156.779C249.32 156.521 249.043 156.248 248.809 155.959H248.621C248.684 156.271 248.73 156.591 248.762 156.92C248.793 157.248 248.809 157.568 248.809 157.88V163.166H245.234V144.298H248.141L248.645 145.998H248.809C249.043 145.646 249.328 145.322 249.664 145.025C250 144.728 250.402 144.494 250.871 144.322C251.348 144.142 251.898 144.052 252.523 144.052ZM251.375 146.912C250.75 146.912 250.254 147.041 249.887 147.298C249.52 147.556 249.25 147.943 249.078 148.459C248.914 148.974 248.824 149.627 248.809 150.416V150.802C248.809 151.646 248.887 152.361 249.043 152.947C249.207 153.533 249.477 153.978 249.852 154.283C250.234 154.588 250.758 154.74 251.422 154.74C251.969 154.74 252.418 154.588 252.77 154.283C253.121 153.978 253.383 153.533 253.555 152.947C253.734 152.353 253.824 151.63 253.824 150.779C253.824 149.498 253.625 148.533 253.227 147.884C252.828 147.236 252.211 146.912 251.375 146.912ZM265.789 144.029C267.547 144.029 268.895 144.412 269.832 145.177C270.77 145.943 271.238 147.107 271.238 148.67V157.4H268.742L268.051 155.619H267.957C267.582 156.088 267.199 156.47 266.809 156.767C266.418 157.064 265.969 157.283 265.461 157.423C264.953 157.564 264.336 157.634 263.609 157.634C262.836 157.634 262.141 157.486 261.523 157.189C260.914 156.892 260.434 156.439 260.082 155.83C259.73 155.213 259.555 154.431 259.555 153.486C259.555 152.095 260.043 151.072 261.02 150.416C261.996 149.752 263.461 149.384 265.414 149.314L267.688 149.244V148.67C267.688 147.982 267.508 147.478 267.148 147.158C266.789 146.838 266.289 146.677 265.648 146.677C265.016 146.677 264.395 146.767 263.785 146.947C263.176 147.127 262.566 147.353 261.957 147.627L260.773 145.213C261.469 144.845 262.246 144.556 263.105 144.345C263.973 144.134 264.867 144.029 265.789 144.029ZM267.688 151.33L266.305 151.377C265.148 151.408 264.344 151.615 263.891 151.998C263.445 152.38 263.223 152.884 263.223 153.509C263.223 154.056 263.383 154.447 263.703 154.681C264.023 154.908 264.441 155.021 264.957 155.021C265.723 155.021 266.367 154.795 266.891 154.341C267.422 153.888 267.688 153.244 267.688 152.408V151.33ZM279.699 144.052C280.645 144.052 281.527 144.177 282.348 144.427C283.168 144.67 283.832 145.048 284.34 145.564C284.848 146.072 285.102 146.728 285.102 147.533C285.102 148.322 284.863 148.951 284.387 149.42C283.91 149.88 283.277 150.213 282.488 150.416V150.533C283.043 150.666 283.543 150.845 283.988 151.072C284.441 151.298 284.801 151.611 285.066 152.009C285.332 152.408 285.465 152.931 285.465 153.58C285.465 154.306 285.234 154.978 284.773 155.595C284.312 156.205 283.605 156.697 282.652 157.072C281.707 157.447 280.492 157.634 279.008 157.634C278.305 157.634 277.641 157.603 277.016 157.541C276.398 157.478 275.832 157.388 275.316 157.271C274.801 157.146 274.352 156.998 273.969 156.826V153.873C274.508 154.123 275.172 154.353 275.961 154.564C276.758 154.775 277.605 154.88 278.504 154.88C279.152 154.88 279.738 154.834 280.262 154.74C280.793 154.646 281.211 154.49 281.516 154.271C281.828 154.045 281.984 153.744 281.984 153.369C281.984 153.017 281.848 152.728 281.574 152.502C281.309 152.267 280.898 152.095 280.344 151.986C279.797 151.869 279.102 151.81 278.258 151.81H276.875V149.338H278.188C279.375 149.338 280.293 149.24 280.941 149.045C281.59 148.849 281.914 148.49 281.914 147.966C281.914 147.545 281.707 147.228 281.293 147.017C280.879 146.806 280.195 146.701 279.242 146.701C278.625 146.701 277.945 146.775 277.203 146.923C276.461 147.064 275.766 147.267 275.117 147.533L274.062 145.037C274.82 144.748 275.641 144.513 276.523 144.334C277.414 144.146 278.473 144.052 279.699 144.052ZM299.879 147.732C299.879 148.435 299.656 149.037 299.211 149.537C298.773 150.029 298.125 150.345 297.266 150.486V150.58C298.172 150.689 298.902 151.005 299.457 151.529C300.012 152.045 300.289 152.697 300.289 153.486C300.289 154.236 300.094 154.908 299.703 155.502C299.312 156.088 298.691 156.552 297.84 156.896C296.988 157.232 295.875 157.4 294.5 157.4H288.266V144.298H294.5C295.523 144.298 296.441 144.408 297.254 144.627C298.066 144.838 298.707 145.193 299.176 145.693C299.645 146.193 299.879 146.873 299.879 147.732ZM296.586 153.298C296.586 152.783 296.383 152.412 295.977 152.185C295.578 151.951 294.984 151.834 294.195 151.834H291.84V154.927H294.266C294.938 154.927 295.492 154.802 295.93 154.552C296.367 154.302 296.586 153.884 296.586 153.298ZM296.258 148.013C296.258 147.607 296.098 147.306 295.777 147.111C295.457 146.916 294.984 146.818 294.359 146.818H291.84V149.408H293.949C294.707 149.408 295.281 149.298 295.672 149.08C296.062 148.861 296.258 148.505 296.258 148.013ZM306.816 144.298V149.478C306.816 149.744 306.805 150.08 306.781 150.486C306.766 150.884 306.742 151.291 306.711 151.705C306.68 152.119 306.648 152.49 306.617 152.818C306.586 153.146 306.562 153.369 306.547 153.486L312.594 144.298H316.895V157.4H313.438V152.173C313.438 151.744 313.453 151.271 313.484 150.755C313.516 150.232 313.551 149.74 313.59 149.279C313.629 148.818 313.656 148.47 313.672 148.236L307.648 157.4H303.359V144.298H306.816ZM332.27 147.732C332.27 148.435 332.047 149.037 331.602 149.537C331.164 150.029 330.516 150.345 329.656 150.486V150.58C330.562 150.689 331.293 151.005 331.848 151.529C332.402 152.045 332.68 152.697 332.68 153.486C332.68 154.236 332.484 154.908 332.094 155.502C331.703 156.088 331.082 156.552 330.23 156.896C329.379 157.232 328.266 157.4 326.891 157.4H320.656V144.298H326.891C327.914 144.298 328.832 144.408 329.645 144.627C330.457 144.838 331.098 145.193 331.566 145.693C332.035 146.193 332.27 146.873 332.27 147.732ZM328.977 153.298C328.977 152.783 328.773 152.412 328.367 152.185C327.969 151.951 327.375 151.834 326.586 151.834H324.23V154.927H326.656C327.328 154.927 327.883 154.802 328.32 154.552C328.758 154.302 328.977 153.884 328.977 153.298ZM328.648 148.013C328.648 147.607 328.488 147.306 328.168 147.111C327.848 146.916 327.375 146.818 326.75 146.818H324.23V149.408H326.34C327.098 149.408 327.672 149.298 328.062 149.08C328.453 148.861 328.648 148.505 328.648 148.013ZM341.117 144.029C342.875 144.029 344.223 144.412 345.16 145.177C346.098 145.943 346.566 147.107 346.566 148.67V157.4H344.07L343.379 155.619H343.285C342.91 156.088 342.527 156.47 342.137 156.767C341.746 157.064 341.297 157.283 340.789 157.423C340.281 157.564 339.664 157.634 338.938 157.634C338.164 157.634 337.469 157.486 336.852 157.189C336.242 156.892 335.762 156.439 335.41 155.83C335.059 155.213 334.883 154.431 334.883 153.486C334.883 152.095 335.371 151.072 336.348 150.416C337.324 149.752 338.789 149.384 340.742 149.314L343.016 149.244V148.67C343.016 147.982 342.836 147.478 342.477 147.158C342.117 146.838 341.617 146.677 340.977 146.677C340.344 146.677 339.723 146.767 339.113 146.947C338.504 147.127 337.895 147.353 337.285 147.627L336.102 145.213C336.797 144.845 337.574 144.556 338.434 144.345C339.301 144.134 340.195 144.029 341.117 144.029ZM343.016 151.33L341.633 151.377C340.477 151.408 339.672 151.615 339.219 151.998C338.773 152.38 338.551 152.884 338.551 153.509C338.551 154.056 338.711 154.447 339.031 154.681C339.352 154.908 339.77 155.021 340.285 155.021C341.051 155.021 341.695 154.795 342.219 154.341C342.75 153.888 343.016 153.244 343.016 152.408V151.33ZM368.352 150.826C368.352 152.279 368.102 153.513 367.602 154.529C367.109 155.545 366.402 156.318 365.48 156.849C364.566 157.373 363.477 157.634 362.211 157.634C361.133 157.634 360.168 157.431 359.316 157.025C358.465 156.619 357.77 156.002 357.23 155.173C356.691 154.338 356.344 153.279 356.188 151.998H353.832V157.4H350.258V144.298H353.832V149.338H356.234C356.398 148.197 356.746 147.236 357.277 146.455C357.816 145.666 358.512 145.068 359.363 144.662C360.215 144.255 361.188 144.052 362.281 144.052C363.461 144.052 364.504 144.314 365.41 144.838C366.324 145.361 367.043 146.127 367.566 147.134C368.09 148.142 368.352 149.373 368.352 150.826ZM359.785 150.826C359.785 151.685 359.867 152.408 360.031 152.994C360.203 153.58 360.469 154.021 360.828 154.318C361.195 154.615 361.672 154.763 362.258 154.763C362.836 154.763 363.305 154.615 363.664 154.318C364.023 154.021 364.285 153.58 364.449 152.994C364.621 152.408 364.707 151.685 364.707 150.826C364.707 149.959 364.621 149.24 364.449 148.67C364.285 148.091 364.02 147.658 363.652 147.369C363.293 147.08 362.82 146.935 362.234 146.935C361.656 146.935 361.188 147.08 360.828 147.369C360.469 147.658 360.203 148.091 360.031 148.67C359.867 149.24 359.785 149.959 359.785 150.826ZM382.145 146.982H377.855V157.4H374.281V146.982H369.98V144.298H382.145V146.982ZM37.332 177.298V182.478C37.332 182.744 37.3203 183.08 37.2969 183.486C37.2812 183.884 37.2578 184.291 37.2266 184.705C37.1953 185.119 37.1641 185.49 37.1328 185.818C37.1016 186.146 37.0781 186.369 37.0625 186.486L43.1094 177.298H47.4102V190.4H43.9531V185.173C43.9531 184.744 43.9688 184.271 44 183.755C44.0312 183.232 44.0664 182.74 44.1055 182.279C44.1445 181.818 44.1719 181.47 44.1875 181.236L38.1641 190.4H33.875V177.298H37.332ZM54.7461 177.298V182.338H59.7383V177.298H63.3125V190.4H59.7383V184.998H54.7461V190.4H51.1719V177.298H54.7461ZM85.6836 177.298L80.8555 183.58L86.1406 190.4H82.3203L77.3281 183.755V190.4H74V183.755L69.0078 190.4H65.1875L70.4727 183.58L65.6445 177.298H69.3359L74 183.662V177.298H77.3281V183.662L81.9922 177.298H85.6836ZM93.418 177.052C94.6289 177.052 95.6719 177.287 96.5469 177.755C97.4219 178.216 98.0977 178.888 98.5742 179.771C99.0508 180.654 99.2891 181.732 99.2891 183.005V184.74H90.8398C90.8789 185.748 91.1797 186.541 91.7422 187.119C92.3125 187.689 93.1016 187.974 94.1094 187.974C94.9453 187.974 95.7109 187.888 96.4062 187.716C97.1016 187.545 97.8164 187.287 98.5508 186.943V189.709C97.9023 190.029 97.2227 190.263 96.5117 190.412C95.8086 190.56 94.9531 190.634 93.9453 190.634C92.6328 190.634 91.4688 190.392 90.4531 189.908C89.4453 189.423 88.6523 188.685 88.0742 187.693C87.5039 186.701 87.2188 185.451 87.2188 183.943C87.2188 182.412 87.4766 181.138 87.9922 180.123C88.5156 179.099 89.2422 178.334 90.1719 177.826C91.1016 177.31 92.1836 177.052 93.418 177.052ZM93.4414 179.595C92.7461 179.595 92.168 179.818 91.707 180.263C91.2539 180.709 90.9922 181.408 90.9219 182.361H95.9375C95.9297 181.83 95.832 181.357 95.6445 180.943C95.4648 180.529 95.1914 180.201 94.8242 179.959C94.4648 179.716 94.0039 179.595 93.4414 179.595ZM105.77 177.298V182.338H110.762V177.298H114.336V190.4H110.762V184.998H105.77V190.4H102.195V177.298H105.77ZM123.488 177.052C124.699 177.052 125.742 177.287 126.617 177.755C127.492 178.216 128.168 178.888 128.645 179.771C129.121 180.654 129.359 181.732 129.359 183.005V184.74H120.91C120.949 185.748 121.25 186.541 121.812 187.119C122.383 187.689 123.172 187.974 124.18 187.974C125.016 187.974 125.781 187.888 126.477 187.716C127.172 187.545 127.887 187.287 128.621 186.943V189.709C127.973 190.029 127.293 190.263 126.582 190.412C125.879 190.56 125.023 190.634 124.016 190.634C122.703 190.634 121.539 190.392 120.523 189.908C119.516 189.423 118.723 188.685 118.145 187.693C117.574 186.701 117.289 185.451 117.289 183.943C117.289 182.412 117.547 181.138 118.062 180.123C118.586 179.099 119.312 178.334 120.242 177.826C121.172 177.31 122.254 177.052 123.488 177.052ZM123.512 179.595C122.816 179.595 122.238 179.818 121.777 180.263C121.324 180.709 121.062 181.408 120.992 182.361H126.008C126 181.83 125.902 181.357 125.715 180.943C125.535 180.529 125.262 180.201 124.895 179.959C124.535 179.716 124.074 179.595 123.512 179.595ZM139.555 177.052C141.031 177.052 142.223 177.627 143.129 178.775C144.043 179.923 144.5 181.607 144.5 183.826C144.5 185.31 144.285 186.56 143.855 187.576C143.426 188.584 142.832 189.345 142.074 189.861C141.316 190.377 140.445 190.634 139.461 190.634C138.828 190.634 138.285 190.556 137.832 190.4C137.379 190.236 136.992 190.029 136.672 189.779C136.352 189.521 136.074 189.248 135.84 188.959H135.652C135.715 189.271 135.762 189.591 135.793 189.92C135.824 190.248 135.84 190.568 135.84 190.88V196.166H132.266V177.298H135.172L135.676 178.998H135.84C136.074 178.646 136.359 178.322 136.695 178.025C137.031 177.728 137.434 177.494 137.902 177.322C138.379 177.142 138.93 177.052 139.555 177.052ZM138.406 179.912C137.781 179.912 137.285 180.041 136.918 180.298C136.551 180.556 136.281 180.943 136.109 181.459C135.945 181.974 135.855 182.627 135.84 183.416V183.802C135.84 184.646 135.918 185.361 136.074 185.947C136.238 186.533 136.508 186.978 136.883 187.283C137.266 187.588 137.789 187.74 138.453 187.74C139 187.74 139.449 187.588 139.801 187.283C140.152 186.978 140.414 186.533 140.586 185.947C140.766 185.353 140.855 184.63 140.855 183.779C140.855 182.498 140.656 181.533 140.258 180.884C139.859 180.236 139.242 179.912 138.406 179.912ZM151.027 177.298V182.338H156.02V177.298H159.594V190.4H156.02V184.998H151.027V190.4H147.453V177.298H151.027ZM163.344 190.4V177.298H166.918V182.361H168.641C169.977 182.361 171.078 182.502 171.945 182.783C172.82 183.064 173.469 183.494 173.891 184.072C174.312 184.642 174.523 185.361 174.523 186.228C174.523 187.072 174.328 187.806 173.938 188.431C173.547 189.056 172.93 189.541 172.086 189.884C171.242 190.228 170.137 190.4 168.77 190.4H163.344ZM166.918 187.927H168.57C169.266 187.927 169.836 187.802 170.281 187.552C170.727 187.295 170.949 186.869 170.949 186.275C170.949 185.767 170.746 185.4 170.34 185.173C169.934 184.947 169.328 184.834 168.523 184.834H166.918V187.927ZM176.422 190.4V177.298H179.996V190.4H176.422ZM189.16 177.052C190.371 177.052 191.414 177.287 192.289 177.755C193.164 178.216 193.84 178.888 194.316 179.771C194.793 180.654 195.031 181.732 195.031 183.005V184.74H186.582C186.621 185.748 186.922 186.541 187.484 187.119C188.055 187.689 188.844 187.974 189.852 187.974C190.688 187.974 191.453 187.888 192.148 187.716C192.844 187.545 193.559 187.287 194.293 186.943V189.709C193.645 190.029 192.965 190.263 192.254 190.412C191.551 190.56 190.695 190.634 189.688 190.634C188.375 190.634 187.211 190.392 186.195 189.908C185.188 189.423 184.395 188.685 183.816 187.693C183.246 186.701 182.961 185.451 182.961 183.943C182.961 182.412 183.219 181.138 183.734 180.123C184.258 179.099 184.984 178.334 185.914 177.826C186.844 177.31 187.926 177.052 189.16 177.052ZM189.184 179.595C188.488 179.595 187.91 179.818 187.449 180.263C186.996 180.709 186.734 181.408 186.664 182.361H191.68C191.672 181.83 191.574 181.357 191.387 180.943C191.207 180.529 190.934 180.201 190.566 179.959C190.207 179.716 189.746 179.595 189.184 179.595ZM215.012 179.982H210.723V190.4H207.148V179.982H202.848V177.298H215.012V179.982ZM222.828 177.029C224.586 177.029 225.934 177.412 226.871 178.177C227.809 178.943 228.277 180.107 228.277 181.67V190.4H225.781L225.09 188.619H224.996C224.621 189.088 224.238 189.47 223.848 189.767C223.457 190.064 223.008 190.283 222.5 190.423C221.992 190.564 221.375 190.634 220.648 190.634C219.875 190.634 219.18 190.486 218.562 190.189C217.953 189.892 217.473 189.439 217.121 188.83C216.77 188.213 216.594 187.431 216.594 186.486C216.594 185.095 217.082 184.072 218.059 183.416C219.035 182.752 220.5 182.384 222.453 182.314L224.727 182.244V181.67C224.727 180.982 224.547 180.478 224.188 180.158C223.828 179.838 223.328 179.677 222.688 179.677C222.055 179.677 221.434 179.767 220.824 179.947C220.215 180.127 219.605 180.353 218.996 180.627L217.812 178.213C218.508 177.845 219.285 177.556 220.145 177.345C221.012 177.134 221.906 177.029 222.828 177.029ZM224.727 184.33L223.344 184.377C222.188 184.408 221.383 184.615 220.93 184.998C220.484 185.38 220.262 185.884 220.262 186.509C220.262 187.056 220.422 187.447 220.742 187.681C221.062 187.908 221.48 188.021 221.996 188.021C222.762 188.021 223.406 187.795 223.93 187.341C224.461 186.888 224.727 186.244 224.727 185.408V184.33ZM243.699 190.4H240.125V179.982H236.832C236.668 181.904 236.473 183.541 236.246 184.892C236.02 186.244 235.73 187.345 235.379 188.197C235.027 189.041 234.59 189.658 234.066 190.048C233.543 190.439 232.898 190.634 232.133 190.634C231.711 190.634 231.332 190.603 230.996 190.541C230.668 190.478 230.367 190.384 230.094 190.259V187.4C230.266 187.47 230.449 187.529 230.645 187.576C230.84 187.615 231.039 187.634 231.242 187.634C231.469 187.634 231.684 187.545 231.887 187.365C232.09 187.185 232.281 186.877 232.461 186.439C232.641 185.994 232.809 185.38 232.965 184.599C233.129 183.818 233.277 182.83 233.41 181.634C233.543 180.439 233.668 178.994 233.785 177.298H243.699V190.4ZM252.828 177.029C254.586 177.029 255.934 177.412 256.871 178.177C257.809 178.943 258.277 180.107 258.277 181.67V190.4H255.781L255.09 188.619H254.996C254.621 189.088 254.238 189.47 253.848 189.767C253.457 190.064 253.008 190.283 252.5 190.423C251.992 190.564 251.375 190.634 250.648 190.634C249.875 190.634 249.18 190.486 248.562 190.189C247.953 189.892 247.473 189.439 247.121 188.83C246.77 188.213 246.594 187.431 246.594 186.486C246.594 185.095 247.082 184.072 248.059 183.416C249.035 182.752 250.5 182.384 252.453 182.314L254.727 182.244V181.67C254.727 180.982 254.547 180.478 254.188 180.158C253.828 179.838 253.328 179.677 252.688 179.677C252.055 179.677 251.434 179.767 250.824 179.947C250.215 180.127 249.605 180.353 248.996 180.627L247.812 178.213C248.508 177.845 249.285 177.556 250.145 177.345C251.012 177.134 251.906 177.029 252.828 177.029ZM254.727 184.33L253.344 184.377C252.188 184.408 251.383 184.615 250.93 184.998C250.484 185.38 250.262 185.884 250.262 186.509C250.262 187.056 250.422 187.447 250.742 187.681C251.062 187.908 251.48 188.021 251.996 188.021C252.762 188.021 253.406 187.795 253.93 187.341C254.461 186.888 254.727 186.244 254.727 185.408V184.33ZM265.543 177.298V182.338H270.535V177.298H274.109V190.4H270.535V184.998H265.543V190.4H261.969V177.298H265.543ZM288.699 179.982H284.41V190.4H280.836V179.982H276.535V177.298H288.699V179.982ZM291.148 190.4V177.298H294.723V182.361H296.445C297.781 182.361 298.883 182.502 299.75 182.783C300.625 183.064 301.273 183.494 301.695 184.072C302.117 184.642 302.328 185.361 302.328 186.228C302.328 187.072 302.133 187.806 301.742 188.431C301.352 189.056 300.734 189.541 299.891 189.884C299.047 190.228 297.941 190.4 296.574 190.4H291.148ZM294.723 187.927H296.375C297.07 187.927 297.641 187.802 298.086 187.552C298.531 187.295 298.754 186.869 298.754 186.275C298.754 185.767 298.551 185.4 298.145 185.173C297.738 184.947 297.133 184.834 296.328 184.834H294.723V187.927ZM304.227 190.4V177.298H307.801V190.4H304.227Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_48_250987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682 212H-1V770H682V212Z",
    fill: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 330.511V560.838H23.3931V317.874H31.7842V362.41H79.1795V290.261H133.185V330.511H180.142V279.303H201.583V266.447H206.827V256.755H209.901V238.785H212.73V256.755H215.804V266.447H221.048V279.303H242.465V330.511H301.276V359.585H366.771V317.874H383.358V306.502H388.603V296.811H391.701V278.841H394.506V296.811H397.604V306.502H402.848V317.874H419.46V362.41H466.855V290.261H520.861V330.511H567.817V279.303H589.234V266.447H594.479V256.755H597.576V238.785H600.382V256.755H603.48V266.447H608.724V279.303H630.141V330.511H682Z",
    fill: "#E4F2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 500.84C681.951 517.154 681.854 544.377 681.805 560.716H480.027C482.515 502.033 494.151 445.029 552.742 435.314C570.622 431.856 589.722 434.364 606.821 429.324C617.164 426.718 622.384 416.808 623.677 405.607C628.995 374.098 661.413 353.693 681.854 353.741V500.596C681.878 500.694 681.951 500.767 682 500.84Z",
    fill: "#C5E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.975 493.267C681.975 493.267 677.902 425.817 652.606 425.817C614.529 425.817 607.943 528.063 572.769 507.828C537.911 487.788 506.127 480.97 498.688 560.716H681.829L681.975 493.267Z",
    fill: "#C0DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.424 561.788C320.181 479.046 398.945 545.303 421.021 491.343C430.485 470.792 444.926 456.912 469.343 461.612C493.76 466.311 491.248 484.209 523.642 483.697C556.011 483.21 552.938 458.422 583.209 464.388C613.481 470.353 623.896 505.904 618.603 560.424L315.424 561.788Z",
    fill: "#9CD0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.976 493.267L681.829 560.716C629.726 560.497 573.574 560.278 521.373 560.059V549.929C527.715 541.65 542.229 529.962 567.402 533.396C580.062 532.836 594.942 528.915 606.797 523.363C617.31 518.859 624.189 512.479 630.629 503.616C644.874 485.012 666.315 469.988 681.976 493.267Z",
    fill: "#9CD0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.68 528.404C422.85 539.483 421.118 550.343 418.362 560.716H-0.975586V270.951C0.95145 269.929 33.6867 254.588 56.9331 294.06C83.2042 337.963 126.648 234.402 176.604 290.261C196.265 311.275 188.874 338.498 204.803 355.422C213.95 365.916 228.61 367.67 239.636 361.533C256.954 353.522 273.859 335.747 294.227 345.828C308.692 353.084 316.863 363.408 321.596 377.385C331.231 401.029 319.327 434.462 338.963 450.387C352.745 459.42 372.235 455.305 388.017 458.203C421.46 461.393 425.851 501.838 423.68 528.404Z",
    fill: "#CEE8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.771 528.988C365.161 537.657 361.966 556.139 359.868 561.958H0.0488281V340.519C2.48811 337.963 34.4428 331.461 49.7371 358.173C73.7396 393.286 110.914 306.527 156.919 360.34C170.165 378.798 163.871 406.897 190.435 412.254C211.145 415.469 228.781 389.365 250.637 396.695C283.396 407.993 280.079 441.28 282.25 461.393C291.812 508.51 364.478 449.802 364.771 528.988Z",
    fill: "#B5DCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.432 561.788C258.369 561.471 128.112 561.155 -0.951082 560.814C-0.877904 560.205 -1.12183 481.53 -0.877904 480.97C5.73256 442.862 29.0033 430.736 61.5922 465.727C75.1302 477.488 88.7902 495.677 108.036 491.587C164.335 462.391 156.627 532.909 199.265 526.456C218.365 521.196 231.342 495.434 253.418 500.353C264.37 503.226 276.274 515.985 286.543 519.857C298.569 525.628 308.765 528.112 320.352 529.183C352.55 533.469 389.066 510.482 387.432 561.788Z",
    fill: "#9CD0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 555H-1V772H682V555Z",
    fill: "#CEE8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.023 352.548C665.462 348.19 661.486 345.097 657.095 345.657L470.075 369.423L441.73 312.639L435.559 321.672C435.047 322.403 423.192 340.008 418.24 364.48C415.289 379.041 415.41 393.042 418.606 406.094C422.606 422.457 431.388 437.213 444.755 449.973L452.536 457.399L472.197 385.226L545.839 375.851V382.158C539.204 382.767 534.033 388.318 534.033 395.088V399.641H525.715V421.361H538.009L510.079 558.549C509.616 560.887 511.104 563.151 513.445 563.614C515.787 564.077 518.056 562.591 518.519 560.254L526.447 521.342L583.746 557.234L584.355 560.278C584.77 562.323 586.575 563.736 588.575 563.736C588.868 563.736 589.161 563.711 589.429 563.638C591.771 563.176 593.259 560.887 592.795 558.574L564.866 421.386H577.16V399.665H568.842V395.112C568.842 388.343 563.646 382.791 557.035 382.182V374.439L631.263 365.015V495.41H621.676V563.517H634.239C634.654 563.663 635.117 563.736 635.58 563.736C636.044 563.736 636.507 563.663 636.922 563.517H649.484V495.41H639.898V363.92L659.12 361.485C663.486 360.9 666.559 356.931 666.023 352.548ZM440.535 338.961L453.244 364.455L434.339 353.985C436.315 348.116 438.535 343.003 440.535 338.961ZM430.754 367.402C430.802 367.158 430.851 366.939 430.9 366.696L446.511 375.34L429.217 378.335C429.51 374.755 430.022 371.127 430.754 367.402ZM429.168 391.338L447.463 388.172L431.51 404.852C430.315 400.493 429.534 395.989 429.168 391.338ZM446.048 432.562C442.267 427.96 439.12 423.139 436.584 418.098L455.317 398.521L446.048 432.562ZM533.618 486.23H562.817L529.057 508.534L533.618 486.23ZM539.18 458.982L564.548 479.777H534.96L539.18 458.982ZM569.939 489.273L574.696 512.649H534.57L569.939 489.273ZM544.815 455.257H562.987L566.622 473.154L544.815 455.257ZM542.692 448.804L557.962 430.517L561.694 448.804H542.692ZM556.108 421.361L556.328 422.408L543.522 437.773L546.864 421.361H556.108ZM535.057 519.127H576.013L581.989 548.517L535.057 519.127Z",
    fill: "#84C5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.373 404.389L110.036 318.677L116.939 255.611L106.865 259.896C106.036 260.237 86.5458 268.638 69.1293 286.56C58.7624 297.225 51.2982 309.059 46.9074 321.745C41.419 337.67 40.8092 354.837 45.1512 372.783L47.688 383.254L103.304 333.117L180.166 369.642V382.158C173.531 382.767 168.359 388.318 168.359 395.088V399.641H160.042V421.361H172.335L144.406 558.549C143.942 560.887 145.43 563.151 147.772 563.614C150.114 564.077 152.382 562.591 152.846 560.254L160.773 521.342L218.072 557.234L218.682 560.278C219.097 562.323 220.902 563.736 222.902 563.736C223.195 563.736 223.487 563.711 223.756 563.638C226.097 563.176 227.585 560.887 227.122 558.574L199.192 421.361H211.486V399.641H203.168V395.112C203.168 388.343 197.972 382.791 191.362 382.182V374.975L265.589 410.233V495.41H256.003V563.517H268.565C268.98 563.663 269.443 563.736 269.907 563.736C270.37 563.736 270.834 563.663 271.249 563.517H283.811V495.41H274.224V414.324L283.543 418.756C284.64 419.292 285.811 419.535 286.958 419.535C289.933 419.535 292.787 417.855 294.153 415.006C296.032 411.013 294.349 406.264 290.373 404.389ZM63.7873 315.049L80.8867 322.257L58.4453 327.662C59.7869 323.353 61.5675 319.14 63.7873 315.049ZM55.6645 358.83C54.9815 352.913 54.9327 347.167 55.5425 341.542L81.9112 335.187L55.6645 358.83ZM70.8612 304.14C73.0322 301.291 75.4471 298.491 78.0571 295.764C78.2279 295.594 78.3986 295.423 78.545 295.253L87.0093 310.958L70.8612 304.14ZM98.5959 305.407L88.3509 286.414C93.1807 282.542 97.8153 279.449 101.694 277.112L98.5959 305.407ZM181.141 421.361H190.411L190.63 422.408L177.799 437.773L181.141 421.361ZM173.482 458.982L198.851 479.777H169.238L173.482 458.982ZM167.92 486.23H197.119L163.359 508.534L167.92 486.23ZM216.291 548.517L169.36 519.127H210.315L216.291 548.517ZM208.998 512.674H168.872L204.241 489.298L208.998 512.674ZM200.948 473.154L179.117 455.257H197.314L200.948 473.154ZM192.264 430.517L195.997 448.804H176.995L192.264 430.517Z",
    fill: "#84C5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.574 527.6H335.426V540.822H345.574V527.6Z",
    fill: "#F9B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.478 546.593H322.522C322.522 540.993 327.06 536.464 332.67 536.464H348.33C353.94 536.464 358.478 540.993 358.478 546.593Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 413.521V477.683H490.053V571.406C490.053 579.661 487.296 587.282 482.662 593.418C475.978 602.233 465.391 607.931 453.463 607.931H228.025C216.096 607.931 205.51 602.233 198.826 593.418C194.192 587.306 191.435 579.685 191.435 571.406V477.683H-1V413.521H219.121C239.318 413.521 255.71 429.884 255.71 450.046V543.769H425.777V450.046C425.777 429.884 442.169 413.521 462.367 413.521H682Z",
    fill: "#FFC05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 463.17H490.053V477.683H596.869V607.931H606.236V477.683H681.829L682 463.17Z",
    fill: "#F9B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6377 532.346V541.696H79.5424V532.346H58.6377Z",
    fill: "#F9B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.582 463.17H-1V477.683H74.7154V607.931H84.0823V477.683H191.386L191.582 463.17Z",
    fill: "#F9B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5184 547.446C60.104 547.446 62.2018 545.351 62.2018 542.77V531.277C62.2018 528.696 60.104 526.602 57.5184 526.602C54.9327 526.602 52.835 528.696 52.835 531.277V542.77C52.835 545.351 54.9327 547.446 57.5184 547.446Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.661 593.418C475.978 602.233 465.391 607.931 453.463 607.931H228.024C216.096 607.931 205.51 602.233 198.826 593.418H482.661Z",
    fill: "#F9B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3 481.335C65.2754 481.335 63.6411 479.704 63.6411 477.683V413.521C63.6411 411.499 65.2754 409.868 67.3 409.868C69.3246 409.868 70.959 411.499 70.959 413.521V477.683C70.959 479.704 69.3246 481.335 67.3 481.335Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6931 481.335C89.6685 481.335 88.0342 479.704 88.0342 477.683V413.521C88.0342 411.499 89.6685 409.868 91.6931 409.868C93.7177 409.868 95.352 411.499 95.352 413.521V477.683C95.352 479.704 93.7177 481.335 91.6931 481.335Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 502.081H191.557C189.533 502.081 187.898 500.45 187.898 498.429C187.898 496.408 189.533 494.776 191.557 494.776H255.833C257.857 494.776 259.491 496.408 259.491 498.429C259.491 500.45 257.857 502.081 255.833 502.081Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.833 526.432H191.557C189.533 526.432 187.898 524.8 187.898 522.779C187.898 520.758 189.533 519.127 191.557 519.127H255.833C257.857 519.127 259.491 520.758 259.491 522.779C259.491 524.8 257.857 526.432 255.833 526.432Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.565 502.081H425.29C423.265 502.081 421.631 500.45 421.631 498.429C421.631 496.408 423.265 494.776 425.29 494.776H489.565C491.59 494.776 493.224 496.408 493.224 498.429C493.224 500.45 491.59 502.081 489.565 502.081Z",
    fill: "#F48C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.565 526.432H425.29C423.265 526.432 421.631 524.8 421.631 522.779C421.631 520.758 423.265 519.127 425.29 519.127H489.565C491.59 519.127 493.224 520.758 493.224 522.779C493.224 524.8 491.59 526.432 489.565 526.432Z",
    fill: "#F48C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.307 481.335C587.283 481.335 585.648 479.704 585.648 477.683V413.521C585.648 411.499 587.283 409.868 589.307 409.868C591.332 409.868 592.966 411.499 592.966 413.521V477.683C592.966 479.704 591.332 481.335 589.307 481.335Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.7 481.335C611.675 481.335 610.041 479.704 610.041 477.683V413.521C610.041 411.499 611.675 409.868 613.7 409.868C615.725 409.868 617.359 411.499 617.359 413.521V477.683C617.359 479.704 615.725 481.335 613.7 481.335Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.286 611.583C387.261 611.583 385.627 609.952 385.627 607.931V543.769C385.627 541.748 387.261 540.116 389.286 540.116C391.31 540.116 392.945 541.748 392.945 543.769V607.931C392.945 609.952 391.31 611.583 389.286 611.583Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.812 611.583C289.787 611.583 288.153 609.952 288.153 607.931V543.769C288.153 541.748 289.787 540.116 291.812 540.116C293.836 540.116 295.471 541.748 295.471 543.769V607.931C295.471 609.952 293.836 611.583 291.812 611.583Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.441 586.6C477.539 579.417 477.539 568.825 471.441 561.642C472.295 560.595 475.222 558.817 473.587 557.259C472.051 555.627 470.221 558.549 469.197 559.401C462.001 553.314 451.39 553.314 444.194 559.401C443.145 558.549 441.364 555.627 439.803 557.259C438.169 558.793 441.096 560.619 441.95 561.642C435.876 568.508 435.876 579.734 441.95 586.6C441.096 587.647 438.193 589.425 439.803 590.983C441.34 592.615 443.17 589.693 444.194 588.841C451.073 594.904 462.318 594.904 469.197 588.841C470.246 589.693 472.026 592.59 473.587 590.983C475.197 589.449 472.295 587.647 471.441 586.6ZM467.977 583.167L460.586 575.789C461.025 574.742 461.025 573.549 460.586 572.502L467.977 565.124C472.197 570.359 472.197 577.907 467.977 583.167ZM456.708 559.718C459.903 559.718 463.123 560.765 465.733 562.883L458.342 570.262C457.293 569.823 456.098 569.823 455.049 570.262L447.658 562.883C450.292 560.765 453.488 559.718 456.708 559.718ZM442.243 574.133C442.243 570.822 443.365 567.656 445.414 565.124L452.805 572.502C452.366 573.549 452.366 574.742 452.805 575.789L445.414 583.167C443.365 580.61 442.243 577.469 442.243 574.133ZM456.708 588.573C453.39 588.573 450.219 587.453 447.682 585.407L455.073 578.029C456.122 578.467 457.317 578.467 458.366 578.029L465.757 585.407C463.172 587.453 460.025 588.573 456.708 588.573Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.836 558.397C283.512 556.724 283.512 554.01 281.836 552.337C280.159 550.663 277.441 550.663 275.764 552.337C274.088 554.01 274.088 556.724 275.764 558.397C277.441 560.071 280.159 560.071 281.836 558.397Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.995 576.879C283.539 574.576 282.111 572.268 279.803 571.724C277.496 571.18 275.183 572.606 274.638 574.91C274.094 577.213 275.522 579.521 277.83 580.065C280.137 580.609 282.45 579.183 282.995 576.879Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.811 600.626C281.182 600.626 283.104 598.707 283.104 596.34C283.104 593.973 281.182 592.055 278.811 592.055C276.44 592.055 274.518 593.973 274.518 596.34C274.518 598.707 276.44 600.626 278.811 600.626Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.146 536.624C482.691 534.321 481.262 532.013 478.955 531.469C476.647 530.925 474.335 532.351 473.79 534.655C473.245 536.958 474.674 539.266 476.982 539.81C479.289 540.354 481.602 538.928 482.146 536.624Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.474 538.633C462.151 536.959 462.151 534.246 460.474 532.572C458.798 530.899 456.079 530.899 454.403 532.572C452.726 534.246 452.726 536.959 454.403 538.633C456.079 540.306 458.798 540.306 460.474 538.633Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.194 556.397C406.739 554.094 405.31 551.786 403.002 551.242C400.695 550.698 398.383 552.124 397.838 554.428C397.293 556.731 398.722 559.039 401.029 559.583C403.337 560.127 405.649 558.701 406.194 556.397Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.056 578.897C406.732 577.223 406.732 574.51 405.056 572.836C403.379 571.162 400.661 571.162 398.984 572.836C397.308 574.51 397.308 577.223 398.984 578.897C400.661 580.57 403.379 580.57 405.056 578.897Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.019 600.626C404.39 600.626 406.312 598.707 406.312 596.34C406.312 593.973 404.39 592.055 402.019 592.055C399.648 592.055 397.726 593.973 397.726 596.34C397.726 598.707 399.648 600.626 402.019 600.626Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.859 539.566C248.051 538.665 249.096 536.16 248.193 533.971C247.29 531.783 244.781 530.74 242.589 531.641C240.396 532.543 239.351 535.048 240.254 537.236C241.158 539.425 243.667 540.468 245.859 539.566Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.707 539.897C226.078 539.897 228 537.978 228 535.611C228 533.245 226.078 531.326 223.707 531.326C221.336 531.326 219.414 533.245 219.414 535.611C219.414 537.978 221.336 539.897 223.707 539.897Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.361 536.595C207.91 534.293 206.485 531.982 204.179 531.434C201.872 530.886 199.557 532.309 199.009 534.611C198.46 536.914 199.884 539.224 202.191 539.772C204.498 540.32 206.812 538.898 207.361 536.595Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.463 486.028C248.843 483.692 247.254 481.49 244.913 481.111C242.573 480.732 240.367 482.319 239.988 484.655C239.608 486.991 241.197 489.193 243.538 489.572C245.878 489.951 248.083 488.364 248.463 486.028Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.707 489.614C226.078 489.614 228 487.696 228 485.329C228 482.962 226.078 481.043 223.707 481.043C221.336 481.043 219.414 482.962 219.414 485.329C219.414 487.696 221.336 489.614 223.707 489.614Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41 486.036C207.792 483.7 206.204 481.497 203.864 481.116C201.524 480.734 199.318 482.319 198.936 484.655C198.554 486.991 200.141 489.193 202.481 489.575C204.821 489.956 207.028 488.371 207.41 486.036Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.901 539.897C439.272 539.897 441.194 537.978 441.194 535.611C441.194 533.245 439.272 531.326 436.901 531.326C434.53 531.326 432.607 533.245 432.607 535.611C432.607 537.978 434.53 539.897 436.901 539.897Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.194 486.018C482.573 483.681 480.984 481.48 478.644 481.101C476.303 480.722 474.098 482.308 473.718 484.645C473.338 486.981 474.928 489.182 477.268 489.561C479.608 489.941 481.814 488.354 482.194 486.018Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.092 489.283C461.283 488.377 462.323 485.87 461.416 483.684C460.508 481.497 457.997 480.459 455.806 481.364C453.616 482.27 452.575 484.777 453.483 486.964C454.39 489.151 456.902 490.189 459.092 489.283Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.901 489.614C439.272 489.614 441.194 487.696 441.194 485.329C441.194 482.962 439.272 481.043 436.901 481.043C434.53 481.043 432.607 482.962 432.607 485.329C432.607 487.696 434.53 489.614 436.901 489.614Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.379 429.421C578.75 429.421 580.672 427.502 580.672 425.136C580.672 422.769 578.75 420.85 576.379 420.85C574.008 420.85 572.086 422.769 572.086 425.136C572.086 427.502 574.008 429.421 576.379 429.421Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.379 449.899C578.75 449.899 580.672 447.981 580.672 445.614C580.672 443.247 578.75 441.328 576.379 441.328C574.008 441.328 572.086 443.247 572.086 445.614C572.086 447.981 574.008 449.899 576.379 449.899Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.038 470.05C580.228 469.144 581.268 466.637 580.361 464.45C579.454 462.263 576.942 461.225 574.752 462.131C572.561 463.037 571.521 465.544 572.428 467.73C573.336 469.917 575.847 470.955 578.038 470.05Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.482 429.421C628.853 429.421 630.775 427.502 630.775 425.136C630.775 422.769 628.853 420.85 626.482 420.85C624.111 420.85 622.189 422.769 622.189 425.136C622.189 427.502 624.111 429.421 626.482 429.421Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.482 449.899C628.853 449.899 630.775 447.981 630.775 445.614C630.775 443.247 628.853 441.328 626.482 441.328C624.111 441.328 622.189 443.247 622.189 445.614C622.189 447.981 624.111 449.899 626.482 449.899Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.141 470.045C630.331 469.14 631.371 466.632 630.464 464.446C629.557 462.259 627.045 461.221 624.855 462.126C622.664 463.032 621.624 465.539 622.531 467.726C623.439 469.913 625.95 470.951 628.141 470.045Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4694 429.421C56.8404 429.421 58.7626 427.502 58.7626 425.136C58.7626 422.769 56.8404 420.85 54.4694 420.85C52.0984 420.85 50.1763 422.769 50.1763 425.136C50.1763 427.502 52.0984 429.421 54.4694 429.421Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4694 449.899C56.8404 449.899 58.7626 447.981 58.7626 445.614C58.7626 443.247 56.8404 441.328 54.4694 441.328C52.0984 441.328 50.1763 443.247 50.1763 445.614C50.1763 447.981 52.0984 449.899 54.4694 449.899Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0941 470.066C58.2888 469.17 59.3402 466.668 58.4425 464.477C57.5448 462.286 55.038 461.237 52.8434 462.133C50.6487 463.029 49.5973 465.531 50.495 467.722C51.3927 469.913 53.8995 470.962 56.0941 470.066Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.548 429.421C106.919 429.421 108.841 427.502 108.841 425.136C108.841 422.769 106.919 420.85 104.548 420.85C102.177 420.85 100.255 422.769 100.255 425.136C100.255 427.502 102.177 429.421 104.548 429.421Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.548 449.899C106.919 449.899 108.841 447.981 108.841 445.614C108.841 443.247 106.919 441.328 104.548 441.328C102.177 441.328 100.255 443.247 100.255 445.614C100.255 447.981 102.177 449.899 104.548 449.899Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.176 470.072C108.371 469.176 109.422 466.674 108.525 464.483C107.627 462.292 105.12 461.243 102.925 462.139C100.731 463.035 99.6794 465.537 100.577 467.728C101.475 469.919 103.982 470.968 106.176 470.072Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.547 532.07V541.42H622.452V532.07H601.547Z",
    fill: "#F9B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.555 547.178C620.969 547.178 618.871 545.084 618.871 542.503V530.985C618.871 528.404 620.969 526.31 623.555 526.31C626.14 526.31 628.238 528.404 628.238 530.985V542.478C628.262 545.084 626.165 547.178 623.555 547.178Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.553 597.412H595.527C592.039 597.412 589.209 600.236 589.209 603.718V607.955H613.846V603.718C613.871 600.236 611.041 597.412 607.553 597.412Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.424 597.412H73.3983C69.9101 597.412 67.0806 600.236 67.0806 603.718V607.955H91.7174V603.718C91.7174 600.236 88.9122 597.412 85.424 597.412Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.552 549.929C608.854 549.929 614.773 544.02 614.773 536.732C614.773 529.443 608.854 523.534 601.552 523.534C594.251 523.534 588.332 529.443 588.332 536.732C588.332 544.02 594.251 549.929 601.552 549.929Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.552 546.496C606.955 546.496 611.334 542.124 611.334 536.732C611.334 531.339 606.955 526.967 601.552 526.967C596.15 526.967 591.771 531.339 591.771 536.732C591.771 542.124 596.15 546.496 601.552 546.496Z",
    fill: "#F8FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.747 535.928L605.748 532.251C605.845 532.178 605.967 532.202 606.04 532.3C606.089 532.373 606.089 532.47 606.04 532.543L602.357 537.535C601.991 538.046 601.259 538.168 600.747 537.779C600.235 537.413 600.113 536.683 600.503 536.172C600.576 536.098 600.65 536.001 600.747 535.928Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3987 549.929C86.7004 549.929 92.6196 544.02 92.6196 536.732C92.6196 529.443 86.7004 523.534 79.3987 523.534C72.0969 523.534 66.1777 529.443 66.1777 536.732C66.1777 544.02 72.0969 549.929 79.3987 549.929Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3987 546.496C84.8009 546.496 89.1803 542.124 89.1803 536.732C89.1803 531.339 84.8009 526.967 79.3987 526.967C73.9965 526.967 69.6172 531.339 69.6172 536.732C69.6172 542.124 73.9965 546.496 79.3987 546.496Z",
    fill: "#F8FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5938 535.928L83.5944 532.251C83.6919 532.178 83.8139 532.202 83.8871 532.3C83.9359 532.373 83.9359 532.47 83.8871 532.543L80.2038 537.535C79.8379 538.046 79.1061 538.168 78.5938 537.779C78.0816 537.413 77.9596 536.683 78.3499 536.172C78.4231 536.098 78.4963 536.001 78.5938 535.928Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.504 525.656C365.344 516.832 365.344 502.525 356.504 493.7C347.664 484.876 333.331 484.876 324.491 493.7C315.651 502.525 315.651 516.832 324.491 525.656C333.331 534.481 347.664 534.481 356.504 525.656Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.03 512.353C358.51 503.247 352.315 494.667 343.193 493.189C334.071 491.711 325.475 497.895 323.995 507.001C322.514 516.108 328.709 524.688 337.832 526.166C346.954 527.644 355.549 521.46 357.03 512.353Z",
    fill: "#F8FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 508.291L347.671 502.008C347.842 501.887 348.062 501.935 348.184 502.082C348.281 502.203 348.281 502.374 348.184 502.52L341.89 511.067C341.232 511.943 340.012 512.138 339.134 511.481C338.256 510.848 338.06 509.606 338.719 508.729C338.817 508.559 338.963 508.413 339.109 508.291Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.928 586.82C468.928 586.82 462.05 588.743 460.684 587.282L458.342 583.094C458.927 582.023 467.367 581.146 468.416 581.73C468.416 581.73 467.757 582.948 468.928 586.82Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.641 557.867C515.641 569.604 512.738 573.476 505.103 581.024C495.956 590.058 483.052 592.25 472.441 588.256C470.246 587.355 466.075 586.503 467.416 583.264C468.246 581.414 470.319 581.73 471.978 581.925C477.588 582.266 483.906 582.51 488.589 579.149C493.614 575.205 502.322 553.606 506.518 548.809C514.69 539.532 515.275 549.394 516.641 557.867Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.221 587.891C478.149 594.758 496.053 593.93 505.591 582.364C505.64 582.29 505.688 582.217 505.761 582.169C508.152 579.222 509.957 576.203 511.274 573.184C517.909 558.087 512.835 543.379 512.933 543.33C502.566 546.691 493.077 572.867 487.174 577.031C484.223 579.685 473.758 578.735 471.977 581.95C472.002 581.925 472.343 585.553 471.221 587.891Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.978 672.264H497.761C498.663 672.264 499.371 671.509 499.322 670.608C499.298 670.17 499.249 669.658 499.151 669.074C498.859 667.418 498.737 665.762 498.785 664.082C498.81 663.279 498.859 662.475 498.932 661.696L500.347 647.841C500.444 646.915 499.712 646.112 498.785 646.112H490.053C489.101 646.112 488.37 646.94 488.492 647.865L490.077 660.503C490.419 663.254 488.638 665.835 485.93 666.517C484.003 667.004 482.027 667.272 480.637 667.637C480.466 667.686 480.271 667.735 480.1 667.783C478.612 668.197 477.393 668.757 476.685 669.804C475.954 670.851 476.71 672.264 477.978 672.264Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.907 670.218C499.859 671.192 499.371 672.288 498.249 672.264H477.734C476.685 672.264 475.929 671.217 476.295 670.218C477.1 667.978 479.93 664.666 489.614 664.106C491.004 664.253 494.175 664.715 498.785 664.082C498.785 664.106 500.346 666.566 499.907 670.218Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.613 669.512C482.661 669.512 482.735 669.512 482.783 669.488C483.003 669.39 483.125 669.147 483.027 668.928C482.1 666.615 480.344 665.908 480.271 665.884C480.051 665.787 479.783 665.908 479.71 666.128C479.612 666.347 479.734 666.59 479.954 666.688C480.002 666.712 481.442 667.296 482.222 669.244C482.271 669.39 482.442 669.512 482.613 669.512Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.003 669.098C486.052 669.098 486.101 669.098 486.125 669.074C486.345 669.001 486.491 668.757 486.418 668.538C485.613 665.957 483.393 664.788 483.296 664.74C483.076 664.618 482.808 664.715 482.71 664.934C482.588 665.153 482.686 665.421 482.906 665.519C482.93 665.519 484.881 666.59 485.589 668.806C485.638 668.976 485.808 669.098 486.003 669.098Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.858 668.611C489.906 668.611 489.955 668.611 490.004 668.587C490.224 668.514 490.345 668.27 490.272 668.027C489.37 665.397 487.296 664.033 487.223 663.96C487.028 663.839 486.76 663.887 486.613 664.082C486.491 664.277 486.54 664.545 486.735 664.691C486.76 664.715 488.638 665.981 489.443 668.319C489.516 668.514 489.687 668.611 489.858 668.611Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.295 670.218H499.907C499.81 670.949 499.615 671.631 499.249 672.264H477.71C476.661 672.264 475.905 671.241 476.271 670.243C476.271 670.243 476.295 670.243 476.295 670.218Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.113 669.804L586.136 652.199C585.722 651.396 584.721 651.104 583.941 651.542C583.551 651.761 583.136 652.029 582.648 652.394C581.306 653.392 579.867 654.269 578.379 655C577.672 655.34 575.916 654.732 575.159 655.024L563.158 654.05C562.28 654.391 561.914 655.389 562.329 656.217L565.085 661.598C565.524 662.451 566.988 663.449 567.768 662.938L579.014 663.23C581.624 663.23 584.551 663.23 586.38 665.324C587.673 666.834 588.819 668.441 589.795 669.512C589.917 669.658 590.039 669.78 590.161 669.926C591.21 671.046 592.259 671.898 593.527 672.069C594.771 672.239 595.698 670.924 595.113 669.804Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.331 651.225C584.209 650.836 585.428 650.763 585.916 651.761L595.234 670.024C595.722 670.973 595.112 672.118 594.064 672.239C591.697 672.556 587.453 671.533 582.55 663.157C582.038 661.866 581.013 658.823 578.379 655C578.379 655 579.867 652.467 583.331 651.225Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.527 666.931C590.502 666.882 590.478 666.834 590.429 666.809C590.258 666.663 589.966 666.663 589.819 666.858C588.185 668.733 588.356 670.608 588.356 670.681C588.38 670.924 588.6 671.095 588.819 671.071C589.063 671.046 589.234 670.827 589.209 670.608C589.209 670.535 589.087 669.001 590.453 667.418C590.6 667.272 590.624 667.077 590.527 666.931Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.624 664.082C588.6 664.033 588.575 664.009 588.551 663.985C588.38 663.814 588.112 663.814 587.941 663.985C585.99 665.884 585.965 668.368 585.941 668.489C585.941 668.733 586.136 668.928 586.38 668.928C586.624 668.928 586.819 668.733 586.819 668.489C586.819 668.465 586.868 666.249 588.551 664.618C588.697 664.472 588.722 664.253 588.624 664.082Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.453 660.868C586.429 660.819 586.405 660.795 586.356 660.746C586.185 660.576 585.917 660.576 585.746 660.771C583.819 662.767 583.526 665.227 583.502 665.324C583.477 665.567 583.648 665.787 583.892 665.811C584.136 665.835 584.356 665.665 584.38 665.421C584.38 665.397 584.673 663.157 586.38 661.355C586.527 661.233 586.551 661.038 586.453 660.868Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.064 672.215L583.331 651.201C584.014 650.957 584.721 650.811 585.453 650.86L595.235 670.023C595.698 670.949 595.137 672.093 594.088 672.215H594.064Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.69 542.6C514.153 538.631 513.226 532.543 513.153 529.987C512.933 524.922 521.032 524.776 521.007 529.816C520.715 529.719 522.227 538.607 523.398 540.871C527.862 541.017 522.154 552.072 518.202 553.509C515.348 554.556 513.909 547.324 515.69 542.6Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.982 529.402C520.982 529.451 521.007 529.524 521.007 529.573C521.007 529.646 521.007 529.743 521.031 529.816C520.812 529.743 521.592 534.662 522.495 538.144C519.617 540.481 515.787 540.798 515.079 540.822C513.957 537.194 513.348 532.47 513.201 530.693C513.177 530.279 513.177 530.011 513.177 529.962C513.177 529.841 513.177 529.743 513.177 529.621C513.25 528.428 513.86 527.381 514.762 526.724C515.397 526.261 516.177 525.993 517.006 525.969C517.836 525.945 518.616 526.188 519.251 526.626C519.275 526.651 519.299 526.651 519.324 526.675C520.226 527.308 520.836 528.282 520.982 529.402Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.883 527.308C504.883 527.308 503.151 523.436 503.127 520.247L505.835 520.295L504.883 527.308Z",
    fill: "#163260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.055 538.558C515.031 540.311 520.641 538.314 523.495 534.297C523.69 533.98 523.885 533.663 524.032 533.323C530.545 515.304 504.469 502.861 505.078 523.997C504.859 530.157 501.615 534.881 510.055 538.558Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.006 532.373L512.835 530.717C512.835 530.717 513.104 532.276 511.982 532.787C510.884 533.25 510.006 532.373 510.006 532.373Z",
    fill: "#F9F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.689 526.115C510.445 525.92 510.421 525.579 510.592 525.36C510.787 525.117 511.128 525.092 511.348 525.263C511.592 525.458 511.616 525.798 511.445 526.018C511.275 526.261 510.933 526.285 510.689 526.115Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.225 527.333C505.981 527.138 505.957 526.797 506.128 526.578C506.323 526.334 506.664 526.31 506.884 526.48C507.128 526.675 507.152 527.016 506.981 527.235C506.811 527.479 506.469 527.527 506.225 527.333Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.494 530.985C509.786 530.888 510.079 530.741 510.299 530.547C510.372 530.474 510.396 530.352 510.299 530.254C510.226 530.181 510.079 530.157 510.006 530.254C509.469 530.741 508.445 530.839 508.201 530.62C508.103 530.547 508.201 530.376 508.298 530.254C509.079 529.183 508.86 526.87 508.86 526.772C508.86 526.651 508.738 526.578 508.64 526.578C508.518 526.578 508.445 526.699 508.445 526.797C508.445 526.821 508.664 529.061 507.957 529.987C507.567 530.498 507.811 530.79 507.933 530.888C508.225 531.18 508.884 531.18 509.494 530.985Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.103 522.511C507.128 519.857 512.543 518.907 514.909 517.763C514.909 517.763 516.299 522.049 521.739 523.047C523.812 526.626 525.203 527.966 523.471 534.297C523.666 533.98 523.861 533.664 524.007 533.323C530.398 516.083 505.64 503.153 505.103 522.511Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.127 516.18C509.713 503.616 524.983 513.794 525.861 517.032C526.959 521.05 525.91 523.607 525.91 523.607L522.08 521.829C517.299 520.636 515.494 516.472 515.494 516.472C514.738 516.862 513.909 517.203 513.104 517.373C510.591 517.836 507.176 519.102 505.079 521.196C502.981 523.266 500.298 521.61 503.127 516.18Z",
    fill: "#163260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.862 522.998C527.252 524.703 526.471 526.359 525.081 526.675C523.691 526.992 522.251 525.872 521.861 524.167C521.471 522.463 522.251 520.807 523.642 520.49C525.008 520.174 526.447 521.294 526.862 522.998Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.91 522.341C522.959 522.292 523.886 521.318 524.813 521.61C525.056 521.683 525.252 521.829 525.422 522.073C525.447 522.097 525.447 522.122 525.471 522.122C525.788 522.536 526.008 523.217 526.13 524.094C526.154 524.191 526.081 524.289 525.983 524.313H525.959C525.837 524.337 525.739 524.24 525.715 524.143C525.617 523.412 525.447 522.876 525.227 522.511C524.251 523.193 524.276 524.654 524.276 524.678C524.276 524.776 524.227 524.849 524.13 524.873C524.105 524.873 524.081 524.873 524.081 524.873C523.959 524.873 523.861 524.8 523.861 524.678C523.861 524.605 523.812 522.998 524.983 522.17C524.886 522.097 524.788 522.024 524.691 521.975C524.008 521.756 523.203 522.584 523.203 522.584C523.129 522.657 522.983 522.657 522.91 522.584C522.837 522.536 522.837 522.414 522.91 522.341Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.084 598.897C536.936 605.813 521.788 605.155 508.811 591.86C505.298 583.898 507.859 579.174 507.079 570.676C505.932 558.16 507.811 549.369 513.299 544.378C514.031 543.72 514.811 543.136 515.665 542.6C515.738 548.468 523.105 543.915 523.276 540.603C523.276 540.603 524.422 540.53 526.252 540.676C531.35 541.09 541.692 543.257 546.376 553.679C547.595 556.382 548.815 564.418 550.888 570.189C553.474 577.347 559.084 598.897 559.084 598.897Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.251 540.676C525.959 541.261 523.032 547.08 518.568 547.397C515.372 547.616 513.933 545.668 513.323 544.378C514.055 543.72 514.836 543.136 515.689 542.6C515.763 548.468 523.129 543.915 523.3 540.603C523.3 540.603 524.446 540.53 526.251 540.676Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.037 650.13C574.037 650.13 572.452 650.227 570.037 650.276C562.573 650.495 547.254 650.495 547.303 647.013C547.425 639.367 555.328 626.729 558.889 614.457C560.426 609.124 560.133 603.986 559.304 599.92C559.231 599.579 559.158 599.238 559.084 598.897C558.255 593.224 555.523 585.675 555.523 585.675C555.523 585.675 551.376 586.673 541.326 583.264C531.277 579.855 525.983 562.153 525.983 562.153C525.691 558.5 525.154 549.515 526.252 540.628C526.252 540.628 524.593 540.165 523.276 540.603C523.276 540.603 520.666 550.221 521.227 562.957C517.543 563.444 513.836 563.663 511.079 563.76C510.957 560.668 511.079 551.585 515.665 542.6C515.665 542.6 514.055 542.405 512.933 543.306C512.933 543.306 505.737 552.608 506.615 566.926C506.518 572.745 506.371 584.945 506.786 587.574C506.932 588.548 507.25 590.058 508.03 591.763C494.541 592.566 482.393 597.874 481.369 612.801C480.759 617.525 484.564 643.555 486.101 653.806C486.491 656.387 486.735 657.97 486.735 657.97C486.735 657.97 493.931 661.038 504.176 658.165C504.762 652.613 505.298 643.044 504.347 635.933C503.615 628.482 503.371 622.882 509.835 621.543C511.665 621.202 516.836 621.202 521.788 621.275C521.056 627.167 520.495 632.963 520.349 637.394C519.812 653.782 523.203 671.363 542.351 672.069C555.645 672.556 568.037 669.342 574.354 667.345C577.135 666.468 578.745 665.811 578.745 665.811C579.16 655.998 574.037 650.13 574.037 650.13Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.811 523.729C512.738 523.777 512.64 523.802 512.543 523.753C511.03 522.95 509.591 523.534 509.591 523.534C509.469 523.583 509.299 523.534 509.25 523.388C509.201 523.266 509.25 523.096 509.396 523.047C509.469 523.023 511.055 522.365 512.811 523.266C512.933 523.339 512.982 523.485 512.909 523.607C512.86 523.656 512.835 523.704 512.811 523.729Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.81 523.753C507.762 523.777 507.737 523.802 507.688 523.802C506.078 523.875 505.664 524.849 505.639 524.849C505.591 524.971 505.42 525.044 505.298 524.995C505.176 524.946 505.103 524.776 505.152 524.654C505.176 524.605 505.713 523.388 507.64 523.29C507.786 523.29 507.908 523.388 507.908 523.534C507.932 523.631 507.883 523.704 507.81 523.753Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.225 592.274C502.225 592.274 496.053 589.815 491.345 592.664C487.711 594.855 488.028 598.605 488.028 598.605C488.028 598.605 497.102 600.675 502.859 598.288L502.225 592.274Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.255 591.008C557.255 591.008 530.081 596.292 507.713 591.056V596.827C507.713 596.827 536.692 601.43 558.84 597.899C558.84 597.874 558.987 594.709 557.255 591.008Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.786 591.811L501.639 592.323V598.069L507.03 599.092L506.786 591.811Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.03 599.092C517.568 606.567 543.839 595.586 548.766 581.852C555.498 563.078 545.985 539.386 526.3 540.628C526.3 540.628 524.373 551.025 526.666 567.193C529.837 589.62 509.567 586.6 506.469 592.298C505.322 594.368 507.03 599.092 507.03 599.092Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.33 667.345C577.111 666.468 578.721 665.811 578.721 665.811C579.16 655.998 574.037 650.13 574.037 650.13C574.037 650.13 572.452 650.227 570.037 650.276C570.061 650.276 575.745 657.751 574.33 667.345Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.101 653.831C486.491 656.412 486.735 657.995 486.735 657.995C486.735 657.995 493.931 661.063 504.176 658.189C504.176 658.189 504.396 656.29 504.566 653.392C504.566 653.392 496.688 656.948 486.101 653.831Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.321 597.655C488.345 597.655 488.394 597.655 488.418 597.655C490.784 596.754 494.736 596.779 494.785 596.779C494.882 596.779 494.956 596.706 494.956 596.608C494.956 596.511 494.882 596.438 494.785 596.438C494.614 596.438 490.736 596.413 488.296 597.339C488.199 597.363 488.15 597.485 488.199 597.558C488.223 597.607 488.272 597.655 488.321 597.655Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.906 596C488.955 596 488.979 596 489.028 595.975C490.931 595.05 494.126 594.806 494.175 594.806C494.273 594.806 494.346 594.709 494.346 594.612C494.346 594.514 494.248 594.441 494.151 594.441C494.029 594.441 490.833 594.66 488.882 595.634C488.784 595.683 488.76 595.78 488.809 595.878C488.809 595.951 488.857 596 488.906 596Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.175 594.149C490.199 594.149 490.248 594.149 490.272 594.149C491.76 593.516 493.785 593.102 493.809 593.102C493.907 593.077 493.956 592.98 493.956 592.907C493.931 592.81 493.834 592.761 493.761 592.761C493.736 592.761 491.687 593.175 490.175 593.832C490.077 593.881 490.053 593.978 490.077 594.051C490.077 594.1 490.126 594.125 490.175 594.149Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.006 532.568C509.932 532.568 509.859 532.543 509.835 532.47C509.786 532.373 509.811 532.251 509.908 532.178L512.738 530.522C512.835 530.474 512.957 530.498 513.03 530.595C513.079 530.693 513.055 530.815 512.957 530.888L510.128 532.543C510.079 532.568 510.03 532.568 510.006 532.568Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.538 589.936C471.246 588.061 468.88 587.355 466.831 588.037L460.659 578.687C462.854 576.349 462.025 572.137 459 570.846C457.415 570.115 456.293 572.575 457.878 573.281C458.269 573.451 458.586 573.719 458.83 574.085C460.562 576.52 456.683 579.198 455.024 576.69C454.439 575.789 454.756 574.109 453.219 574.182C452.488 574.206 451.902 574.839 451.927 575.57C451.975 578.784 455.439 581.17 458.415 580.148L464.611 589.547C462.367 591.957 463.513 596.73 466.904 597.412C468.294 597.461 468.758 595.391 467.465 594.855C467.074 594.685 466.757 594.417 466.513 594.052C464.782 591.617 468.66 588.938 470.319 591.446C470.904 592.347 470.587 594.027 472.124 593.954C474.197 593.711 473.343 591.056 472.538 589.936Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.952 588.524C463.855 588.597 463.83 588.597 463.782 588.621C463.733 588.646 463.684 588.67 463.66 588.694C463.562 588.743 463.489 588.768 463.391 588.816C463.221 588.889 463.025 588.938 462.83 588.962C462.635 588.987 462.44 588.987 462.245 588.962C462.05 588.938 461.879 588.889 461.708 588.816C461.22 588.597 461.098 588.013 461.391 587.501C461.611 587.136 461.976 586.917 462.342 586.868L462.903 586.82C462.903 586.82 462.903 586.82 462.928 586.82H462.952L462.903 586.844C463.44 586.479 464.099 586.552 464.391 587.014C464.684 587.477 464.489 588.159 463.952 588.524Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.66 587.501C462.562 587.526 462.538 587.55 462.489 587.55L462.367 587.599C462.269 587.623 462.196 587.647 462.099 587.647C461.928 587.672 461.733 587.696 461.562 587.696C461.367 587.696 461.172 587.672 460.976 587.599C460.781 587.55 460.586 587.428 460.415 587.307C459.976 586.966 459.976 586.308 460.391 585.821C460.806 585.334 461.513 585.212 461.952 585.553C461.928 585.529 461.928 585.553 461.977 585.553C462.001 585.553 462.05 585.553 462.074 585.553C462.099 585.553 462.123 585.553 462.147 585.529H462.172C462.757 585.31 463.343 585.553 463.489 586.089C463.611 586.649 463.245 587.282 462.66 587.501Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.074 586.235L459.976 586.211C459.366 586.186 458.976 585.699 459.098 585.139C459.22 584.555 459.805 584.092 460.415 584.117L461.513 584.141C462.123 584.165 462.513 584.652 462.391 585.212C462.269 585.797 461.684 586.26 461.074 586.235Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.049 584.774L458.952 584.75C458.342 584.725 457.952 584.238 458.074 583.678C458.196 583.094 458.781 582.631 459.391 582.656L460.488 582.68C461.098 582.704 461.489 583.191 461.367 583.751C461.245 584.336 460.659 584.799 460.049 584.774Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.245 584.36C464.391 583.167 462.391 581.974 460.147 582.12C459.513 582.169 458.586 582.704 458.293 581.803C458.049 580.902 459.196 580.659 459.83 580.464C462.367 579.831 465.562 580.075 469.294 581.852C472.124 583.216 468.392 585.943 466.245 584.36Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.861 517.008C525.861 517.008 515.689 511.724 502.468 520.563C502.468 520.563 497.907 507.195 513.079 504.76C522.08 503.323 525.861 517.008 525.861 517.008Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.86 515.523C519.86 515.523 515.299 514.5 511.664 515.084C508.03 515.669 501.956 517.982 500.297 520.539C498.639 523.096 502.493 520.563 502.493 520.563C502.493 520.563 510.323 514.963 519.86 515.523Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.908 506.318C507.908 506.318 502.542 510.531 503.42 517.982C503.42 517.982 509.494 515.547 509.689 515.523C509.86 515.474 508.103 509.265 512.031 504.93C512.055 504.906 509.591 504.565 507.908 506.318Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.274 624.489C506.25 622.784 507.786 621.859 509.835 621.567C512.763 621.129 516.47 621.153 521.788 621.299L522.3 616.332C522.3 616.332 507.884 616.551 505.274 624.489Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.26 487.715C152.26 487.715 172.116 492.317 179.263 519.93L159.944 523.997L152.26 487.715Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.355 670.778L129.014 670.584C129.014 670.827 128.721 671.679 128.453 671.679L118.086 671.898C117.842 671.898 117.696 671.436 117.696 671.192L116.817 670.949C116.817 669.39 116.939 668.83 117.622 667.637C118.5 666.079 118.866 664.204 118.72 662.353L117.232 645.406C117.208 645.138 117.403 644.919 117.671 644.919H128.282C128.55 644.919 128.745 645.138 128.721 645.406L127.355 662.499C127.209 664.301 127.55 666.103 128.404 667.613C128.404 667.613 128.404 667.613 128.404 667.637C129.111 668.855 129.355 669.244 129.355 670.778Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.726 672.264H155.066C154.114 672.264 153.383 671.485 153.431 670.535C153.456 670.072 153.505 669.537 153.627 668.928C153.919 667.199 154.041 665.47 154.017 663.717C153.992 662.889 153.944 662.037 153.87 661.209L152.383 646.721C152.285 645.747 153.041 644.919 154.017 644.919H163.14C164.14 644.919 164.896 645.795 164.774 646.769L163.115 659.967C162.749 662.865 164.628 665.543 167.457 666.249C169.482 666.761 171.531 667.053 172.994 667.418C173.19 667.467 173.36 667.516 173.556 667.564C175.117 668.003 176.385 668.587 177.141 669.683C177.824 670.803 177.044 672.264 175.726 672.264Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.797 670.121C152.846 670.462 152.895 670.778 152.992 671.095C153.188 671.777 153.822 672.264 154.529 672.264H175.97C177.068 672.264 177.849 671.192 177.483 670.17C177.483 670.145 177.483 670.145 177.458 670.121C176.629 667.783 173.678 664.301 163.554 663.741C163.408 663.741 163.237 663.741 163.091 663.79C162.335 663.985 159.505 664.52 155.237 663.936C154.48 663.839 153.749 664.277 153.505 665.007C153.09 666.249 152.578 668.246 152.797 670.121Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.427 672.264H127.599C128.746 672.264 129.672 671.314 129.624 670.17C129.624 670.145 129.624 670.145 129.624 670.121C129.502 667.613 128.453 663.766 123.013 663.717C117.574 663.668 116.5 667.564 116.403 670.121C116.403 670.145 116.403 670.145 116.403 670.17C116.354 671.314 117.281 672.264 118.427 672.264Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.872 669.366C171.043 669.366 171.214 669.269 171.287 669.074C172.116 667.053 173.604 666.42 173.653 666.395C173.897 666.298 173.994 666.03 173.897 665.811C173.799 665.567 173.531 665.47 173.311 665.567C173.238 665.592 171.409 666.347 170.433 668.757C170.335 669.001 170.457 669.244 170.677 669.342C170.75 669.366 170.799 669.366 170.872 669.366Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.335 668.952C167.53 668.952 167.701 668.83 167.774 668.636C168.506 666.298 170.555 665.202 170.579 665.178C170.799 665.056 170.897 664.788 170.775 664.569C170.653 664.35 170.384 664.253 170.165 664.374C170.067 664.423 167.75 665.641 166.921 668.368C166.847 668.611 166.969 668.855 167.213 668.928C167.238 668.952 167.286 668.952 167.335 668.952Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.286 668.465C163.481 668.465 163.652 668.343 163.725 668.149C164.579 665.714 166.53 664.374 166.554 664.374C166.774 664.228 166.823 663.96 166.676 663.741C166.53 663.522 166.262 663.473 166.042 663.619C165.945 663.668 163.798 665.129 162.847 667.856C162.774 668.1 162.896 668.343 163.139 668.441C163.188 668.441 163.237 668.465 163.286 668.465Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38 666.444C126.551 666.444 126.721 666.347 126.794 666.176C126.892 665.957 126.794 665.689 126.575 665.567C126.404 665.494 122.574 663.79 119.501 665.592C119.281 665.714 119.208 666.006 119.33 666.225C119.452 666.444 119.745 666.517 119.964 666.395C122.623 664.837 126.16 666.395 126.209 666.42C126.258 666.444 126.331 666.444 126.38 666.444Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.482 670.121H152.797C152.894 670.876 153.09 671.606 153.48 672.264H175.97C177.068 672.264 177.848 671.192 177.482 670.17C177.482 670.145 177.482 670.145 177.482 670.121Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.427 672.264H127.599C128.746 672.264 129.672 671.314 129.624 670.17V670.121H116.403C116.403 670.145 116.403 670.145 116.403 670.17C116.354 671.314 117.281 672.264 118.427 672.264Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.772 484.866C146.284 480.434 145.577 474.055 144.967 471.425C144.65 470.013 143.625 468.941 142.479 468.576C139.552 467.553 136.088 470.061 136.991 473.349C137.259 473.178 138.113 482.577 137.527 485.183C129.795 487.472 153.017 495.093 145.772 484.866Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.917 472.91C136.917 472.959 136.942 473.032 136.942 473.081C136.966 473.154 136.966 473.251 136.991 473.324C137.186 473.202 137.722 478.365 137.722 482.139C141.259 483.746 145.211 483.04 145.918 482.894C146.065 478.925 145.455 474.006 145.138 472.155C145.04 471.717 144.967 471.474 144.967 471.425C144.943 471.303 144.894 471.181 144.87 471.084C144.479 469.915 143.577 469.014 142.479 468.576C141.723 468.284 140.869 468.211 140.015 468.405C139.162 468.6 138.454 469.063 137.918 469.672C137.893 469.696 137.869 469.72 137.844 469.745C137.113 470.597 136.747 471.741 136.917 472.91Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.238 546.301C165.018 554.58 117.086 553.606 116.378 547.762L117.818 530.741C118.745 519.419 124.257 497.626 131.136 486.863C131.136 486.863 133.649 485.718 137.576 484.866C137.576 484.866 148.211 493.973 145.796 484.89C149.358 485.499 151.504 486.96 151.504 486.96C161.676 500.815 165.091 530.133 167.238 546.301Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.992 487.033C148.114 493.778 137.088 489.517 134.356 485.694C134.356 485.694 135.673 484.866 137.551 484.866C146.65 491.197 145.869 485.304 145.772 484.866C145.772 484.866 147.065 484.744 148.992 485.743C149.04 486.011 148.992 486.79 148.992 487.033Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.262 552.316C167.75 543.087 162.92 499.987 155.358 489.2C154.651 487.642 151.48 486.936 151.48 486.936C155.529 496.116 156.432 505.929 156.432 505.929C156.432 505.929 152.724 507.974 148.992 508.461C144.577 509.046 139.82 508.291 139.82 508.291C138.332 491.295 131.087 486.814 131.087 486.814C128.77 486.863 127.453 488.397 127.453 488.397C136.844 514.232 117.769 530.668 117.769 530.668C116.988 537.681 115.695 553.314 115.695 553.314C114.207 563.37 112.817 605.666 114.866 660.551C114.866 660.551 125.184 662.913 130.526 660.381C133.307 643.993 140.991 598.313 143.65 567.023C143.747 568.849 149.382 642.435 150.455 660.381C154.139 661.55 161.505 662.938 165.652 660.137C167.311 641.753 175.507 601.04 168.262 552.316Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.504 660.43C150.504 660.43 151.773 660.868 153.651 661.233H153.675C153.675 661.233 148.48 588.208 147.724 578.443C146.943 568.703 143.699 567.047 143.699 567.047C143.699 567.047 150.578 658.847 150.504 660.43Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.309 656.875C150.455 658.993 150.529 660.235 150.504 660.405C150.504 660.405 151.773 660.844 153.651 661.209C156.993 661.891 162.286 662.426 165.677 660.137C165.677 660.137 165.799 658.969 166.018 656.85C166.042 656.875 158.798 660.04 150.309 656.875Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.915 660.6C114.915 660.6 125.233 662.962 130.575 660.43C130.575 660.43 130.795 659.163 131.185 656.899C131.185 656.899 124.136 658.823 115.037 656.899C114.988 659.09 114.964 660.405 114.915 660.6Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.232 537.56C117.232 537.56 147.797 543.428 166.555 536.683C166.555 536.683 167.872 540.335 167.189 542.332C167.189 542.332 147.894 548.98 116.647 542.917C116.647 542.917 116.11 539.921 117.232 537.56Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.672 490.418C117.915 499.963 112.183 515.474 114.256 527.381C118.989 549.808 140.113 546.252 153.651 533.664C156.529 531.131 152.456 526.748 149.138 528.599C146.723 529.938 145.04 530.985 142.479 531.716C119.94 538.193 125.477 516.326 132.161 505.831L125.672 490.418Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.529 535.538C151.529 535.538 150.626 536.415 149.016 537.633C144.26 541.188 133.283 547.665 120.184 543.55C97.3765 536.391 108.426 495.653 127.502 488.421C127.502 488.421 132.453 494.923 133.454 502.301C134.258 508.291 132.575 513.891 130.234 518.104C123.013 531.107 137.649 530.668 144.552 529.841C146.552 529.597 147.894 529.329 147.894 529.329C147.894 533.664 151.529 535.538 151.529 535.538Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.041 545.79L177.409 545.084L187.752 500.621L161.383 501.302L151.041 545.79Z",
    fill: "#3A72AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.141 529.5C181.288 529.792 183.629 528.623 181.946 527.503C181.288 527.113 180.653 527.406 180.117 527.6H180.166C178.385 527.43 178.58 529.329 180.141 529.5Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.873 527.795C181.654 527.746 182.556 527.503 182.971 526.772C183.532 525.579 181.068 524.776 180.58 525.823C180.58 525.798 180.605 525.798 180.556 525.823C180.507 525.847 180.41 525.872 180.336 525.872C178.531 526.042 179.458 527.917 180.873 527.795Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.702 526.042L182.8 525.701C184.41 525.044 182.629 523.437 181.507 523.899L180.41 524.24C178.8 524.898 180.58 526.505 181.702 526.042Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.117 524.386L183.215 524.045C184.825 523.388 183.044 521.781 181.922 522.243L180.824 522.584C179.239 523.242 180.995 524.849 182.117 524.386Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.114 528.599C149.382 528.112 149.797 527.625 150.211 527.211C152.09 525.165 154.358 523.51 156.919 522.463C157.944 522.049 158.993 521.732 160.066 521.513C161.115 521.294 161.53 522.901 160.505 523.193C159.383 523.558 158.334 524.045 157.358 524.654C158.676 524.167 160.066 523.753 161.432 523.437C162.432 523.169 162.969 524.703 161.993 525.092C160.164 525.847 158.383 526.821 156.724 527.941C158.456 527.259 160.164 526.505 161.822 525.652C162.774 525.141 163.627 526.626 162.676 527.186C160.895 528.282 159.066 529.256 157.188 530.157C158.188 529.841 159.188 529.475 160.139 529.086C161.115 528.672 161.822 530.157 160.895 530.668C160.554 530.863 160.212 531.058 159.871 531.253C157.724 532.397 155.529 533.444 153.212 534.175C152.821 534.248 148.723 529.329 149.114 528.599Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.919 453.601C151.919 453.601 154.553 452.968 155.358 455.378C156.163 457.789 154.236 458.739 155.431 460.979C159.383 466.725 154.748 464.85 154.309 469.087C153.968 468.966 146.138 454.429 151.919 453.601Z",
    fill: "#8C4225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26 480.581C146.48 482.748 141.674 482.358 138.259 480.556C136.82 479.826 135.576 478.827 134.673 477.537C131.112 471.815 132.137 462.561 136.527 457.716C142.943 450.557 153.09 454.916 152.895 464.436C152.992 465.922 153.48 467.651 154.285 469.087C156.432 472.91 155.139 477.61 150.26 480.581Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26 475.15L145.138 471.352C143.845 474.079 146.479 476.879 149.26 475.15Z",
    fill: "#F9F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.431 467.626C147.943 467.091 147.089 466.287 146.577 466.847C146.065 467.383 146.918 468.186 147.431 467.626Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.309 468.138C152.822 467.602 151.968 466.798 151.456 467.358C150.943 467.919 151.821 468.698 152.309 468.138Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.187 475.345C149.406 475.443 149.601 475.126 149.406 474.98C149.26 474.98 145.113 470.694 144.967 471.206C144.894 471.303 144.894 471.425 144.991 471.522C145.064 471.571 149.065 475.321 149.187 475.345Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.236 460.589C148.699 462.537 145.479 457.18 144.406 461.247C143.991 462.951 141.04 461.612 140.455 462.294C139.869 463 139.869 464.631 138.893 465.459C137.918 466.287 134.064 466.604 134.064 466.604C133.917 470.305 132.576 473.154 135.308 478.292C135.088 478.048 134.893 477.805 134.698 477.537C131.136 471.815 132.161 462.562 136.552 457.716C140.869 452.237 150.724 453.235 152.236 460.589Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.967 472.399C149.992 472.789 152.065 472.594 150.967 471.254C150.065 470.402 149.919 468.016 149.919 467.992C149.894 467.699 149.455 467.748 149.48 468.016C149.48 468.113 149.65 470.597 150.675 471.571C150.797 471.693 150.919 471.839 150.821 471.936C150.602 472.228 149.504 472.302 148.845 471.863C148.284 471.717 148.553 472.375 148.967 472.399Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.772 459.274C151.772 459.274 154.163 457.57 152.724 455.427C151.285 453.284 152.065 450.898 149.358 450.557C146.626 450.24 145.577 450.289 142.942 448.731C140.308 447.172 137.161 449.242 136.771 451.044C136.381 452.87 132.575 451.799 131.331 454.088C130.087 456.352 130.453 457.253 130.16 458.3C129.868 459.347 126.16 459.81 126.111 462.488C126.062 465.167 128.282 465.386 128.233 467.091C128.185 468.819 126.184 471.23 127.794 472.642C130.185 474.761 133.039 473.641 133.039 473.641C130.941 461.588 137.625 468.625 138.698 462.391C138.795 459.883 142.064 461.588 143.211 460.589C146.65 454.94 145.869 460.76 151.772 459.274Z",
    fill: "#8C4225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.941 467.188C129.624 471.571 135.161 471.912 135.38 467.529C135.698 463.17 130.16 462.805 129.941 467.188Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.99 468.406C131.624 468.43 131.039 465.995 132.015 465.751C133.015 465.313 133.6 466.433 133.99 466.092C134.21 465.703 132.82 464.948 131.819 465.362C131.234 465.605 130.527 467.164 130.99 468.406Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.039 468.673C133.893 469.063 132.624 465.508 131.209 466.044C131.161 466.165 131.234 466.287 131.331 466.311C132.917 466.92 132.722 468.503 133.039 468.673Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.942 465.63C145.04 465.678 145.138 465.63 145.211 465.532C146.235 463.876 148.309 464.022 148.333 464.022C148.455 464.022 148.553 463.949 148.553 463.828C148.553 463.706 148.479 463.609 148.357 463.584C148.26 463.584 146.016 463.414 144.845 465.289C144.772 465.386 144.82 465.532 144.918 465.581C144.918 465.63 144.918 465.63 144.942 465.63Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.553 465.727C152.602 465.751 152.675 465.751 152.748 465.703C152.846 465.63 152.87 465.508 152.822 465.41C152.773 465.337 151.821 463.828 150.09 463.901C149.968 463.901 149.87 463.998 149.894 464.12C149.894 464.242 149.992 464.339 150.114 464.315C151.578 464.242 152.431 465.605 152.456 465.63C152.456 465.678 152.504 465.703 152.553 465.727Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.741 477.853C318.741 477.853 323.596 476.222 324.01 472.082L317.936 466.263C316.717 466.311 314.717 471.815 314.448 475.053C314.448 475.053 315.814 475.004 318.741 477.853Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.741 475.71L315.204 473.811L318.985 476.538L318.595 478.584L313.741 475.71Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.595 478.584C318.693 479.655 318.693 480.727 318.619 481.822C317.936 491.1 311.204 505.588 297.593 513.283C287.543 518.98 266.663 520.441 254.93 504.151C246.343 492.22 259.15 483.332 268.736 489.2C276.932 494.192 288.567 495.799 295.007 492.561C300.203 489.955 308.35 480.946 311.643 477.805C312.936 476.538 313.741 475.711 313.741 475.711C317.132 475.759 318.595 478.584 318.595 478.584Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.621 477.683C334.694 473.324 329.279 471.108 325.571 473.397L314.79 462.537C317.107 458.812 314.838 453.382 310.448 452.481C309.472 452.261 308.472 452.87 308.252 453.844C307.764 455.841 310.033 455.89 311.106 456.839C314.058 459.737 309.691 464.217 306.716 461.368C306.276 460.954 305.984 460.419 305.837 459.859C305.325 457.545 301.691 458.422 302.276 460.711C303.203 464.996 308.447 467.261 312.18 465.094L323.01 476.003C319.424 481.701 327.693 489.103 329.62 484.55C330.108 482.553 327.84 482.504 326.766 481.554C325.522 480.337 325.498 478.34 326.693 477.098C328.328 475.321 331.523 476.197 332.035 478.559C332.572 480.848 336.206 479.972 335.621 477.683Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.176 544.28C275.151 544.402 275.102 544.451 275.078 544.451C274.883 544.353 274.785 544.353 275.176 544.28Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.882 611.437C262.857 611.437 261.223 609.806 261.223 607.785V543.623C261.223 541.602 262.857 539.97 264.882 539.97C266.907 539.97 268.541 541.602 268.541 543.623V607.785C268.541 609.806 266.907 611.437 264.882 611.437Z",
    fill: "#3A72AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.733 670.778L242.392 670.584C242.392 670.827 242.099 671.679 241.831 671.679L231.464 671.898C231.22 671.898 231.073 671.436 231.073 671.192L230.195 670.949C230.195 669.39 230.317 668.83 231 667.637C231.878 666.079 232.244 664.204 232.098 662.353L230.61 645.406C230.586 645.138 230.781 644.919 231.049 644.919H241.684C241.953 644.919 242.148 645.138 242.123 645.406L240.757 662.499C240.611 664.301 240.953 666.103 241.806 667.613C241.806 667.613 241.806 667.613 241.806 667.637C242.514 668.855 242.733 669.244 242.733 670.778Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.104 672.264H268.443C267.492 672.264 266.76 671.484 266.809 670.535C266.833 670.072 266.882 669.536 267.004 668.928C267.297 667.199 267.419 665.47 267.394 663.717C267.37 662.889 267.321 662.037 267.248 661.209L265.76 646.721C265.662 645.747 266.419 644.919 267.394 644.919H276.517C277.517 644.919 278.273 645.795 278.152 646.769L276.493 659.967C276.127 662.865 278.005 665.543 280.835 666.249C282.859 666.761 284.908 667.053 286.372 667.418C286.567 667.467 286.738 667.515 286.933 667.564C288.494 668.002 289.763 668.587 290.519 669.683C291.202 670.803 290.421 672.264 289.104 672.264Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.199 670.121C266.248 670.462 266.297 670.778 266.394 671.095C266.59 671.777 267.224 672.264 267.931 672.264H289.373C290.47 672.264 291.251 671.192 290.885 670.17C290.885 670.145 290.885 670.145 290.86 670.121C290.031 667.783 287.08 664.301 276.957 663.741C276.81 663.741 276.639 663.741 276.493 663.79C275.737 663.985 272.907 664.52 268.639 663.936C267.882 663.839 267.151 664.277 266.907 665.007C266.468 666.249 265.955 668.246 266.199 670.121Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.83 672.264H240.977C242.124 672.264 243.05 671.314 243.002 670.17C243.002 670.145 243.002 670.145 243.002 670.121C242.88 667.613 241.831 663.766 236.391 663.717C230.952 663.668 229.878 667.564 229.781 670.121C229.781 670.145 229.781 670.145 229.781 670.17C229.756 671.314 230.683 672.264 231.83 672.264Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.25 669.366C284.421 669.366 284.591 669.269 284.665 669.074C285.494 667.053 286.982 666.42 287.031 666.395C287.275 666.298 287.372 666.03 287.275 665.811C287.177 665.567 286.909 665.47 286.689 665.567C286.616 665.592 284.787 666.347 283.811 668.757C283.713 669.001 283.835 669.244 284.055 669.342C284.128 669.366 284.201 669.366 284.25 669.366Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.713 668.952C280.908 668.952 281.079 668.83 281.152 668.636C281.883 666.298 283.932 665.202 283.957 665.178C284.176 665.056 284.274 664.788 284.152 664.569C284.03 664.35 283.762 664.253 283.542 664.374C283.445 664.423 281.127 665.641 280.298 668.368C280.225 668.611 280.347 668.855 280.591 668.928C280.615 668.952 280.664 668.952 280.713 668.952Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.688 668.465C276.883 668.465 277.054 668.343 277.127 668.149C277.981 665.714 279.932 664.374 279.957 664.374C280.176 664.228 280.225 663.96 280.079 663.741C279.932 663.522 279.664 663.473 279.445 663.619C279.347 663.668 277.2 665.129 276.249 667.856C276.176 668.1 276.298 668.343 276.542 668.441C276.591 668.441 276.639 668.465 276.688 668.465Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.782 666.444C239.952 666.444 240.123 666.347 240.196 666.176C240.294 665.957 240.196 665.689 239.977 665.567C239.806 665.494 235.976 663.79 232.903 665.592C232.683 665.714 232.61 666.006 232.732 666.225C232.854 666.444 233.147 666.517 233.366 666.395C236.025 664.837 239.562 666.395 239.611 666.42C239.635 666.444 239.708 666.444 239.782 666.444Z",
    fill: "#E8C0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86 670.121H266.199C266.297 670.876 266.492 671.606 266.882 672.264H289.372C290.47 672.264 291.251 671.192 290.885 670.17C290.86 670.145 290.86 670.145 290.86 670.121Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.83 672.264H240.977C242.124 672.264 243.05 671.314 243.002 670.17V670.121H229.781C229.781 670.145 229.781 670.145 229.781 670.17C229.756 671.314 230.683 672.264 231.83 672.264Z",
    fill: "#0F2E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.149 484.866C259.662 480.434 258.954 474.055 258.344 471.425C258.027 470.013 257.003 468.941 255.856 468.576C252.929 467.553 249.466 470.061 250.368 473.349C250.636 473.178 251.49 482.577 250.905 485.183C243.172 487.472 266.394 495.093 259.149 484.866Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.295 472.91C250.295 472.959 250.319 473.032 250.319 473.081C250.344 473.154 250.344 473.251 250.368 473.324C250.563 473.202 251.1 478.365 251.1 482.139C254.637 483.746 258.589 483.04 259.296 482.894C259.442 478.925 258.833 474.006 258.515 472.155C258.418 471.717 258.345 471.474 258.345 471.425C258.32 471.303 258.272 471.181 258.247 471.084C257.857 469.915 256.954 469.014 255.857 468.576C255.1 468.284 254.247 468.211 253.393 468.405C252.539 468.6 251.832 469.063 251.295 469.672C251.271 469.696 251.246 469.72 251.222 469.745C250.515 470.597 250.149 471.741 250.295 472.91Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.468 466.019C266.468 466.019 267.004 461.466 266.004 458.276L263.345 459.201L266.468 466.019Z",
    fill: "#163260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.102 478.73C261.76 481.408 257.028 481.725 253.442 480.507C252.32 480.142 251.271 479.606 250.368 478.876C250.051 478.632 249.783 478.365 249.515 478.097C245.197 473.081 244.807 463.925 248.344 458.568C250.832 454.404 256.759 452.408 260.93 455.135C263.858 457.107 264.687 460.638 265.638 463.949C265.955 464.875 266.614 466.092 267.321 466.944C269.956 470.353 269.395 475.102 265.102 478.73Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.418 466.579C260.589 466.311 260.515 465.97 260.272 465.8C260.003 465.63 259.662 465.703 259.491 465.946C259.32 466.214 259.393 466.555 259.637 466.725C259.881 466.896 260.247 466.823 260.418 466.579Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.248 466.336C265.419 466.068 265.346 465.727 265.102 465.557C264.833 465.386 264.492 465.459 264.321 465.703C264.15 465.971 264.224 466.311 264.467 466.482C264.711 466.677 265.077 466.604 265.248 466.336Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.199 471.035C263.857 471.035 264.516 470.816 264.736 470.451C264.809 470.305 264.955 469.94 264.394 469.55C263.394 468.844 262.882 466.555 262.882 466.531C262.857 466.409 262.735 466.336 262.638 466.36C262.516 466.384 262.443 466.506 262.467 466.604C262.491 466.701 263.028 469.087 264.15 469.891C264.272 469.988 264.419 470.11 264.345 470.232C264.175 470.548 263.126 470.767 262.418 470.451C262.321 470.402 262.174 470.451 262.126 470.548C262.077 470.646 262.126 470.792 262.223 470.84C262.54 470.987 262.857 471.035 263.199 471.035Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.687 460.76C260.808 460.492 257.686 459.104 257.686 459.104C256.442 460.248 254.905 460.492 253.783 459.932C253.783 459.932 253.491 464.388 248.417 467.139L247.514 471.352C247.514 471.352 247.953 476.1 250.368 478.876C250.051 478.632 249.783 478.365 249.514 478.097C248.588 477.147 247.88 475.954 247.344 474.59C247.173 474.176 247.026 473.738 246.904 473.3C246.709 472.642 246.539 471.936 246.392 471.181C246.343 470.962 246.319 470.767 246.27 470.548C246.246 470.354 246.197 470.159 246.173 469.964C246.148 469.672 246.099 469.379 246.051 469.063C246.051 469.014 246.051 468.99 246.051 468.941C246.026 468.649 246.002 468.357 245.978 468.065C245.953 467.748 245.953 467.432 245.953 467.139C245.929 463.876 246.807 460.857 248.344 458.544C249.027 457.497 249.856 456.596 250.783 455.865C250.832 455.817 250.88 455.792 250.929 455.743C252.222 454.769 253.734 454.136 255.344 453.966C256.052 453.893 256.71 453.869 257.345 453.917C258.272 453.99 259.101 454.185 259.881 454.526C259.906 454.55 259.955 454.55 259.979 454.575C260.321 454.721 260.638 454.916 260.93 455.11C261.394 455.427 261.808 455.768 262.199 456.182C262.638 456.644 263.028 457.18 263.394 457.765C263.979 458.787 264.687 460.76 264.687 460.76Z",
    fill: "#E57D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.953 455.67C249.295 452.188 253.027 452.675 256.856 449.802C261.857 446.077 262.979 452.87 265.76 455.597C269.37 459.153 267.467 460.175 264.369 459.859C261.028 459.518 257.417 458.276 257.417 458.276C257.417 458.276 256.247 459.907 253.076 459.104C253.076 459.104 252.051 463.292 247.709 466.019H244.197C244.197 466.019 241.66 457.984 248.953 455.67Z",
    fill: "#163260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.367 468.771C243.538 470.597 244.855 471.961 246.343 471.839C247.807 471.717 248.88 470.11 248.71 468.284C248.539 466.457 247.222 465.094 245.734 465.216C244.27 465.362 243.197 466.944 243.367 468.771Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.636 469.793C244.66 469.793 244.66 469.793 244.685 469.793C244.807 469.769 244.88 469.672 244.856 469.55C244.612 468.259 244.734 467.383 245.197 467.066C245.807 466.628 246.856 467.188 246.88 467.188C246.978 467.237 247.124 467.212 247.173 467.091C247.222 466.993 247.197 466.847 247.075 466.798C247.026 466.774 245.758 466.117 244.953 466.701C244.343 467.139 244.173 468.113 244.441 469.599C244.441 469.72 244.538 469.793 244.636 469.793Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.66 469.745C246.685 469.745 246.709 469.745 246.709 469.745C246.831 469.72 246.88 469.599 246.856 469.477C246.831 469.404 246.295 467.578 244.66 467.285C244.538 467.261 244.441 467.334 244.416 467.456C244.392 467.578 244.465 467.675 244.587 467.699C245.953 467.943 246.441 469.574 246.441 469.599C246.465 469.672 246.563 469.745 246.66 469.745Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.64 546.301C278.42 554.58 230.488 553.606 229.781 547.762L231.22 530.742C231.342 529.402 231.513 527.893 231.732 526.285C231.927 524.995 232.147 523.631 232.415 522.219C234.562 510.58 239.123 495.312 244.514 486.887C244.514 486.887 247.027 485.743 250.954 484.89C250.954 484.89 261.589 493.997 259.174 484.915C262.736 485.524 264.882 486.985 264.882 486.985C275.054 500.815 278.469 530.133 280.64 546.301Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.37 487.033C261.491 493.778 250.466 489.517 247.734 485.694C247.734 485.694 249.051 484.866 250.929 484.866C260.028 491.197 259.247 485.304 259.15 484.866C259.15 484.866 260.443 484.744 262.37 485.743C262.418 486.011 262.37 486.79 262.37 487.033Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.64 552.316C281.006 541.602 276.274 499.817 268.736 489.2C267.736 487.788 264.858 486.936 264.858 486.936C268.907 496.116 269.809 505.929 269.809 505.929C269.809 505.929 266.102 507.974 262.37 508.461C257.955 509.046 253.198 508.291 253.198 508.291C251.71 491.295 244.465 486.814 244.465 486.814C242.148 486.863 240.831 488.397 240.831 488.397C250.222 514.232 231.147 530.668 231.147 530.668C230.366 537.681 229.073 553.314 229.073 553.314C227.585 563.37 226.195 605.666 228.244 660.551C228.244 660.551 238.562 662.913 243.904 660.381C246.685 643.993 254.369 598.313 257.028 567.023C257.125 568.849 262.76 642.435 263.833 660.381C267.517 661.55 274.883 662.938 279.03 660.137C280.689 641.753 288.885 601.04 281.64 552.316Z",
    fill: "#1D3F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.882 660.43C263.882 660.43 265.15 660.868 267.028 661.233H267.053C267.053 661.233 261.857 588.207 261.101 578.443C260.32 568.703 257.076 567.047 257.076 567.047C257.076 567.047 263.979 658.847 263.882 660.43Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.687 656.875C263.833 658.993 263.906 660.235 263.882 660.405C263.882 660.405 265.15 660.844 267.028 661.209C270.37 661.891 275.663 662.426 279.054 660.137C279.054 660.137 279.176 658.969 279.396 656.85C279.42 656.875 272.2 660.04 263.687 656.875Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.317 660.6C228.317 660.6 238.635 662.962 243.977 660.43C243.977 660.43 244.197 659.163 244.587 656.899C244.587 656.899 237.537 658.823 228.439 656.899C228.366 659.09 228.341 660.405 228.317 660.6Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.61 537.559C230.61 537.559 261.174 543.428 279.932 536.683C279.932 536.683 281.249 540.335 280.566 542.332C280.566 542.332 261.272 548.98 230.024 542.916C230.024 542.916 229.488 539.921 230.61 537.559Z",
    fill: "#103663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.125 465.313C258.174 465.313 258.223 465.313 258.247 465.289C258.271 465.289 259.711 464.461 260.955 464.607C261.101 464.631 261.223 464.534 261.247 464.388C261.272 464.242 261.174 464.12 261.028 464.096C259.613 463.901 258.052 464.802 258.003 464.826C257.881 464.899 257.832 465.045 257.905 465.191C257.954 465.264 258.027 465.313 258.125 465.313Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.394 464.753C265.492 464.753 265.589 464.704 265.638 464.607C265.711 464.485 265.638 464.315 265.516 464.266C264.467 463.73 263.443 464.071 263.394 464.071C263.247 464.12 263.174 464.266 263.223 464.388C263.272 464.534 263.418 464.607 263.54 464.558C263.565 464.558 264.394 464.29 265.272 464.729C265.296 464.753 265.345 464.753 265.394 464.753Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.053 473.154C263.736 473.154 264.541 473.032 265.297 472.618C265.419 472.545 265.467 472.399 265.394 472.277C265.321 472.155 265.175 472.107 265.053 472.18C263.54 473.032 261.638 472.472 261.613 472.472C261.467 472.423 261.321 472.496 261.296 472.642C261.248 472.788 261.321 472.935 261.467 472.959C261.516 472.959 262.174 473.154 263.053 473.154Z",
    fill: "#C16256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.904 464.753C243.904 464.753 250.661 455.11 266.443 457.204C266.443 457.204 264.37 442.497 249.929 447.708C240.782 451.02 243.904 464.753 243.904 464.753Z",
    fill: "#EB5648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.636 460.346C248.636 460.346 252.271 457.424 255.808 456.352C259.345 455.256 265.809 454.672 268.419 456.23C271.053 457.789 266.443 457.204 266.443 457.204C266.443 457.204 256.93 455.622 248.636 460.346Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.271 446.831C255.271 446.831 261.955 448.244 264.443 455.33C264.443 455.33 257.906 455.841 257.735 455.89C257.564 455.938 256.393 449.559 250.929 447.416C250.954 447.391 253.003 445.979 255.271 446.831Z",
    fill: "#CE3932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.985 472.983C317.985 472.983 317.204 470.597 317.814 468.698C317.961 468.211 318.546 466.701 317.936 466.263C317.302 465.849 316.643 466.652 316.375 467.115C314.692 469.842 314.814 472.837 314.814 472.837C315.18 475.345 318.668 475.004 317.985 472.983Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62 472.594C323.693 472.496 323.717 472.496 323.766 472.448C323.79 472.399 323.839 472.375 323.864 472.326C323.912 472.253 323.961 472.155 324.01 472.082C324.108 471.912 324.181 471.741 324.23 471.547C324.278 471.352 324.327 471.157 324.327 470.987C324.327 470.792 324.303 470.621 324.254 470.451C324.132 469.94 323.571 469.72 323.01 469.915C322.62 470.061 322.327 470.402 322.254 470.743L322.132 471.279C322.132 471.279 322.132 471.279 322.132 471.303V471.327L322.156 471.279C321.717 471.741 321.693 472.399 322.107 472.764C322.522 473.129 323.181 473.056 323.62 472.594Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 471.133C322.888 471.06 322.888 471.035 322.913 470.962L322.961 470.84C323.01 470.767 323.035 470.67 323.059 470.597C323.108 470.427 323.157 470.256 323.181 470.061C323.205 469.866 323.205 469.672 323.181 469.477C323.157 469.282 323.083 469.063 322.986 468.892C322.718 468.405 322.059 468.308 321.522 468.649C320.986 468.99 320.742 469.647 321.01 470.134C320.986 470.11 321.01 470.086 321.01 470.159C321.01 470.183 320.986 470.232 320.986 470.256C320.986 470.28 320.961 470.305 320.961 470.329L320.937 470.353C320.62 470.889 320.766 471.522 321.278 471.741C321.839 471.936 322.498 471.693 322.84 471.133Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.839 469.38L321.985 468.284C322.059 467.675 321.644 467.212 321.058 467.237C320.473 467.261 319.912 467.748 319.839 468.357L319.692 469.453C319.619 470.061 320.034 470.524 320.619 470.5C321.205 470.5 321.741 469.988 321.839 469.38Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.547 468.138L320.693 467.042C320.766 466.433 320.351 465.97 319.766 465.995C319.181 466.019 318.62 466.506 318.546 467.115L318.4 468.211C318.327 468.819 318.741 469.282 319.327 469.258C319.912 469.233 320.449 468.746 320.547 468.138Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.026 560.229C248.221 561.422 245.88 559.353 244.587 559.474C245.441 561.496 246.88 563.297 246.88 563.322C248.953 565.099 251.1 566.755 253.32 568.338C254.905 572.088 246.709 565.976 245.685 565.489L245.66 565.513C247.392 567.778 249.246 569.969 251.271 571.966C252.002 576.154 244.611 567.534 243.733 566.755H243.709C244.977 569.166 246.514 571.43 248.295 573.476C248.66 577.761 241.83 568.435 241.221 567.413H241.196C241.391 569.214 244.611 573.037 243.758 574.206C241.879 575.278 235.708 562.908 235 558.598C234.635 557.039 238.562 554.945 240.074 555.384C241.489 555.773 243.196 556.82 243.831 557.161C245.294 557.746 248.953 558.476 249.026 560.229Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.293 527.235C232.561 537.219 236.171 548.079 241.294 556.65C242.245 557.965 241.928 559.864 240.538 560.765C236.098 563.784 226.951 548.931 225.121 545.449C208.9 513.209 236.464 513.429 234.293 527.235Z",
    fill: "#F99370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.879 488.446C240.879 488.446 226.195 493.462 220.828 508.51C215.462 523.558 218.657 547.421 234.415 558.354C234.415 558.354 236.269 554.824 239.928 554.41C239.928 554.41 233.561 539.921 235.854 528.039C237.562 519.078 249.319 511.359 240.879 488.446Z",
    fill: "#CE3932"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_250987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682,
    height: 770,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_48_250987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.4,
    fill: "white",
    transform: "translate(38 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_48_250987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38.4,
    fill: "white",
    transform: "translate(38 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_48_250987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 558,
    fill: "white",
    transform: "translate(-1 212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.ce2d21c4b907b1de9f9e1feab6e4b769.svg";
export { ForwardRef as ReactComponent };